//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import moment from 'moment';
import { BaseService } from './BaseService';

export module ClientPublicService {
  export class APIClient extends BaseService {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
      super();
      this.http = http ? http : (window as any);
      this.baseUrl = baseUrl ?? '';
    }

    /**
     * @return Success
     */
    padInfo(fileId: string): Promise<PublicPADInfoDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/{fileId}/pad-info';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPadInfo(_response));
        });
    }

    protected processPadInfo(response: Response): Promise<PublicPADInfoDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PublicPADInfoDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PublicPADInfoDto>(null as any);
    }

    /**
     * @param receiptDateFrom (optional)
     * @param receiptDateTo (optional)
     * @param isDeposited (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    padScheduleAll(
      fileId: string,
      receiptDateFrom: moment.Moment | undefined,
      receiptDateTo: moment.Moment | undefined,
      isDeposited: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PADScheduleDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/{fileId}/pad-schedule?';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      if (receiptDateFrom === null) throw new Error("The parameter 'receiptDateFrom' cannot be null.");
      else if (receiptDateFrom !== undefined)
        url_ +=
          'ReceiptDateFrom=' + encodeURIComponent(receiptDateFrom ? '' + receiptDateFrom.toISOString() : '') + '&';
      if (receiptDateTo === null) throw new Error("The parameter 'receiptDateTo' cannot be null.");
      else if (receiptDateTo !== undefined)
        url_ += 'ReceiptDateTo=' + encodeURIComponent(receiptDateTo ? '' + receiptDateTo.toISOString() : '') + '&';
      if (isDeposited === null) throw new Error("The parameter 'isDeposited' cannot be null.");
      else if (isDeposited !== undefined) url_ += 'IsDeposited=' + encodeURIComponent('' + isDeposited) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPadScheduleAll(_response));
        });
    }

    protected processPadScheduleAll(response: Response): Promise<PADScheduleDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PADScheduleDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PADScheduleDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    padSchedulePUT(fileId: string, body: PADScheduleUpdatePublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/{fileId}/pad-schedule';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPadSchedulePUT(_response));
        });
    }

    protected processPadSchedulePUT(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    padScheduleGET(id: string, fileId: string): Promise<PADScheduleDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/{fileId}/pad-schedule/{id}';
      if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace('{id}', encodeURIComponent('' + id));
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPadScheduleGET(_response));
        });
    }

    protected processPadScheduleGET(response: Response): Promise<PADScheduleDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PADScheduleDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PADScheduleDto>(null as any);
    }

    /**
     * @param receiptDateFrom (optional)
     * @param receiptDateTo (optional)
     * @param isDeposited (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    count(
      receiptDateFrom: moment.Moment | undefined,
      receiptDateTo: moment.Moment | undefined,
      isDeposited: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/pad-schedule/count?';
      if (receiptDateFrom === null) throw new Error("The parameter 'receiptDateFrom' cannot be null.");
      else if (receiptDateFrom !== undefined)
        url_ +=
          'ReceiptDateFrom=' + encodeURIComponent(receiptDateFrom ? '' + receiptDateFrom.toISOString() : '') + '&';
      if (receiptDateTo === null) throw new Error("The parameter 'receiptDateTo' cannot be null.");
      else if (receiptDateTo !== undefined)
        url_ += 'ReceiptDateTo=' + encodeURIComponent(receiptDateTo ? '' + receiptDateTo.toISOString() : '') + '&';
      if (isDeposited === null) throw new Error("The parameter 'isDeposited' cannot be null.");
      else if (isDeposited !== undefined) url_ += 'IsDeposited=' + encodeURIComponent('' + isDeposited) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCount(_response));
        });
    }

    protected processCount(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    padInfoChangeRequest(fileId: string, body: PADInfoChangeRequestCreatePublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/{fileId}/pad-info-change-request';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processPadInfoChangeRequest(_response)
          );
        });
    }

    protected processPadInfoChangeRequest(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    balanceInfo(): Promise<BalanceInfoDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/banking/balance-info';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBalanceInfo(_response));
        });
    }

    protected processBalanceInfo(response: Response): Promise<BalanceInfoDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = BalanceInfoDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<BalanceInfoDto>(null as any);
    }

    /**
     * @return Success
     */
    discharge(id: string): Promise<AdminInfoDischargeDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/discharge/{id}';
      if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace('{id}', encodeURIComponent('' + id));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDischarge(_response));
        });
    }

    protected processDischarge(response: Response): Promise<AdminInfoDischargeDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdminInfoDischargeDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AdminInfoDischargeDto>(null as any);
    }

    /**
     * @param dueDate (optional)
     * @param dueDateStart (optional)
     * @param dueDateEnd (optional)
     * @param statuses (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    schedulesAll(
      dueDate: moment.Moment | undefined,
      dueDateStart: moment.Moment | undefined,
      dueDateEnd: moment.Moment | undefined,
      statuses: IncomeExpensePeriodStatusEnum[] | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<IncomeExpenseSubmissionPeriodDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/income-expense/schedules?';
      if (dueDate === null) throw new Error("The parameter 'dueDate' cannot be null.");
      else if (dueDate !== undefined)
        url_ += 'DueDate=' + encodeURIComponent(dueDate ? '' + dueDate.toISOString() : '') + '&';
      if (dueDateStart === null) throw new Error("The parameter 'dueDateStart' cannot be null.");
      else if (dueDateStart !== undefined)
        url_ += 'DueDateStart=' + encodeURIComponent(dueDateStart ? '' + dueDateStart.toISOString() : '') + '&';
      if (dueDateEnd === null) throw new Error("The parameter 'dueDateEnd' cannot be null.");
      else if (dueDateEnd !== undefined)
        url_ += 'DueDateEnd=' + encodeURIComponent(dueDateEnd ? '' + dueDateEnd.toISOString() : '') + '&';
      if (statuses === null) throw new Error("The parameter 'statuses' cannot be null.");
      else if (statuses !== undefined)
        statuses &&
          statuses.forEach((item) => {
            url_ += 'Statuses=' + encodeURIComponent('' + item) + '&';
          });
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSchedulesAll(_response));
        });
    }

    protected processSchedulesAll(response: Response): Promise<IncomeExpenseSubmissionPeriodDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(IncomeExpenseSubmissionPeriodDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<IncomeExpenseSubmissionPeriodDto[]>(null as any);
    }

    /**
     * @return Success
     */
    schedules(periodId: string): Promise<IncomeExpenseSubmissionPeriodDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/income-expense/schedules/{periodId}';
      if (periodId === undefined || periodId === null) throw new Error("The parameter 'periodId' must be defined.");
      url_ = url_.replace('{periodId}', encodeURIComponent('' + periodId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSchedules(_response));
        });
    }

    protected processSchedules(response: Response): Promise<IncomeExpenseSubmissionPeriodDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IncomeExpenseSubmissionPeriodDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<IncomeExpenseSubmissionPeriodDto>(null as any);
    }

    /**
     * @return Success
     */
    activeSubmission(periodId: string): Promise<IncomeExpenseSubmissionPublicDto> {
      let url_ =
        this.baseUrl + '/api/client-service-public/admin-info/income-expense/schedules/{periodId}/active-submission';
      if (periodId === undefined || periodId === null) throw new Error("The parameter 'periodId' must be defined.");
      url_ = url_.replace('{periodId}', encodeURIComponent('' + periodId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processActiveSubmission(_response)
          );
        });
    }

    protected processActiveSubmission(response: Response): Promise<IncomeExpenseSubmissionPublicDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IncomeExpenseSubmissionPublicDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<IncomeExpenseSubmissionPublicDto>(null as any);
    }

    /**
     * @return Success
     */
    previousActiveSubmission(periodId: string): Promise<IncomeExpenseSubmissionPublicDto> {
      let url_ =
        this.baseUrl +
        '/api/client-service-public/admin-info/income-expense/schedules/{periodId}/previous-active-submission';
      if (periodId === undefined || periodId === null) throw new Error("The parameter 'periodId' must be defined.");
      url_ = url_.replace('{periodId}', encodeURIComponent('' + periodId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processPreviousActiveSubmission(_response)
          );
        });
    }

    protected processPreviousActiveSubmission(response: Response): Promise<IncomeExpenseSubmissionPublicDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IncomeExpenseSubmissionPublicDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<IncomeExpenseSubmissionPublicDto>(null as any);
    }

    /**
     * @return Success
     */
    periodStatus(): Promise<LookupReadOnlyDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/income-expense/lookup/period-status';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processPeriodStatus(_response));
        });
    }

    protected processPeriodStatus(response: Response): Promise<LookupReadOnlyDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupReadOnlyDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    save(body: IncomeExpenseSubmissionPublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/income-expense/submissions/save';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSave(_response));
        });
    }

    protected processSave(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    submit(body: IncomeExpenseSubmissionCreatePublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/income-expense/submissions/submit';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSubmit(_response));
        });
    }

    protected processSubmit(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    signUp(): Promise<AdminInfoSignupPublicDto> {
      let url_ = this.baseUrl + '/api/client-service-public/admin-info/sign-up';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSignUp(_response));
        });
    }

    protected processSignUp(response: Response): Promise<AdminInfoSignupPublicDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AdminInfoSignupPublicDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AdminInfoSignupPublicDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    listAppFormAssets(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetListItem[]> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/ListAppFormAssets?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppFormAssets(_response)
          );
        });
    }

    protected processListAppFormAssets(response: Response): Promise<AppFormAssetsDebtsAssetListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppFormAssetsDebtsAssetListItem.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormAssetsDebtsAssetListItem[]>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormAssetConfig(fileId: string | undefined): Promise<AppFormAssetsDebtsAssetConfig> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/GetAppFormAssetConfig?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormAssetConfig(_response)
          );
        });
    }

    protected processGetAppFormAssetConfig(response: Response): Promise<AppFormAssetsDebtsAssetConfig> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormAssetsDebtsAssetConfig.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormAssetsDebtsAssetConfig>(null as any);
    }

    /**
     * @param assetId (optional)
     * @return Success
     */
    getAppFormAsset(assetId: string | undefined): Promise<AppFormAssetsDebtsAssetDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/GetAppFormAsset?';
      if (assetId === null) throw new Error("The parameter 'assetId' cannot be null.");
      else if (assetId !== undefined) url_ += 'assetId=' + encodeURIComponent('' + assetId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetAppFormAsset(_response));
        });
    }

    protected processGetAppFormAsset(response: Response): Promise<AppFormAssetsDebtsAssetDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormAssetsDebtsAssetDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormAssetsDebtsAssetDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAppFormAsset(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/CreateAppFormAsset';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processCreateAppFormAsset(_response)
          );
        });
    }

    protected processCreateAppFormAsset(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormAsset(body: AppFormAssetsDebtsAssetDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/UpdateAppFormAsset';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormAsset(_response)
          );
        });
    }

    protected processUpdateAppFormAsset(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param assetId (optional)
     * @return Success
     */
    deleteAppFormAsset(assetId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/DeleteAppFormAsset?';
      if (assetId === null) throw new Error("The parameter 'assetId' cannot be null.");
      else if (assetId !== undefined) url_ += 'assetId=' + encodeURIComponent('' + assetId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processDeleteAppFormAsset(_response)
          );
        });
    }

    protected processDeleteAppFormAsset(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    listAppFormDebts(fileId: string | undefined): Promise<AppFormAssetsDebtsDebtListItem[]> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/ListAppFormDebts?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppFormDebts(_response)
          );
        });
    }

    protected processListAppFormDebts(response: Response): Promise<AppFormAssetsDebtsDebtListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppFormAssetsDebtsDebtListItem.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormAssetsDebtsDebtListItem[]>(null as any);
    }

    /**
     * @param debtId (optional)
     * @return Success
     */
    getAppFormDebt(debtId: string | undefined): Promise<AppFormAssetsDebtsDebtDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/GetAppFormDebt?';
      if (debtId === null) throw new Error("The parameter 'debtId' cannot be null.");
      else if (debtId !== undefined) url_ += 'debtId=' + encodeURIComponent('' + debtId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetAppFormDebt(_response));
        });
    }

    protected processGetAppFormDebt(response: Response): Promise<AppFormAssetsDebtsDebtDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormAssetsDebtsDebtDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormAssetsDebtsDebtDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAppFormDebt(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/CreateAppFormDebt';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processCreateAppFormDebt(_response)
          );
        });
    }

    protected processCreateAppFormDebt(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormDebt(body: AppFormAssetsDebtsDebtDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/UpdateAppFormDebt';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormDebt(_response)
          );
        });
    }

    protected processUpdateAppFormDebt(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param debtId (optional)
     * @return Success
     */
    deleteAppFormDebt(debtId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/DeleteAppFormDebt?';
      if (debtId === null) throw new Error("The parameter 'debtId' cannot be null.");
      else if (debtId !== undefined) url_ += 'debtId=' + encodeURIComponent('' + debtId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processDeleteAppFormDebt(_response)
          );
        });
    }

    protected processDeleteAppFormDebt(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAssetsDebtsStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/GetAssetsDebtsStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAssetsDebtsStatus(_response)
          );
        });
    }

    protected processGetAssetsDebtsStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    assetsDebtsMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormAssetsDebts/AssetsDebtsMarkAsComplete?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processAssetsDebtsMarkAsComplete(_response)
          );
        });
    }

    protected processAssetsDebtsMarkAsComplete(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormBankingInfo(fileId: string | undefined): Promise<AppFormBankingInfoDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormBankingInfo/GetAppFormBankingInfo?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormBankingInfo(_response)
          );
        });
    }

    protected processGetAppFormBankingInfo(response: Response): Promise<AppFormBankingInfoDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormBankingInfoDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormBankingInfoDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormBankingInfo(body: AppFormBankingInfoDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormBankingInfo/UpdateAppFormBankingInfo';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormBankingInfo(_response)
          );
        });
    }

    protected processUpdateAppFormBankingInfo(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getBankingInfoStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormBankingInfo/GetBankingInfoStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetBankingInfoStatus(_response)
          );
        });
    }

    protected processGetBankingInfoStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    bankingInfoMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormBankingInfo/BankingInfoMarkAsComplete?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processBankingInfoMarkAsComplete(_response)
          );
        });
    }

    protected processBankingInfoMarkAsComplete(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    listAppFormIncomeDetails(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/ListAppFormIncomeDetails?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppFormIncomeDetails(_response)
          );
        });
    }

    protected processListAppFormIncomeDetails(response: Response): Promise<AppFormIncomeExpenseIncomeDetailListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppFormIncomeExpenseIncomeDetailListItem.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormIncomeExpenseIncomeDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormIncome(fileId: string | undefined): Promise<AppFormIncomeExpenseIncomeDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/GetAppFormIncome?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormIncome(_response)
          );
        });
    }

    protected processGetAppFormIncome(response: Response): Promise<AppFormIncomeExpenseIncomeDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormIncomeExpenseIncomeDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormIncomeExpenseIncomeDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormIncome(body: AppFormIncomeExpenseIncomeDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/UpdateAppFormIncome';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormIncome(_response)
          );
        });
    }

    protected processUpdateAppFormIncome(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param incomeId (optional)
     * @return Success
     */
    deleteAppFormIncome(incomeId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/DeleteAppFormIncome?';
      if (incomeId === null) throw new Error("The parameter 'incomeId' cannot be null.");
      else if (incomeId !== undefined) url_ += 'incomeId=' + encodeURIComponent('' + incomeId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processDeleteAppFormIncome(_response)
          );
        });
    }

    protected processDeleteAppFormIncome(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    listAppFormExpenseDetails(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/ListAppFormExpenseDetails?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppFormExpenseDetails(_response)
          );
        });
    }

    protected processListAppFormExpenseDetails(
      response: Response
    ): Promise<AppFormIncomeExpenseExpenseDetailListItem[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppFormIncomeExpenseExpenseDetailListItem.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormIncomeExpenseExpenseDetailListItem[]>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormExpense(fileId: string | undefined): Promise<AppFormIncomeExpenseExpenseDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/GetAppFormExpense?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormExpense(_response)
          );
        });
    }

    protected processGetAppFormExpense(response: Response): Promise<AppFormIncomeExpenseExpenseDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormIncomeExpenseExpenseDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormIncomeExpenseExpenseDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormExpense(body: AppFormIncomeExpenseExpenseDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/UpdateAppFormExpense';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormExpense(_response)
          );
        });
    }

    protected processUpdateAppFormExpense(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param expenseId (optional)
     * @return Success
     */
    deleteAppFormExpense(expenseId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/DeleteAppFormExpense?';
      if (expenseId === null) throw new Error("The parameter 'expenseId' cannot be null.");
      else if (expenseId !== undefined) url_ += 'expenseId=' + encodeURIComponent('' + expenseId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processDeleteAppFormExpense(_response)
          );
        });
    }

    protected processDeleteAppFormExpense(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getIncomeExpenseStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeExpense/GetIncomeExpenseStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetIncomeExpenseStatus(_response)
          );
        });
    }

    protected processGetIncomeExpenseStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormIncomeTax(fileId: string | undefined): Promise<AppFormIncomeTaxDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeTax/GetAppFormIncomeTax?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormIncomeTax(_response)
          );
        });
    }

    protected processGetAppFormIncomeTax(response: Response): Promise<AppFormIncomeTaxDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormIncomeTaxDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormIncomeTaxDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormIncomeTax(body: AppFormIncomeTaxDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeTax/UpdateAppFormIncomeTax';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormIncomeTax(_response)
          );
        });
    }

    protected processUpdateAppFormIncomeTax(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getIncomeTaxStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormIncomeTax/GetIncomeTaxStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetIncomeTaxStatus(_response)
          );
        });
    }

    protected processGetIncomeTaxStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormPersonalInfo(fileId: string | undefined): Promise<AppFormPersonalInfoDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormPersonalInfo/GetAppFormPersonalInfo?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormPersonalInfo(_response)
          );
        });
    }

    protected processGetAppFormPersonalInfo(response: Response): Promise<AppFormPersonalInfoDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormPersonalInfoDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormPersonalInfoDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormPersonalInfo(body: AppFormPersonalInfoDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormPersonalInfo/UpdateAppFormPersonalInfo';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormPersonalInfo(_response)
          );
        });
    }

    protected processUpdateAppFormPersonalInfo(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getPersonalInfoStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormPersonalInfo/GetPersonalInfoStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetPersonalInfoStatus(_response)
          );
        });
    }

    protected processGetPersonalInfoStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    personalInfoMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormPersonalInfo/PersonalInfoMarkAsComplete?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processPersonalInfoMarkAsComplete(_response)
          );
        });
    }

    protected processPersonalInfoMarkAsComplete(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormStatus(fileId: string | undefined): Promise<AppFormStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormPersonalInfo/GetAppFormStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormStatus(_response)
          );
        });
    }

    protected processGetAppFormStatus(response: Response): Promise<AppFormStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getAppFormQuestionnaire(fileId: string | undefined): Promise<AppFormQuestionnaireDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormQuestionnaire/GetAppFormQuestionnaire?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppFormQuestionnaire(_response)
          );
        });
    }

    protected processGetAppFormQuestionnaire(response: Response): Promise<AppFormQuestionnaireDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormQuestionnaireDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormQuestionnaireDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppFormQuestionnaire(body: AppFormQuestionnaireDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormQuestionnaire/UpdateAppFormQuestionnaire';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppFormQuestionnaire(_response)
          );
        });
    }

    protected processUpdateAppFormQuestionnaire(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    getQuestionnaireStatus(fileId: string | undefined): Promise<AppFormSectionStatusDto> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormQuestionnaire/GetQuestionnaireStatus?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetQuestionnaireStatus(_response)
          );
        });
    }

    protected processGetQuestionnaireStatus(response: Response): Promise<AppFormSectionStatusDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppFormSectionStatusDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppFormSectionStatusDto>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    questionnaireMarkAsComplete(fileId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/AppFormQuestionnaire/QuestionnaireMarkAsComplete?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processQuestionnaireMarkAsComplete(_response)
          );
        });
    }

    protected processQuestionnaireMarkAsComplete(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    applicationFile(): Promise<ApplicationFileDto> {
      let url_ = this.baseUrl + '/api/client-service-public/application-file';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processApplicationFile(_response));
        });
    }

    protected processApplicationFile(response: Response): Promise<ApplicationFileDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationFileDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<ApplicationFileDto>(null as any);
    }

    /**
     * @param officeLocationId (optional)
     * @param isPreferedLanguageEnglish (optional)
     * @param meetingTypeEnum (optional)
     * @return Success
     */
    getInitialAppointmentTimeSlots(
      officeLocationId: string | undefined,
      isPreferedLanguageEnglish: boolean | undefined,
      meetingTypeEnum: MeetingTypeEnum | undefined
    ): Promise<AvailableTimeSlotsDto> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/GetInitialAppointmentTimeSlots?';
      if (officeLocationId === null) throw new Error("The parameter 'officeLocationId' cannot be null.");
      else if (officeLocationId !== undefined)
        url_ += 'officeLocationId=' + encodeURIComponent('' + officeLocationId) + '&';
      if (isPreferedLanguageEnglish === null)
        throw new Error("The parameter 'isPreferedLanguageEnglish' cannot be null.");
      else if (isPreferedLanguageEnglish !== undefined)
        url_ += 'isPreferedLanguageEnglish=' + encodeURIComponent('' + isPreferedLanguageEnglish) + '&';
      if (meetingTypeEnum === null) throw new Error("The parameter 'meetingTypeEnum' cannot be null.");
      else if (meetingTypeEnum !== undefined)
        url_ += 'meetingTypeEnum=' + encodeURIComponent('' + meetingTypeEnum) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetInitialAppointmentTimeSlots(_response)
          );
        });
    }

    protected processGetInitialAppointmentTimeSlots(response: Response): Promise<AvailableTimeSlotsDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AvailableTimeSlotsDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AvailableTimeSlotsDto>(null as any);
    }

    /**
     * @param date (optional)
     * @param officeLocationId (optional)
     * @param isPreferedLanguageEnglish (optional)
     * @param meetingTypeEnum (optional)
     * @return Success
     */
    getAvailableTimeSlots(
      date: moment.Moment | undefined,
      officeLocationId: string | undefined,
      isPreferedLanguageEnglish: boolean | undefined,
      meetingTypeEnum: MeetingTypeEnum | undefined
    ): Promise<AvailableTimeSlotsDto> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/GetAvailableTimeSlots?';
      if (date === null) throw new Error("The parameter 'date' cannot be null.");
      else if (date !== undefined) url_ += 'date=' + encodeURIComponent(date ? '' + date.toISOString() : '') + '&';
      if (officeLocationId === null) throw new Error("The parameter 'officeLocationId' cannot be null.");
      else if (officeLocationId !== undefined)
        url_ += 'officeLocationId=' + encodeURIComponent('' + officeLocationId) + '&';
      if (isPreferedLanguageEnglish === null)
        throw new Error("The parameter 'isPreferedLanguageEnglish' cannot be null.");
      else if (isPreferedLanguageEnglish !== undefined)
        url_ += 'isPreferedLanguageEnglish=' + encodeURIComponent('' + isPreferedLanguageEnglish) + '&';
      if (meetingTypeEnum === null) throw new Error("The parameter 'meetingTypeEnum' cannot be null.");
      else if (meetingTypeEnum !== undefined)
        url_ += 'meetingTypeEnum=' + encodeURIComponent('' + meetingTypeEnum) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAvailableTimeSlots(_response)
          );
        });
    }

    protected processGetAvailableTimeSlots(response: Response): Promise<AvailableTimeSlotsDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AvailableTimeSlotsDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AvailableTimeSlotsDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateAppointment(body: UpdateAppointmentPublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/UpdateAppointment';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateAppointment(_response)
          );
        });
    }

    protected processUpdateAppointment(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appointmentId (optional)
     * @return Success
     */
    cancelAppointment(appointmentId: string | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/CancelAppointment?';
      if (appointmentId === null) throw new Error("The parameter 'appointmentId' cannot be null.");
      else if (appointmentId !== undefined) url_ += 'appointmentId=' + encodeURIComponent('' + appointmentId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processCancelAppointment(_response)
          );
        });
    }

    protected processCancelAppointment(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appointmentId (optional)
     * @return Success
     */
    getAppointmentInfo(appointmentId: string | undefined): Promise<AppointmentInfoDto> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/GetAppointmentInfo?';
      if (appointmentId === null) throw new Error("The parameter 'appointmentId' cannot be null.");
      else if (appointmentId !== undefined) url_ += 'appointmentId=' + encodeURIComponent('' + appointmentId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppointmentInfo(_response)
          );
        });
    }

    protected processGetAppointmentInfo(response: Response): Promise<AppointmentInfoDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppointmentInfoDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<AppointmentInfoDto>(null as any);
    }

    /**
     * @param isAllAppointments (optional)
     * @param appointmentStatusEnums (optional)
     * @param appointmentTypeEnums (optional)
     * @param startDateTimeBefore (optional)
     * @param startDateTimeAfter (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAppointmentInfoList(
      isAllAppointments: boolean | undefined,
      appointmentStatusEnums: AppointmentStatusEnum[] | undefined,
      appointmentTypeEnums: AppointmentTypeEnum[] | undefined,
      startDateTimeBefore: moment.Moment | undefined,
      startDateTimeAfter: moment.Moment | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/GetAppointmentInfoList?';
      if (isAllAppointments === null) throw new Error("The parameter 'isAllAppointments' cannot be null.");
      else if (isAllAppointments !== undefined)
        url_ += 'IsAllAppointments=' + encodeURIComponent('' + isAllAppointments) + '&';
      if (appointmentStatusEnums === null) throw new Error("The parameter 'appointmentStatusEnums' cannot be null.");
      else if (appointmentStatusEnums !== undefined)
        appointmentStatusEnums &&
          appointmentStatusEnums.forEach((item) => {
            url_ += 'AppointmentStatusEnums=' + encodeURIComponent('' + item) + '&';
          });
      if (appointmentTypeEnums === null) throw new Error("The parameter 'appointmentTypeEnums' cannot be null.");
      else if (appointmentTypeEnums !== undefined)
        appointmentTypeEnums &&
          appointmentTypeEnums.forEach((item) => {
            url_ += 'AppointmentTypeEnums=' + encodeURIComponent('' + item) + '&';
          });
      if (startDateTimeBefore === null) throw new Error("The parameter 'startDateTimeBefore' cannot be null.");
      else if (startDateTimeBefore !== undefined)
        url_ +=
          'StartDateTimeBefore=' +
          encodeURIComponent(startDateTimeBefore ? '' + startDateTimeBefore.toISOString() : '') +
          '&';
      if (startDateTimeAfter === null) throw new Error("The parameter 'startDateTimeAfter' cannot be null.");
      else if (startDateTimeAfter !== undefined)
        url_ +=
          'StartDateTimeAfter=' +
          encodeURIComponent(startDateTimeAfter ? '' + startDateTimeAfter.toISOString() : '') +
          '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAppointmentInfoList(_response)
          );
        });
    }

    protected processGetAppointmentInfoList(
      response: Response
    ): Promise<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
        null as any
      );
    }

    /**
     * @param body (optional)
     * @return Success
     */
    reserveAppointment(body: ReserveAppointmentDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/ReserveAppointment';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processReserveAppointment(_response)
          );
        });
    }

    protected processReserveAppointment(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    createAppointmentAndFile(body: BookInitialAppointmenInputPublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/CreateAppointmentAndFile';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processCreateAppointmentAndFile(_response)
          );
        });
    }

    protected processCreateAppointmentAndFile(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    bookAppointment(body: BookAppointmentInputPublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/BookAppointment';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processBookAppointment(_response));
        });
    }

    protected processBookAppointment(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param agentId (optional)
     * @param dateTime (optional)
     * @param officeLocationId (optional)
     * @return Success
     */
    unreserveAppointment(
      agentId: string | undefined,
      dateTime: moment.Moment | undefined,
      officeLocationId: string | undefined
    ): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/Appointment/UnreserveAppointment?';
      if (agentId === null) throw new Error("The parameter 'agentId' cannot be null.");
      else if (agentId !== undefined) url_ += 'AgentId=' + encodeURIComponent('' + agentId) + '&';
      if (dateTime === null) throw new Error("The parameter 'dateTime' cannot be null.");
      else if (dateTime !== undefined)
        url_ += 'DateTime=' + encodeURIComponent(dateTime ? '' + dateTime.toISOString() : '') + '&';
      if (officeLocationId === null) throw new Error("The parameter 'officeLocationId' cannot be null.");
      else if (officeLocationId !== undefined)
        url_ += 'OfficeLocationId=' + encodeURIComponent('' + officeLocationId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUnreserveAppointment(_response)
          );
        });
    }

    protected processUnreserveAppointment(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param filterText (optional)
     * @param filterSubjectText (optional)
     * @param filterEmailSenderEmailAddressText (optional)
     * @param fileId (optional)
     * @param description (optional)
     * @param followUpDateMin (optional)
     * @param followUpDateMax (optional)
     * @param openDateMin (optional)
     * @param openDateMax (optional)
     * @param closeDateMin (optional)
     * @param closeDateMax (optional)
     * @param assignedAgentId (optional)
     * @param assignedTeamId (optional)
     * @param appTaskId (optional)
     * @param appTaskActionIds (optional)
     * @param appTaskActionId (optional)
     * @param appTaskActionNameId (optional)
     * @param appTaskActionStatusId (optional)
     * @param appTaskActionStatus (optional)
     * @param teamTypes (optional)
     * @param appTaskActionNames (optional)
     * @param calledFromDashboard (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    count2(
      filterText: string | undefined,
      filterSubjectText: string | undefined,
      filterEmailSenderEmailAddressText: string | undefined,
      fileId: string | undefined,
      description: string | undefined,
      followUpDateMin: moment.Moment | undefined,
      followUpDateMax: moment.Moment | undefined,
      openDateMin: moment.Moment | undefined,
      openDateMax: moment.Moment | undefined,
      closeDateMin: moment.Moment | undefined,
      closeDateMax: moment.Moment | undefined,
      assignedAgentId: string | undefined,
      assignedTeamId: string | undefined,
      appTaskId: string | undefined,
      appTaskActionIds: string[] | undefined,
      appTaskActionId: string | undefined,
      appTaskActionNameId: string | undefined,
      appTaskActionStatusId: string | undefined,
      appTaskActionStatus: AppTaskActionStatusEnum | undefined,
      teamTypes: TeamTypeEnum[] | undefined,
      appTaskActionNames: AppTaskActionNameEnum[] | undefined,
      calledFromDashboard: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + '/api/client-service-public/task-actions/count?';
      if (filterText === null) throw new Error("The parameter 'filterText' cannot be null.");
      else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
      if (filterSubjectText === null) throw new Error("The parameter 'filterSubjectText' cannot be null.");
      else if (filterSubjectText !== undefined)
        url_ += 'FilterSubjectText=' + encodeURIComponent('' + filterSubjectText) + '&';
      if (filterEmailSenderEmailAddressText === null)
        throw new Error("The parameter 'filterEmailSenderEmailAddressText' cannot be null.");
      else if (filterEmailSenderEmailAddressText !== undefined)
        url_ += 'FilterEmailSenderEmailAddressText=' + encodeURIComponent('' + filterEmailSenderEmailAddressText) + '&';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'FileId=' + encodeURIComponent('' + fileId) + '&';
      if (description === null) throw new Error("The parameter 'description' cannot be null.");
      else if (description !== undefined) url_ += 'Description=' + encodeURIComponent('' + description) + '&';
      if (followUpDateMin === null) throw new Error("The parameter 'followUpDateMin' cannot be null.");
      else if (followUpDateMin !== undefined)
        url_ +=
          'FollowUpDateMin=' + encodeURIComponent(followUpDateMin ? '' + followUpDateMin.toISOString() : '') + '&';
      if (followUpDateMax === null) throw new Error("The parameter 'followUpDateMax' cannot be null.");
      else if (followUpDateMax !== undefined)
        url_ +=
          'FollowUpDateMax=' + encodeURIComponent(followUpDateMax ? '' + followUpDateMax.toISOString() : '') + '&';
      if (openDateMin === null) throw new Error("The parameter 'openDateMin' cannot be null.");
      else if (openDateMin !== undefined)
        url_ += 'OpenDateMin=' + encodeURIComponent(openDateMin ? '' + openDateMin.toISOString() : '') + '&';
      if (openDateMax === null) throw new Error("The parameter 'openDateMax' cannot be null.");
      else if (openDateMax !== undefined)
        url_ += 'OpenDateMax=' + encodeURIComponent(openDateMax ? '' + openDateMax.toISOString() : '') + '&';
      if (closeDateMin === null) throw new Error("The parameter 'closeDateMin' cannot be null.");
      else if (closeDateMin !== undefined)
        url_ += 'CloseDateMin=' + encodeURIComponent(closeDateMin ? '' + closeDateMin.toISOString() : '') + '&';
      if (closeDateMax === null) throw new Error("The parameter 'closeDateMax' cannot be null.");
      else if (closeDateMax !== undefined)
        url_ += 'CloseDateMax=' + encodeURIComponent(closeDateMax ? '' + closeDateMax.toISOString() : '') + '&';
      if (assignedAgentId === null) throw new Error("The parameter 'assignedAgentId' cannot be null.");
      else if (assignedAgentId !== undefined)
        url_ += 'AssignedAgentId=' + encodeURIComponent('' + assignedAgentId) + '&';
      if (assignedTeamId === null) throw new Error("The parameter 'assignedTeamId' cannot be null.");
      else if (assignedTeamId !== undefined) url_ += 'AssignedTeamId=' + encodeURIComponent('' + assignedTeamId) + '&';
      if (appTaskId === null) throw new Error("The parameter 'appTaskId' cannot be null.");
      else if (appTaskId !== undefined) url_ += 'AppTaskId=' + encodeURIComponent('' + appTaskId) + '&';
      if (appTaskActionIds === null) throw new Error("The parameter 'appTaskActionIds' cannot be null.");
      else if (appTaskActionIds !== undefined)
        appTaskActionIds &&
          appTaskActionIds.forEach((item) => {
            url_ += 'AppTaskActionIds=' + encodeURIComponent('' + item) + '&';
          });
      if (appTaskActionId === null) throw new Error("The parameter 'appTaskActionId' cannot be null.");
      else if (appTaskActionId !== undefined)
        url_ += 'AppTaskActionId=' + encodeURIComponent('' + appTaskActionId) + '&';
      if (appTaskActionNameId === null) throw new Error("The parameter 'appTaskActionNameId' cannot be null.");
      else if (appTaskActionNameId !== undefined)
        url_ += 'AppTaskActionNameId=' + encodeURIComponent('' + appTaskActionNameId) + '&';
      if (appTaskActionStatusId === null) throw new Error("The parameter 'appTaskActionStatusId' cannot be null.");
      else if (appTaskActionStatusId !== undefined)
        url_ += 'AppTaskActionStatusId=' + encodeURIComponent('' + appTaskActionStatusId) + '&';
      if (appTaskActionStatus === null) throw new Error("The parameter 'appTaskActionStatus' cannot be null.");
      else if (appTaskActionStatus !== undefined)
        url_ += 'AppTaskActionStatus=' + encodeURIComponent('' + appTaskActionStatus) + '&';
      if (teamTypes === null) throw new Error("The parameter 'teamTypes' cannot be null.");
      else if (teamTypes !== undefined)
        teamTypes &&
          teamTypes.forEach((item) => {
            url_ += 'TeamTypes=' + encodeURIComponent('' + item) + '&';
          });
      if (appTaskActionNames === null) throw new Error("The parameter 'appTaskActionNames' cannot be null.");
      else if (appTaskActionNames !== undefined)
        appTaskActionNames &&
          appTaskActionNames.forEach((item) => {
            url_ += 'AppTaskActionNames=' + encodeURIComponent('' + item) + '&';
          });
      if (calledFromDashboard === null) throw new Error("The parameter 'calledFromDashboard' cannot be null.");
      else if (calledFromDashboard !== undefined)
        url_ += 'CalledFromDashboard=' + encodeURIComponent('' + calledFromDashboard) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCount2(_response));
        });
    }

    protected processCount2(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<number>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    taskAndAction(body: AppTaskAndTaskActionCreateDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/task-actions/task-and-action';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processTaskAndAction(_response));
        });
    }

    protected processTaskAndAction(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    followUpRequest(): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/task-actions/follow-up-request';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFollowUpRequest(_response));
        });
    }

    protected processFollowUpRequest(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param appTaskNames (optional)
     * @param appTaskStatuses (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    countTasks(
      appTaskNames: AppTaskNameEnum[] | undefined,
      appTaskStatuses: AppTaskStatusEnum[] | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + '/api/client-service-public/tasks/count-tasks?';
      if (appTaskNames === null) throw new Error("The parameter 'appTaskNames' cannot be null.");
      else if (appTaskNames !== undefined)
        appTaskNames &&
          appTaskNames.forEach((item) => {
            url_ += 'AppTaskNames=' + encodeURIComponent('' + item) + '&';
          });
      if (appTaskStatuses === null) throw new Error("The parameter 'appTaskStatuses' cannot be null.");
      else if (appTaskStatuses !== undefined)
        appTaskStatuses &&
          appTaskStatuses.forEach((item) => {
            url_ += 'AppTaskStatuses=' + encodeURIComponent('' + item) + '&';
          });
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCountTasks(_response));
        });
    }

    protected processCountTasks(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<number>(null as any);
    }

    /**
     * @return Success
     */
    counsellingFollowUp(): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/tasks/counselling-follow-up';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processCounsellingFollowUp(_response)
          );
        });
    }

    protected processCounsellingFollowUp(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    getDebtorProfile(): Promise<DebtorProfilePageDto> {
      let url_ = this.baseUrl + '/api/client-service-public/ClientInfo/GetDebtorProfile';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetDebtorProfile(_response)
          );
        });
    }

    protected processGetDebtorProfile(response: Response): Promise<DebtorProfilePageDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = DebtorProfilePageDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<DebtorProfilePageDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDebtorProfile(fileId: string, body: DebtorProfileUpdatePublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/ClientInfo/UpdateDebtorProfile/{fileId}';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateDebtorProfile(_response)
          );
        });
    }

    protected processUpdateDebtorProfile(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    settings(fileId: string, body: DebtorSettingsPublicUpdateDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/ClientInfo/UpdateDebtorSettings/settings/{fileId}';
      if (fileId === undefined || fileId === null) throw new Error("The parameter 'fileId' must be defined.");
      url_ = url_.replace('{fileId}', encodeURIComponent('' + fileId));
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSettings(_response));
        });
    }

    protected processSettings(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDebtorPassword(body: DebtorPasswordUpdatePublicDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/ClientInfo/UpdateDebtorPassword';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateDebtorPassword(_response)
          );
        });
    }

    protected processUpdateDebtorPassword(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    getGoogleApiKey(): Promise<GoogleApiKeyDto> {
      let url_ = this.baseUrl + '/api/client-service-public/config/GetGoogleApiKey';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetGoogleApiKey(_response));
        });
    }

    protected processGetGoogleApiKey(response: Response): Promise<GoogleApiKeyDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GoogleApiKeyDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<GoogleApiKeyDto>(null as any);
    }

    verifyReCaptchaToken(body: VerifyReCaptchaTokenDto | undefined): Promise<void> {
      let url_ = this.baseUrl + '/api/client-service-public/config/VerifyReCaptchaToken';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processVerifyReCaptchaToken(_response)
          );
        });
    }

    protected processVerifyReCaptchaToken(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAllCPCTeams(): Promise<TeamDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/contact-staff/GetAllCPCTeams';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetAllCPCTeams(_response));
        });
    }

    protected processGetAllCPCTeams(response: Response): Promise<TeamDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(TeamDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<TeamDto[]>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    sendMessage(body: ContactStaffDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/contact-staff/SendMessage';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processSendMessage(_response));
        });
    }

    protected processSendMessage(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    contactSupport(body: ContactSupportFormDto | undefined): Promise<void> {
      let url_ = this.baseUrl + '/api/client-service-public/contact-staff/ContactSupport';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json-patch+json',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processContactSupport(_response));
        });
    }

    protected processContactSupport(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          return;
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          return throwException('Bad Request', status, _responseText, _headers);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          return throwException('Server Error', status, _responseText, _headers);
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<void>(null as any);
    }

    /**
     * @return OK
     */
    requestCode(): Promise<RequestDocumentDownloadCodeResultDto> {
      let url_ = this.baseUrl + '/api/client-service-public/document-download-mfa/request-code';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.processRequestCode(_response);
        });
    }

    protected processRequestCode(response: Response): Promise<RequestDocumentDownloadCodeResultDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = RequestDocumentDownloadCodeResultDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Not Implemented', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<RequestDocumentDownloadCodeResultDto>(null as any);
    }

    /**
     * @param body (optional)
     * @return OK
     */
    verifyCode(body: VerifyDocumentDownloadCodeInputDto | undefined): Promise<VerifyDocumentDownloadCodeResultDto> {
      let url_ = this.baseUrl + '/api/client-service-public/document-download-mfa/verify-code';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.processVerifyCode(_response);
        });
    }

    protected processVerifyCode(response: Response): Promise<VerifyDocumentDownloadCodeResultDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = VerifyDocumentDownloadCodeResultDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Not Implemented', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Internal Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<VerifyDocumentDownloadCodeResultDto>(null as any);
    }

    /**
     * @param filterText (optional)
     * @param filterTextlang (optional)
     * @param fileId (optional)
     * @param documentId (optional)
     * @param documentIds (optional)
     * @param documentFolderId (optional)
     * @param documentVerificationStatusId (optional)
     * @param documentVerificationStatuses (optional)
     * @param documentTypeId (optional)
     * @param documentTypes (optional)
     * @param documentPrefixes (optional)
     * @param documentPrefixCodes (optional)
     * @param documentFolders (optional)
     * @param isVisible (optional)
     * @param isDeleted (optional)
     * @param modifiedDateMin (optional)
     * @param modifiedDateMax (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    documentsGET(
      filterText: string | undefined,
      filterTextlang: LanguageEnum | undefined,
      fileId: string | undefined,
      documentId: string | undefined,
      documentIds: string[] | undefined,
      documentFolderId: string | undefined,
      documentVerificationStatusId: string | undefined,
      documentVerificationStatuses: DocumentVerificationStatusEnum[] | undefined,
      documentTypeId: string | undefined,
      documentTypes: DocumentTypeEnum[] | undefined,
      documentPrefixes: string[] | undefined,
      documentPrefixCodes: string[] | undefined,
      documentFolders: string[] | undefined,
      isVisible: boolean | undefined,
      isDeleted: boolean | undefined,
      modifiedDateMin: moment.Moment | undefined,
      modifiedDateMax: moment.Moment | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      let url_ = this.baseUrl + '/api/client-service-public/documents?';
      if (filterText === null) throw new Error("The parameter 'filterText' cannot be null.");
      else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
      if (filterTextlang === null) throw new Error("The parameter 'filterTextlang' cannot be null.");
      else if (filterTextlang !== undefined) url_ += 'FilterTextlang=' + encodeURIComponent('' + filterTextlang) + '&';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'FileId=' + encodeURIComponent('' + fileId) + '&';
      if (documentId === null) throw new Error("The parameter 'documentId' cannot be null.");
      else if (documentId !== undefined) url_ += 'DocumentId=' + encodeURIComponent('' + documentId) + '&';
      if (documentIds === null) throw new Error("The parameter 'documentIds' cannot be null.");
      else if (documentIds !== undefined)
        documentIds &&
          documentIds.forEach((item) => {
            url_ += 'DocumentIds=' + encodeURIComponent('' + item) + '&';
          });
      if (documentFolderId === null) throw new Error("The parameter 'documentFolderId' cannot be null.");
      else if (documentFolderId !== undefined)
        url_ += 'DocumentFolderId=' + encodeURIComponent('' + documentFolderId) + '&';
      if (documentVerificationStatusId === null)
        throw new Error("The parameter 'documentVerificationStatusId' cannot be null.");
      else if (documentVerificationStatusId !== undefined)
        url_ += 'DocumentVerificationStatusId=' + encodeURIComponent('' + documentVerificationStatusId) + '&';
      if (documentVerificationStatuses === null)
        throw new Error("The parameter 'documentVerificationStatuses' cannot be null.");
      else if (documentVerificationStatuses !== undefined)
        documentVerificationStatuses &&
          documentVerificationStatuses.forEach((item) => {
            url_ += 'DocumentVerificationStatuses=' + encodeURIComponent('' + item) + '&';
          });
      if (documentTypeId === null) throw new Error("The parameter 'documentTypeId' cannot be null.");
      else if (documentTypeId !== undefined) url_ += 'DocumentTypeId=' + encodeURIComponent('' + documentTypeId) + '&';
      if (documentTypes === null) throw new Error("The parameter 'documentTypes' cannot be null.");
      else if (documentTypes !== undefined)
        documentTypes &&
          documentTypes.forEach((item) => {
            url_ += 'DocumentTypes=' + encodeURIComponent('' + item) + '&';
          });
      if (documentPrefixes === null) throw new Error("The parameter 'documentPrefixes' cannot be null.");
      else if (documentPrefixes !== undefined)
        documentPrefixes &&
          documentPrefixes.forEach((item) => {
            url_ += 'DocumentPrefixes=' + encodeURIComponent('' + item) + '&';
          });
      if (documentPrefixCodes === null) throw new Error("The parameter 'documentPrefixCodes' cannot be null.");
      else if (documentPrefixCodes !== undefined)
        documentPrefixCodes &&
          documentPrefixCodes.forEach((item) => {
            url_ += 'DocumentPrefixCodes=' + encodeURIComponent('' + item) + '&';
          });
      if (documentFolders === null) throw new Error("The parameter 'documentFolders' cannot be null.");
      else if (documentFolders !== undefined)
        documentFolders &&
          documentFolders.forEach((item) => {
            url_ += 'DocumentFolders=' + encodeURIComponent('' + item) + '&';
          });
      if (isVisible === null) throw new Error("The parameter 'isVisible' cannot be null.");
      else if (isVisible !== undefined) url_ += 'IsVisible=' + encodeURIComponent('' + isVisible) + '&';
      if (isDeleted === null) throw new Error("The parameter 'isDeleted' cannot be null.");
      else if (isDeleted !== undefined) url_ += 'IsDeleted=' + encodeURIComponent('' + isDeleted) + '&';
      if (modifiedDateMin === null) throw new Error("The parameter 'modifiedDateMin' cannot be null.");
      else if (modifiedDateMin !== undefined)
        url_ +=
          'ModifiedDateMin=' + encodeURIComponent(modifiedDateMin ? '' + modifiedDateMin.toISOString() : '') + '&';
      if (modifiedDateMax === null) throw new Error("The parameter 'modifiedDateMax' cannot be null.");
      else if (modifiedDateMax !== undefined)
        url_ +=
          'ModifiedDateMax=' + encodeURIComponent(modifiedDateMax ? '' + modifiedDateMax.toISOString() : '') + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDocumentsGET(_response));
        });
    }

    protected processDocumentsGET(
      response: Response
    ): Promise<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
        null as any
      );
    }

    /**
     * @param documentFolderId (optional)
     * @param documentPrefixId (optional)
     * @param additionalInformation (optional)
     * @param isVisible (optional)
     * @param fileModifiedDate (optional)
     * @param content (optional)
     * @param isForSpouse (optional)
     * @param businessName (optional)
     * @return Success
     */
    documentsPOST(
      documentFolderId: string | undefined,
      documentPrefixId: string | undefined,
      additionalInformation: string | undefined,
      isVisible: boolean | undefined,
      fileModifiedDate: moment.Moment | undefined,
      content: FileParameter | undefined,
      isForSpouse: boolean | undefined,
      businessName: string | undefined
    ): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/documents';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (documentFolderId === null || documentFolderId === undefined)
        throw new Error("The parameter 'documentFolderId' cannot be null.");
      else content_.append('DocumentFolderId', documentFolderId.toString());
      if (documentPrefixId === null || documentPrefixId === undefined)
        throw new Error("The parameter 'documentPrefixId' cannot be null.");
      else content_.append('DocumentPrefixId', documentPrefixId.toString());
      if (additionalInformation === null || additionalInformation === undefined)
        throw new Error("The parameter 'additionalInformation' cannot be null.");
      else content_.append('AdditionalInformation', additionalInformation.toString());
      if (isVisible === null || isVisible === undefined) throw new Error("The parameter 'isVisible' cannot be null.");
      else content_.append('IsVisible', isVisible.toString());
      if (fileModifiedDate === null || fileModifiedDate === undefined)
        throw new Error("The parameter 'fileModifiedDate' cannot be null.");
      else content_.append('FileModifiedDate', fileModifiedDate.toJSON());
      if (content === null || content === undefined) throw new Error("The parameter 'content' cannot be null.");
      else content_.append('Content', content.data, content.fileName ? content.fileName : 'Content');
      if (isForSpouse === null || isForSpouse === undefined)
        throw new Error("The parameter 'isForSpouse' cannot be null.");
      else content_.append('IsForSpouse', isForSpouse.toString());
      if (businessName === null || businessName === undefined)
        throw new Error("The parameter 'businessName' cannot be null.");
      else content_.append('BusinessName', businessName.toString());

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDocumentsPOST(_response));
        });
    }

    protected processDocumentsPOST(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param ids (optional)
     * @return Success
     */
    documentsDELETE(ids: string[] | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/documents?';
      if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
      else if (ids !== undefined)
        ids &&
          ids.forEach((item) => {
            url_ += 'ids=' + encodeURIComponent('' + item) + '&';
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'DELETE',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDocumentsDELETE(_response));
        });
    }

    protected processDocumentsDELETE(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    download(id: string): Promise<void> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/{id}/download';
      if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace('{id}', encodeURIComponent('' + id));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {},
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDownload(_response));
        });
    }

    protected processDownload(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    listTypes(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/list-types';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListTypes(_response));
        });
    }

    protected processListTypes(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listFolders(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/list-folders';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListFolders(_response));
        });
    }

    protected processListFolders(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional)
     * @param assetId (optional)
     * @param prefixCodes (optional)
     * @return Success
     */
    listPrefixes(
      documentFolderId: string | undefined,
      assetId: string | undefined,
      prefixCodes: string[] | undefined
    ): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/list-prefixes?';
      if (documentFolderId === null) throw new Error("The parameter 'documentFolderId' cannot be null.");
      else if (documentFolderId !== undefined)
        url_ += 'documentFolderId=' + encodeURIComponent('' + documentFolderId) + '&';
      if (assetId === null) throw new Error("The parameter 'assetId' cannot be null.");
      else if (assetId !== undefined) url_ += 'assetId=' + encodeURIComponent('' + assetId) + '&';
      if (prefixCodes === null) throw new Error("The parameter 'prefixCodes' cannot be null.");
      else if (prefixCodes !== undefined)
        prefixCodes &&
          prefixCodes.forEach((item) => {
            url_ += 'prefixCodes=' + encodeURIComponent('' + item) + '&';
          });
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListPrefixes(_response));
        });
    }

    protected processListPrefixes(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param documentFolderId (optional)
     * @param context (optional)
     * @return Success
     */
    listDocumentPrefixesByContext(
      documentFolderId: string | undefined,
      context: DocumentPrefixContextEnum | undefined
    ): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/ListDocumentPrefixesByContext?';
      if (documentFolderId === null) throw new Error("The parameter 'documentFolderId' cannot be null.");
      else if (documentFolderId !== undefined)
        url_ += 'documentFolderId=' + encodeURIComponent('' + documentFolderId) + '&';
      if (context === null) throw new Error("The parameter 'context' cannot be null.");
      else if (context !== undefined) url_ += 'context=' + encodeURIComponent('' + context) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListDocumentPrefixesByContext(_response)
          );
        });
    }

    protected processListDocumentPrefixesByContext(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param file (optional)
     * @return Success
     */
    convertHeicToJpg(file: FileParameter | undefined): Promise<FileResponse> {
      let url_ = this.baseUrl + '/api/client-service-public/documents/convert-heic-to-jpg';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (file === null || file === undefined) throw new Error("The parameter 'file' cannot be null.");
      else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processConvertHeicToJpg(_response)
          );
        });
    }

    protected processConvertHeicToJpg(response: Response): Promise<FileResponse> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200 || status === 206) {
        const contentDisposition = response.headers ? response.headers.get('content-disposition') : undefined;
        let fileNameMatch = contentDisposition
          ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
          : undefined;
        let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
        if (fileName) {
          fileName = decodeURIComponent(fileName);
        } else {
          fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
          fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
        }
        return response.blob().then((blob) => {
          return { fileName: fileName, data: blob, status: status, headers: _headers };
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = resultData400 !== undefined ? resultData400 : <any>null;

          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = resultData500 !== undefined ? resultData500 : <any>null;

          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<FileResponse>(null as any);
    }

    /**
     * @param fileId (optional)
     * @return Success
     */
    listAppointmentTypes(fileId: string | undefined): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAppointmentTypes?';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'fileId=' + encodeURIComponent('' + fileId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppointmentTypes(_response)
          );
        });
    }

    protected processListAppointmentTypes(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listCountries(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListCountries';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListCountries(_response));
        });
    }

    protected processListCountries(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listMeetingTypes(): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListMeetingTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListMeetingTypes(_response)
          );
        });
    }

    protected processListMeetingTypes(
      response: Response
    ): Promise<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listPhoneTypes(): Promise<PhoneTypeLookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListPhoneTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListPhoneTypes(_response));
        });
    }

    protected processListPhoneTypes(response: Response): Promise<PhoneTypeLookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PhoneTypeLookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PhoneTypeLookupDto[]>(null as any);
    }

    /**
     * @param isActive (optional)
     * @return Success
     */
    listReferralSourceTypes(isActive: boolean | undefined): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListReferralSourceTypes?';
      if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
      else if (isActive !== undefined) url_ += 'isActive=' + encodeURIComponent('' + isActive) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListReferralSourceTypes(_response)
          );
        });
    }

    protected processListReferralSourceTypes(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param countryId (optional)
     * @return Success
     */
    listProvinces(countryId: string | undefined): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListProvinces?';
      if (countryId === null) throw new Error("The parameter 'countryId' cannot be null.");
      else if (countryId !== undefined) url_ += 'countryId=' + encodeURIComponent('' + countryId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListProvinces(_response));
        });
    }

    protected processListProvinces(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listAppointmentStatuses(): Promise<
      LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAppointmentStatuses';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppointmentStatuses(_response)
          );
        });
    }

    protected processListAppointmentStatuses(
      response: Response
    ): Promise<LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listMaritalStatuses(): Promise<
      LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListMaritalStatuses';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListMaritalStatuses(_response)
          );
        });
    }

    protected processListMaritalStatuses(
      response: Response
    ): Promise<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listEducationLevels(): Promise<
      LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListEducationLevels';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListEducationLevels(_response)
          );
        });
    }

    protected processListEducationLevels(
      response: Response
    ): Promise<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listEmploymentStatuses(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListEmploymentStatuses';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListEmploymentStatuses(_response)
          );
        });
    }

    protected processListEmploymentStatuses(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listRelationshipTypes(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListRelationshipTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListRelationshipTypes(_response)
          );
        });
    }

    protected processListRelationshipTypes(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param currentFileStage (optional)
     * @return Success
     */
    listAppointmentTypesByFileStage(currentFileStage: FileStageEnum | undefined): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAppointmentTypesByFileStage?';
      if (currentFileStage === null) throw new Error("The parameter 'currentFileStage' cannot be null.");
      else if (currentFileStage !== undefined)
        url_ += 'currentFileStage=' + encodeURIComponent('' + currentFileStage) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAppointmentTypesByFileStage(_response)
          );
        });
    }

    protected processListAppointmentTypesByFileStage(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listAssetDebtOwnershipTypes(): Promise<
      LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAssetDebtOwnershipTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAssetDebtOwnershipTypes(_response)
          );
        });
    }

    protected processListAssetDebtOwnershipTypes(
      response: Response
    ): Promise<LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listAssetTypes(): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAssetTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListAssetTypes(_response));
        });
    }

    protected processListAssetTypes(
      response: Response
    ): Promise<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @param assetTypeId (optional)
     * @return Success
     */
    listAssetDescriptions(
      assetTypeId: string | undefined
    ): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAssetDescriptions?';
      if (assetTypeId === null) throw new Error("The parameter 'assetTypeId' cannot be null.");
      else if (assetTypeId !== undefined) url_ += 'assetTypeId=' + encodeURIComponent('' + assetTypeId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListAssetDescriptions(_response)
          );
        });
    }

    protected processListAssetDescriptions(
      response: Response
    ): Promise<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listDebtDescriptions(): Promise<
      LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListDebtDescriptions';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListDebtDescriptions(_response)
          );
        });
    }

    protected processListDebtDescriptions(
      response: Response
    ): Promise<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listCreditorTypes(): Promise<
      LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListCreditorTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListCreditorTypes(_response)
          );
        });
    }

    protected processListCreditorTypes(
      response: Response
    ): Promise<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listLTPCodes(): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListLTPCodes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListLTPCodes(_response));
        });
    }

    protected processListLTPCodes(
      response: Response
    ): Promise<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listReasonForPreferreds(): Promise<
      LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListReasonForPreferreds';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListReasonForPreferreds(_response)
          );
        });
    }

    protected processListReasonForPreferreds(
      response: Response
    ): Promise<LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listDocumentFolders(): Promise<
      LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListDocumentFolders';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListDocumentFolders(_response)
          );
        });
    }

    protected processListDocumentFolders(
      response: Response
    ): Promise<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @param searchText (optional)
     * @return Success
     */
    listIndustries(
      searchText: string | undefined
    ): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListIndustries?';
      if (searchText === null) throw new Error("The parameter 'searchText' cannot be null.");
      else if (searchText !== undefined) url_ += 'searchText=' + encodeURIComponent('' + searchText) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListIndustries(_response));
        });
    }

    protected processListIndustries(
      response: Response
    ): Promise<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listInsolvencyTypes(): Promise<
      LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListInsolvencyTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListInsolvencyTypes(_response)
          );
        });
    }

    protected processListInsolvencyTypes(
      response: Response
    ): Promise<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listIncomeTypes(): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListIncomeTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListIncomeTypes(_response));
        });
    }

    protected processListIncomeTypes(
      response: Response
    ): Promise<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listExpenseTypes(): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListExpenseTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListExpenseTypes(_response)
          );
        });
    }

    protected processListExpenseTypes(
      response: Response
    ): Promise<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @param expenseTypeId (optional)
     * @return Success
     */
    listExpenseDescriptions(
      expenseTypeId: string | undefined
    ): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListExpenseDescriptions?';
      if (expenseTypeId === null) throw new Error("The parameter 'expenseTypeId' cannot be null.");
      else if (expenseTypeId !== undefined) url_ += 'expenseTypeId=' + encodeURIComponent('' + expenseTypeId) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListExpenseDescriptions(_response)
          );
        });
    }

    protected processListExpenseDescriptions(
      response: Response
    ): Promise<LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listResidenceAppliesTo(): Promise<
      LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListResidenceAppliesTo';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListResidenceAppliesTo(_response)
          );
        });
    }

    protected processListResidenceAppliesTo(
      response: Response
    ): Promise<LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listResidenceAvailable(): Promise<
      LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListResidenceAvailable';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListResidenceAvailable(_response)
          );
        });
    }

    protected processListResidenceAvailable(
      response: Response
    ): Promise<LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listRESPs(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListRESPs';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListRESPs(_response));
        });
    }

    protected processListRESPs(
      response: Response
    ): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listRRSPs(): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListRRSPs';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListRRSPs(_response));
        });
    }

    protected processListRRSPs(
      response: Response
    ): Promise<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listTaxTypes(): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListTaxTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListTaxTypes(_response));
        });
    }

    protected processListTaxTypes(
      response: Response
    ): Promise<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listBusinessOwnershipTypes(): Promise<
      LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListBusinessOwnershipTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListBusinessOwnershipTypes(_response)
          );
        });
    }

    protected processListBusinessOwnershipTypes(
      response: Response
    ): Promise<LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @return Success
     */
    listBusinessTypes(): Promise<
      LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListBusinessTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListBusinessTypes(_response)
          );
        });
    }

    protected processListBusinessTypes(
      response: Response
    ): Promise<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listProposalResults(): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListProposalResults';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListProposalResults(_response)
          );
        });
    }

    protected processListProposalResults(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listAnswerTypes(): Promise<LookupReadOnlyDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListAnswerTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListAnswerTypes(_response));
        });
    }

    protected processListAnswerTypes(response: Response): Promise<LookupReadOnlyDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupReadOnlyDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupReadOnlyDto[]>(null as any);
    }

    /**
     * @return Success
     */
    listGenderOptions(): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListGenderOptions';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListGenderOptions(_response)
          );
        });
    }

    protected processListGenderOptions(
      response: Response
    ): Promise<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listCityTypes(): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListCityTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processListCityTypes(_response));
        });
    }

    protected processListCityTypes(
      response: Response
    ): Promise<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item)
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]>(
        null as any
      );
    }

    /**
     * @return Success
     */
    listBankruptcyDischargeTypes(): Promise<
      LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
    > {
      let url_ = this.baseUrl + '/api/client-service-public/Lookup/ListBankruptcyDischargeTypes';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListBankruptcyDischargeTypes(_response)
          );
        });
    }

    protected processListBankruptcyDischargeTypes(
      response: Response
    ): Promise<LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<
        LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null[]
      >(null as any);
    }

    /**
     * @param isUnread (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    notificationsGET(
      isUnread: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      let url_ = this.baseUrl + '/api/client-service-public/notifications?';
      if (isUnread === null) throw new Error("The parameter 'isUnread' cannot be null.");
      else if (isUnread !== undefined) url_ += 'IsUnread=' + encodeURIComponent('' + isUnread) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processNotificationsGET(_response)
          );
        });
    }

    protected processNotificationsGET(
      response: Response
    ): Promise<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
        null as any
      );
    }

    /**
     * @return Success
     */
    notificationsPUT(): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/notifications';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'PUT',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processNotificationsPUT(_response)
          );
        });
    }

    protected processNotificationsPUT(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @return Success
     */
    newExist(): Promise<boolean> {
      let url_ = this.baseUrl + '/api/client-service-public/notifications/new-exist';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processNewExist(_response));
        });
    }

    protected processNewExist(response: Response): Promise<boolean> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param filterText (optional)
     * @param nearbyLatitude (optional)
     * @param nearbyLongitude (optional)
     * @param includeInactive (optional)
     * @param isActive (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    officeLocations(
      filterText: string | undefined,
      nearbyLatitude: number | undefined,
      nearbyLongitude: number | undefined,
      includeInactive: boolean | undefined,
      isActive: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      let url_ = this.baseUrl + '/api/client-service-public/office-locations?';
      if (filterText === null) throw new Error("The parameter 'filterText' cannot be null.");
      else if (filterText !== undefined) url_ += 'FilterText=' + encodeURIComponent('' + filterText) + '&';
      if (nearbyLatitude === null) throw new Error("The parameter 'nearbyLatitude' cannot be null.");
      else if (nearbyLatitude !== undefined) url_ += 'NearbyLatitude=' + encodeURIComponent('' + nearbyLatitude) + '&';
      if (nearbyLongitude === null) throw new Error("The parameter 'nearbyLongitude' cannot be null.");
      else if (nearbyLongitude !== undefined)
        url_ += 'NearbyLongitude=' + encodeURIComponent('' + nearbyLongitude) + '&';
      if (includeInactive === null) throw new Error("The parameter 'includeInactive' cannot be null.");
      else if (includeInactive !== undefined)
        url_ += 'IncludeInactive=' + encodeURIComponent('' + includeInactive) + '&';
      if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
      else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processOfficeLocations(_response));
        });
    }

    protected processOfficeLocations(
      response: Response
    ): Promise<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
        null as any
      );
    }

    /**
     * @param userIds (optional)
     * @param roleName (optional)
     * @param roleNames (optional)
     * @param isActive (optional)
     * @return Success
     */
    filterUsers(
      userIds: string[] | undefined,
      roleName: string | undefined,
      roleNames: string[] | undefined,
      isActive: boolean | undefined
    ): Promise<string[]> {
      let url_ = this.baseUrl + '/api/identity-public/pds-user/FilterUsers?';
      if (userIds === null) throw new Error("The parameter 'userIds' cannot be null.");
      else if (userIds !== undefined)
        userIds &&
          userIds.forEach((item) => {
            url_ += 'UserIds=' + encodeURIComponent('' + item) + '&';
          });
      if (roleName === null) throw new Error("The parameter 'roleName' cannot be null.");
      else if (roleName !== undefined) url_ += 'RoleName=' + encodeURIComponent('' + roleName) + '&';
      if (roleNames === null) throw new Error("The parameter 'roleNames' cannot be null.");
      else if (roleNames !== undefined)
        roleNames &&
          roleNames.forEach((item) => {
            url_ += 'RoleNames=' + encodeURIComponent('' + item) + '&';
          });
      if (isActive === null) throw new Error("The parameter 'isActive' cannot be null.");
      else if (isActive !== undefined) url_ += 'IsActive=' + encodeURIComponent('' + isActive) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processFilterUsers(_response));
        });
    }

    protected processFilterUsers(response: Response): Promise<string[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<string[]>(null as any);
    }

    download2(id: string): Promise<void> {
      let url_ = this.baseUrl + '/api/client-service-public/receipts/{id}/download';
      if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
      url_ = url_.replace('{id}', encodeURIComponent('' + id));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {},
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processDownload2(_response));
        });
    }

    protected processDownload2(response: Response): Promise<void> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<void>(null as any);
    }

    /**
     * @return Success
     */
    getAll(padScheduleId: string): Promise<ReceiptPublicDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/receipts/get-all/{padScheduleId}';
      if (padScheduleId === undefined || padScheduleId === null)
        throw new Error("The parameter 'padScheduleId' must be defined.");
      url_ = url_.replace('{padScheduleId}', encodeURIComponent('' + padScheduleId));
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ReceiptPublicDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ReceiptPublicDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<ReceiptPublicDto[]>(null as any);
    }

    /**
     * @param supportingDocumentStatus (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    getAllSupportingdocuments(
      supportingDocumentStatus: SupportingDocumentStatusEnum | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/get-all-supportingdocuments?';
      if (supportingDocumentStatus === null)
        throw new Error("The parameter 'supportingDocumentStatus' cannot be null.");
      else if (supportingDocumentStatus !== undefined)
        url_ += 'SupportingDocumentStatus=' + encodeURIComponent('' + supportingDocumentStatus) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetAllSupportingdocuments(_response)
          );
        });
    }

    protected processGetAllSupportingdocuments(
      response: Response
    ): Promise<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
        null as any
      );
    }

    /**
     * @param id (optional)
     * @return Success
     */
    getSupportingdocument(id: string | undefined): Promise<SupportingDocumentDto> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/get-supportingdocument?';
      if (id === null) throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processGetSupportingdocument(_response)
          );
        });
    }

    protected processGetSupportingdocument(response: Response): Promise<SupportingDocumentDto> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SupportingDocumentDto.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SupportingDocumentDto>(null as any);
    }

    /**
     * @param id (optional)
     * @return Success
     */
    listPrefixesForAsset(id: string | undefined): Promise<LookupDto[]> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/list-prefixes-for-asset?';
      if (id === null) throw new Error("The parameter 'id' cannot be null.");
      else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processListPrefixesForAsset(_response)
          );
        });
    }

    protected processListPrefixesForAsset(response: Response): Promise<LookupDto[]> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(LookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<LookupDto[]>(null as any);
    }

    /**
     * @param appFormAssetsDebtsAssetId (optional)
     * @param fileId (optional)
     * @param isDeleted (optional)
     * @param isUploaded (optional)
     * @param isReviewd (optional)
     * @param isOverridden (optional)
     * @param sorting (optional)
     * @param skipCount (optional)
     * @param maxResultCount (optional)
     * @return Success
     */
    count3(
      appFormAssetsDebtsAssetId: string | undefined,
      fileId: string | undefined,
      isDeleted: boolean | undefined,
      isUploaded: boolean | undefined,
      isReviewd: boolean | undefined,
      isOverridden: boolean | undefined,
      sorting: string | undefined,
      skipCount: number | undefined,
      maxResultCount: number | undefined
    ): Promise<number> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/count?';
      if (appFormAssetsDebtsAssetId === null)
        throw new Error("The parameter 'appFormAssetsDebtsAssetId' cannot be null.");
      else if (appFormAssetsDebtsAssetId !== undefined)
        url_ += 'AppFormAssetsDebtsAssetId=' + encodeURIComponent('' + appFormAssetsDebtsAssetId) + '&';
      if (fileId === null) throw new Error("The parameter 'fileId' cannot be null.");
      else if (fileId !== undefined) url_ += 'FileId=' + encodeURIComponent('' + fileId) + '&';
      if (isDeleted === null) throw new Error("The parameter 'isDeleted' cannot be null.");
      else if (isDeleted !== undefined) url_ += 'IsDeleted=' + encodeURIComponent('' + isDeleted) + '&';
      if (isUploaded === null) throw new Error("The parameter 'isUploaded' cannot be null.");
      else if (isUploaded !== undefined) url_ += 'IsUploaded=' + encodeURIComponent('' + isUploaded) + '&';
      if (isReviewd === null) throw new Error("The parameter 'isReviewd' cannot be null.");
      else if (isReviewd !== undefined) url_ += 'IsReviewd=' + encodeURIComponent('' + isReviewd) + '&';
      if (isOverridden === null) throw new Error("The parameter 'isOverridden' cannot be null.");
      else if (isOverridden !== undefined) url_ += 'IsOverridden=' + encodeURIComponent('' + isOverridden) + '&';
      if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
      else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
      if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
      else if (skipCount !== undefined) url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
      if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
      else if (maxResultCount !== undefined) url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
      url_ = url_.replace(/[?&]$/, '');

      let options_: RequestInit = {
        method: 'GET',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processCount3(_response));
        });
    }

    protected processCount3(response: Response): Promise<number> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<number>(null as any);
    }

    /**
     * @param supportingDocumentId (optional)
     * @param documentFolderId (optional)
     * @param documentPrefixId (optional)
     * @param additionalInformation (optional)
     * @param isVisible (optional)
     * @param fileModifiedDate (optional)
     * @param content (optional)
     * @param isForSpouse (optional)
     * @param businessName (optional)
     * @return Success
     */
    upload(
      supportingDocumentId: string | undefined,
      documentFolderId: string | undefined,
      documentPrefixId: string | undefined,
      additionalInformation: string | undefined,
      isVisible: boolean | undefined,
      fileModifiedDate: moment.Moment | undefined,
      content: FileParameter | undefined,
      isForSpouse: boolean | undefined,
      businessName: string | undefined
    ): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/upload';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = new FormData();
      if (supportingDocumentId === null || supportingDocumentId === undefined)
        throw new Error("The parameter 'supportingDocumentId' cannot be null.");
      else content_.append('SupportingDocumentId', supportingDocumentId.toString());
      if (documentFolderId === null || documentFolderId === undefined)
        throw new Error("The parameter 'documentFolderId' cannot be null.");
      else content_.append('DocumentFolderId', documentFolderId.toString());
      if (documentPrefixId === null || documentPrefixId === undefined)
        throw new Error("The parameter 'documentPrefixId' cannot be null.");
      else content_.append('DocumentPrefixId', documentPrefixId.toString());
      if (additionalInformation === null || additionalInformation === undefined)
        throw new Error("The parameter 'additionalInformation' cannot be null.");
      else content_.append('AdditionalInformation', additionalInformation.toString());
      if (isVisible === null || isVisible === undefined) throw new Error("The parameter 'isVisible' cannot be null.");
      else content_.append('IsVisible', isVisible.toString());
      if (fileModifiedDate === null || fileModifiedDate === undefined)
        throw new Error("The parameter 'fileModifiedDate' cannot be null.");
      else content_.append('FileModifiedDate', fileModifiedDate.toJSON());
      if (content === null || content === undefined) throw new Error("The parameter 'content' cannot be null.");
      else content_.append('Content', content.data, content.fileName ? content.fileName : 'Content');
      if (isForSpouse === null || isForSpouse === undefined)
        throw new Error("The parameter 'isForSpouse' cannot be null.");
      else content_.append('IsForSpouse', isForSpouse.toString());
      if (businessName === null || businessName === undefined)
        throw new Error("The parameter 'businessName' cannot be null.");
      else content_.append('BusinessName', businessName.toString());

      let options_: RequestInit = {
        body: content_,
        method: 'POST',
        headers: {
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) => this.processUpload(_response));
        });
    }

    protected processUpload(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }

    /**
     * @param body (optional)
     * @return Success
     */
    updateDocumentsMany(body: SupportingDocumentDocumentUpdateDto | undefined): Promise<SaveResult> {
      let url_ = this.baseUrl + '/api/client-service-public/supporting-documents/update-documents-many';
      url_ = url_.replace(/[?&]$/, '');

      const content_ = JSON.stringify(body);

      let options_: RequestInit = {
        body: content_,
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json-patch+json',
          Accept: 'text/plain',
        },
      };

      return this.transformOptions(options_)
        .then((transformedOptions_) => {
          return this.http.fetch(url_, transformedOptions_);
        })
        .then((_response: Response) => {
          return this.transformResult(url_, _response, (_response: Response) =>
            this.processUpdateDocumentsMany(_response)
          );
        });
    }

    protected processUpdateDocumentsMany(response: Response): Promise<SaveResult> {
      const status = response.status;
      let _headers: any = {};
      if (response.headers && response.headers.forEach) {
        response.headers.forEach((v: any, k: any) => (_headers[k] = v));
      }
      if (status === 200) {
        return response.text().then((_responseText) => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SaveResult.fromJS(resultData200);
          return result200;
        });
      } else if (status === 403) {
        return response.text().then((_responseText) => {
          let result403: any = null;
          let resultData403 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        });
      } else if (status === 401) {
        return response.text().then((_responseText) => {
          let result401: any = null;
          let resultData401 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        });
      } else if (status === 400) {
        return response.text().then((_responseText) => {
          let result400: any = null;
          let resultData400 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        });
      } else if (status === 404) {
        return response.text().then((_responseText) => {
          let result404: any = null;
          let resultData404 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        });
      } else if (status === 501) {
        return response.text().then((_responseText) => {
          let result501: any = null;
          let resultData501 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        });
      } else if (status === 500) {
        return response.text().then((_responseText) => {
          let result500: any = null;
          let resultData500 = _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        });
      } else if (status !== 200 && status !== 204) {
        return response.text().then((_responseText) => {
          return throwException('An unexpected server error occurred.', status, _responseText, _headers);
        });
      }
      return Promise.resolve<SaveResult>(null as any);
    }
  }

  export class DocumentPrefixDto implements IDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;
    frenchName?: string | undefined;

    constructor(data?: IDocumentPrefixDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.documentPrefixName = _data['documentPrefixName'];
        this.documentFolderId = _data['documentFolderId'];
        this.documentFolderName = _data['documentFolderName'];
        this.isCustom = _data['isCustom'];
        this.isActive = _data['isActive'];
        this.frenchName = _data['frenchName'];
      }
    }

    static fromJS(data: any): DocumentPrefixDto {
      data = typeof data === 'object' ? data : {};
      let result = new DocumentPrefixDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['documentPrefixName'] = this.documentPrefixName;
      data['documentFolderId'] = this.documentFolderId;
      data['documentFolderName'] = this.documentFolderName;
      data['isCustom'] = this.isCustom;
      data['isActive'] = this.isActive;
      data['frenchName'] = this.frenchName;
      return data;
    }
  }

  export interface IDocumentPrefixDto {
    id?: string;
    documentPrefixName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    isCustom?: boolean;
    isActive?: boolean;
    frenchName?: string | undefined;
  }

  export class AgentDto implements IAgentDto {
    id?: string;
    fullName?: string | undefined;
    teams?: TeamDto[] | undefined;

    constructor(data?: IAgentDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fullName = _data['fullName'];
        if (Array.isArray(_data['teams'])) {
          this.teams = [] as any;
          for (let item of _data['teams']) this.teams!.push(TeamDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): AgentDto {
      data = typeof data === 'object' ? data : {};
      let result = new AgentDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fullName'] = this.fullName;
      if (Array.isArray(this.teams)) {
        data['teams'] = [];
        for (let item of this.teams) data['teams'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IAgentDto {
    id?: string;
    fullName?: string | undefined;
    teams?: TeamDto[] | undefined;
  }

  export class TeamDto implements ITeamDto {
    id?: string;
    name?: string | undefined;
    teamType?: TeamTypeDto;
    agents?: AgentDto[] | undefined;

    constructor(data?: ITeamDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.name = _data['name'];
        this.teamType = _data['teamType'] ? TeamTypeDto.fromJS(_data['teamType']) : <any>undefined;
        if (Array.isArray(_data['agents'])) {
          this.agents = [] as any;
          for (let item of _data['agents']) this.agents!.push(AgentDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): TeamDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeamDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['name'] = this.name;
      data['teamType'] = this.teamType ? this.teamType.toJSON() : <any>undefined;
      if (Array.isArray(this.agents)) {
        data['agents'] = [];
        for (let item of this.agents) data['agents'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ITeamDto {
    id?: string;
    name?: string | undefined;
    teamType?: TeamTypeDto;
    agents?: AgentDto[] | undefined;
  }

  export class TeamTypeDto implements ITeamTypeDto {
    id?: string;
    name?: string | undefined;

    constructor(data?: ITeamTypeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.name = _data['name'];
      }
    }

    static fromJS(data: any): TeamTypeDto {
      data = typeof data === 'object' ? data : {};
      let result = new TeamTypeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['name'] = this.name;
      return data;
    }
  }

  export interface ITeamTypeDto {
    id?: string;
    name?: string | undefined;
  }

  export class AppFormAssetsDebtsAssetConfig implements IAppFormAssetsDebtsAssetConfig {
    isJointFile?: boolean;
    isManitoba?: boolean;
    hasPrincipalResidence?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetConfig) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isJointFile = _data['isJointFile'];
        this.isManitoba = _data['isManitoba'];
        this.hasPrincipalResidence = _data['hasPrincipalResidence'];
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetConfig {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsAssetConfig();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isJointFile'] = this.isJointFile;
      data['isManitoba'] = this.isManitoba;
      data['hasPrincipalResidence'] = this.hasPrincipalResidence;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsAssetConfig {
    isJointFile?: boolean;
    isManitoba?: boolean;
    hasPrincipalResidence?: boolean;
  }

  export class AppFormAssetsDebtsAssetDto implements IAppFormAssetsDebtsAssetDto {
    id?: string;
    fileId?: string;
    assetType?: AssetTypeEnum;
    assetDescription?: AssetDescriptionEnum;
    assetDescriptionName?: string | undefined;
    assetTypeId?: string | undefined;
    assetDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    ownershipTypeId?: string | undefined;
    comments?: string | undefined;
    isExempt?: boolean;
    isForeignAsset?: boolean;
    securedToDebts?: AppFormAssetsDebtsDebtListItem[] | undefined;
    basisOfValue?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    applicantOwnershipPercentage?: number | undefined;
    spouseOwnershipPercentage?: number | undefined;
    otherOwnershipPercentage?: number | undefined;
    totalNumberOfOwners?: number | undefined;
    isOwnershipHeldInJointTenancy?: boolean | undefined;
    isPrincipalResidence?: boolean | undefined;
    nameOfInstitution?: string | undefined;
    policyNumber?: string | undefined;
    contributionsInLast12Months?: number | undefined;
    grantToBeRepaid?: number | undefined;
    estimatedTaxOnDisposition?: number | undefined;
    debtorsOwnershipInterest?: number | undefined;
    year?: moment.Moment | undefined;
    make?: string | undefined;
    model?: string | undefined;
    trim?: string | undefined;
    style?: string | undefined;
    kilometers?: number | undefined;
    vin?: string | undefined;
    isVehicleNeededForEmployment?: boolean | undefined;
    documentIds?: string[] | undefined;
    supportingDocumentOverrideInfo?: SupportingDocumentApplicabilityOverrideDto;
    clientUpdatedFields?: AppFormAssetsDebtsAssetUpdatedFieldsDto;

    constructor(data?: IAppFormAssetsDebtsAssetDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.assetType = _data['assetType'];
        this.assetDescription = _data['assetDescription'];
        this.assetDescriptionName = _data['assetDescriptionName'];
        this.assetTypeId = _data['assetTypeId'];
        this.assetDescriptionId = _data['assetDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.value = _data['value'];
        this.ownershipTypeId = _data['ownershipTypeId'];
        this.comments = _data['comments'];
        this.isExempt = _data['isExempt'];
        this.isForeignAsset = _data['isForeignAsset'];
        if (Array.isArray(_data['securedToDebts'])) {
          this.securedToDebts = [] as any;
          for (let item of _data['securedToDebts'])
            this.securedToDebts!.push(AppFormAssetsDebtsDebtListItem.fromJS(item));
        }
        this.basisOfValue = _data['basisOfValue'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.applicantOwnershipPercentage = _data['applicantOwnershipPercentage'];
        this.spouseOwnershipPercentage = _data['spouseOwnershipPercentage'];
        this.otherOwnershipPercentage = _data['otherOwnershipPercentage'];
        this.totalNumberOfOwners = _data['totalNumberOfOwners'];
        this.isOwnershipHeldInJointTenancy = _data['isOwnershipHeldInJointTenancy'];
        this.isPrincipalResidence = _data['isPrincipalResidence'];
        this.nameOfInstitution = _data['nameOfInstitution'];
        this.policyNumber = _data['policyNumber'];
        this.contributionsInLast12Months = _data['contributionsInLast12Months'];
        this.grantToBeRepaid = _data['grantToBeRepaid'];
        this.estimatedTaxOnDisposition = _data['estimatedTaxOnDisposition'];
        this.debtorsOwnershipInterest = _data['debtorsOwnershipInterest'];
        this.year = _data['year'] ? moment(_data['year'].toString()) : <any>undefined;
        this.make = _data['make'];
        this.model = _data['model'];
        this.trim = _data['trim'];
        this.style = _data['style'];
        this.kilometers = _data['kilometers'];
        this.vin = _data['vin'];
        this.isVehicleNeededForEmployment = _data['isVehicleNeededForEmployment'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.supportingDocumentOverrideInfo = _data['supportingDocumentOverrideInfo']
          ? SupportingDocumentApplicabilityOverrideDto.fromJS(_data['supportingDocumentOverrideInfo'])
          : <any>undefined;
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormAssetsDebtsAssetUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsAssetDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['assetType'] = this.assetType;
      data['assetDescription'] = this.assetDescription;
      data['assetDescriptionName'] = this.assetDescriptionName;
      data['assetTypeId'] = this.assetTypeId;
      data['assetDescriptionId'] = this.assetDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['value'] = this.value;
      data['ownershipTypeId'] = this.ownershipTypeId;
      data['comments'] = this.comments;
      data['isExempt'] = this.isExempt;
      data['isForeignAsset'] = this.isForeignAsset;
      if (Array.isArray(this.securedToDebts)) {
        data['securedToDebts'] = [];
        for (let item of this.securedToDebts) data['securedToDebts'].push(item.toJSON());
      }
      data['basisOfValue'] = this.basisOfValue;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['applicantOwnershipPercentage'] = this.applicantOwnershipPercentage;
      data['spouseOwnershipPercentage'] = this.spouseOwnershipPercentage;
      data['otherOwnershipPercentage'] = this.otherOwnershipPercentage;
      data['totalNumberOfOwners'] = this.totalNumberOfOwners;
      data['isOwnershipHeldInJointTenancy'] = this.isOwnershipHeldInJointTenancy;
      data['isPrincipalResidence'] = this.isPrincipalResidence;
      data['nameOfInstitution'] = this.nameOfInstitution;
      data['policyNumber'] = this.policyNumber;
      data['contributionsInLast12Months'] = this.contributionsInLast12Months;
      data['grantToBeRepaid'] = this.grantToBeRepaid;
      data['estimatedTaxOnDisposition'] = this.estimatedTaxOnDisposition;
      data['debtorsOwnershipInterest'] = this.debtorsOwnershipInterest;
      data['year'] = this.year ? this.year.toISOString() : <any>undefined;
      data['make'] = this.make;
      data['model'] = this.model;
      data['trim'] = this.trim;
      data['style'] = this.style;
      data['kilometers'] = this.kilometers;
      data['vin'] = this.vin;
      data['isVehicleNeededForEmployment'] = this.isVehicleNeededForEmployment;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['supportingDocumentOverrideInfo'] = this.supportingDocumentOverrideInfo
        ? this.supportingDocumentOverrideInfo.toJSON()
        : <any>undefined;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsAssetDto {
    id?: string;
    fileId?: string;
    assetType?: AssetTypeEnum;
    assetDescription?: AssetDescriptionEnum;
    assetDescriptionName?: string | undefined;
    assetTypeId?: string | undefined;
    assetDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    ownershipTypeId?: string | undefined;
    comments?: string | undefined;
    isExempt?: boolean;
    isForeignAsset?: boolean;
    securedToDebts?: AppFormAssetsDebtsDebtListItem[] | undefined;
    basisOfValue?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    applicantOwnershipPercentage?: number | undefined;
    spouseOwnershipPercentage?: number | undefined;
    otherOwnershipPercentage?: number | undefined;
    totalNumberOfOwners?: number | undefined;
    isOwnershipHeldInJointTenancy?: boolean | undefined;
    isPrincipalResidence?: boolean | undefined;
    nameOfInstitution?: string | undefined;
    policyNumber?: string | undefined;
    contributionsInLast12Months?: number | undefined;
    grantToBeRepaid?: number | undefined;
    estimatedTaxOnDisposition?: number | undefined;
    debtorsOwnershipInterest?: number | undefined;
    year?: moment.Moment | undefined;
    make?: string | undefined;
    model?: string | undefined;
    trim?: string | undefined;
    style?: string | undefined;
    kilometers?: number | undefined;
    vin?: string | undefined;
    isVehicleNeededForEmployment?: boolean | undefined;
    documentIds?: string[] | undefined;
    supportingDocumentOverrideInfo?: SupportingDocumentApplicabilityOverrideDto;
    clientUpdatedFields?: AppFormAssetsDebtsAssetUpdatedFieldsDto;
  }

  export class AppFormAssetsDebtsAssetListItem implements IAppFormAssetsDebtsAssetListItem {
    id?: string;
    assetType?: LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    assetDescription?: LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    isMissingSupportingDocuments?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetListItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.assetType = _data['assetType']
          ? LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(_data['assetType'])
          : <any>undefined;
        this.assetDescription = _data['assetDescription']
          ? LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              _data['assetDescription']
            )
          : <any>undefined;
        this.specifiedDescription = _data['specifiedDescription'];
        this.value = _data['value'];
        this.displayName = _data['displayName'];
        this.isMissingDetails = _data['isMissingDetails'];
        this.isMissingSupportingDocuments = _data['isMissingSupportingDocuments'];
        this.updatedByClient = _data['updatedByClient'];
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetListItem {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsAssetListItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['assetType'] = this.assetType ? this.assetType.toJSON() : <any>undefined;
      data['assetDescription'] = this.assetDescription ? this.assetDescription.toJSON() : <any>undefined;
      data['specifiedDescription'] = this.specifiedDescription;
      data['value'] = this.value;
      data['displayName'] = this.displayName;
      data['isMissingDetails'] = this.isMissingDetails;
      data['isMissingSupportingDocuments'] = this.isMissingSupportingDocuments;
      data['updatedByClient'] = this.updatedByClient;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsAssetListItem {
    id?: string;
    assetType?: LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    assetDescription?: LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    value?: number | undefined;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    isMissingSupportingDocuments?: boolean;
    updatedByClient?: boolean;
  }

  export class AppFormAssetsDebtsDebtDto implements IAppFormAssetsDebtsDebtDto {
    id?: string;
    fileId?: string;
    debtDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    creditorName?: string | undefined;
    amount?: number | undefined;
    ownershipTypeId?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isBusinessDebt?: boolean;
    creditorAddress?: string | undefined;
    creditorStreetNumber?: string | undefined;
    creditorStreetName?: string | undefined;
    creditorUnit?: string | undefined;
    creditorCity?: string | undefined;
    creditorPostalCode?: string | undefined;
    creditorProvinceCode?: string | undefined;
    creditorCountryCode?: string | undefined;
    creditorEmailAddress?: string | undefined;
    isUniqueCreditor?: boolean;
    externalCreditorNameId?: string | undefined;
    creditorTypeId?: string | undefined;
    unsecuredAmount?: number | undefined;
    isIncludeInProposal?: boolean;
    isCreditorNotParticipatingInProposal?: boolean;
    reasonForPreferredId?: string | undefined;
    ltpCodeId?: string | undefined;
    isPotentiallyStatuteBarred?: boolean;
    securedByAssetIds?: string[] | undefined;
    clientUpdatedFields?: AppFormAssetsDebtsDebtUpdatedFieldsDto;

    constructor(data?: IAppFormAssetsDebtsDebtDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.debtDescriptionId = _data['debtDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.creditorName = _data['creditorName'];
        this.amount = _data['amount'];
        this.ownershipTypeId = _data['ownershipTypeId'];
        this.accountNumber = _data['accountNumber'];
        this.comments = _data['comments'];
        this.isBusinessDebt = _data['isBusinessDebt'];
        this.creditorAddress = _data['creditorAddress'];
        this.creditorStreetNumber = _data['creditorStreetNumber'];
        this.creditorStreetName = _data['creditorStreetName'];
        this.creditorUnit = _data['creditorUnit'];
        this.creditorCity = _data['creditorCity'];
        this.creditorPostalCode = _data['creditorPostalCode'];
        this.creditorProvinceCode = _data['creditorProvinceCode'];
        this.creditorCountryCode = _data['creditorCountryCode'];
        this.creditorEmailAddress = _data['creditorEmailAddress'];
        this.isUniqueCreditor = _data['isUniqueCreditor'];
        this.externalCreditorNameId = _data['externalCreditorNameId'];
        this.creditorTypeId = _data['creditorTypeId'];
        this.unsecuredAmount = _data['unsecuredAmount'];
        this.isIncludeInProposal = _data['isIncludeInProposal'];
        this.isCreditorNotParticipatingInProposal = _data['isCreditorNotParticipatingInProposal'];
        this.reasonForPreferredId = _data['reasonForPreferredId'];
        this.ltpCodeId = _data['ltpCodeId'];
        this.isPotentiallyStatuteBarred = _data['isPotentiallyStatuteBarred'];
        if (Array.isArray(_data['securedByAssetIds'])) {
          this.securedByAssetIds = [] as any;
          for (let item of _data['securedByAssetIds']) this.securedByAssetIds!.push(item);
        }
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormAssetsDebtsDebtUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsDebtDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['debtDescriptionId'] = this.debtDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['creditorName'] = this.creditorName;
      data['amount'] = this.amount;
      data['ownershipTypeId'] = this.ownershipTypeId;
      data['accountNumber'] = this.accountNumber;
      data['comments'] = this.comments;
      data['isBusinessDebt'] = this.isBusinessDebt;
      data['creditorAddress'] = this.creditorAddress;
      data['creditorStreetNumber'] = this.creditorStreetNumber;
      data['creditorStreetName'] = this.creditorStreetName;
      data['creditorUnit'] = this.creditorUnit;
      data['creditorCity'] = this.creditorCity;
      data['creditorPostalCode'] = this.creditorPostalCode;
      data['creditorProvinceCode'] = this.creditorProvinceCode;
      data['creditorCountryCode'] = this.creditorCountryCode;
      data['creditorEmailAddress'] = this.creditorEmailAddress;
      data['isUniqueCreditor'] = this.isUniqueCreditor;
      data['externalCreditorNameId'] = this.externalCreditorNameId;
      data['creditorTypeId'] = this.creditorTypeId;
      data['unsecuredAmount'] = this.unsecuredAmount;
      data['isIncludeInProposal'] = this.isIncludeInProposal;
      data['isCreditorNotParticipatingInProposal'] = this.isCreditorNotParticipatingInProposal;
      data['reasonForPreferredId'] = this.reasonForPreferredId;
      data['ltpCodeId'] = this.ltpCodeId;
      data['isPotentiallyStatuteBarred'] = this.isPotentiallyStatuteBarred;
      if (Array.isArray(this.securedByAssetIds)) {
        data['securedByAssetIds'] = [];
        for (let item of this.securedByAssetIds) data['securedByAssetIds'].push(item);
      }
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsDebtDto {
    id?: string;
    fileId?: string;
    debtDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    creditorName?: string | undefined;
    amount?: number | undefined;
    ownershipTypeId?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isBusinessDebt?: boolean;
    creditorAddress?: string | undefined;
    creditorStreetNumber?: string | undefined;
    creditorStreetName?: string | undefined;
    creditorUnit?: string | undefined;
    creditorCity?: string | undefined;
    creditorPostalCode?: string | undefined;
    creditorProvinceCode?: string | undefined;
    creditorCountryCode?: string | undefined;
    creditorEmailAddress?: string | undefined;
    isUniqueCreditor?: boolean;
    externalCreditorNameId?: string | undefined;
    creditorTypeId?: string | undefined;
    unsecuredAmount?: number | undefined;
    isIncludeInProposal?: boolean;
    isCreditorNotParticipatingInProposal?: boolean;
    reasonForPreferredId?: string | undefined;
    ltpCodeId?: string | undefined;
    isPotentiallyStatuteBarred?: boolean;
    securedByAssetIds?: string[] | undefined;
    clientUpdatedFields?: AppFormAssetsDebtsDebtUpdatedFieldsDto;
  }

  export class AppFormAssetsDebtsDebtListItem implements IAppFormAssetsDebtsDebtListItem {
    id?: string;
    debtDescription?: LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    creditorName?: string | undefined;
    amount?: number | undefined;
    isSecured?: boolean;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormAssetsDebtsDebtListItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.debtDescription = _data['debtDescription']
          ? LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              _data['debtDescription']
            )
          : <any>undefined;
        this.creditorName = _data['creditorName'];
        this.amount = _data['amount'];
        this.isSecured = _data['isSecured'];
        this.displayName = _data['displayName'];
        this.isMissingDetails = _data['isMissingDetails'];
        this.updatedByClient = _data['updatedByClient'];
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtListItem {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsDebtListItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['debtDescription'] = this.debtDescription ? this.debtDescription.toJSON() : <any>undefined;
      data['creditorName'] = this.creditorName;
      data['amount'] = this.amount;
      data['isSecured'] = this.isSecured;
      data['displayName'] = this.displayName;
      data['isMissingDetails'] = this.isMissingDetails;
      data['updatedByClient'] = this.updatedByClient;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsDebtListItem {
    id?: string;
    debtDescription?: LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    creditorName?: string | undefined;
    amount?: number | undefined;
    isSecured?: boolean;
    displayName?: string | undefined;
    isMissingDetails?: boolean;
    updatedByClient?: boolean;
  }

  export class AppFormBankingInfoDetailDto implements IAppFormBankingInfoDetailDto {
    id?: string;
    institution?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isOverdraftOwed?: boolean | undefined;
    isJointAccount?: boolean | undefined;
    clientUpdatedFields?: AppFormBankingInfoDetailUpdatedFieldsDto;

    constructor(data?: IAppFormBankingInfoDetailDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.institution = _data['institution'];
        this.transitNumber = _data['transitNumber'];
        this.accountNumber = _data['accountNumber'];
        this.comments = _data['comments'];
        this.isOverdraftOwed = _data['isOverdraftOwed'];
        this.isJointAccount = _data['isJointAccount'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormBankingInfoDetailUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormBankingInfoDetailDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormBankingInfoDetailDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['institution'] = this.institution;
      data['transitNumber'] = this.transitNumber;
      data['accountNumber'] = this.accountNumber;
      data['comments'] = this.comments;
      data['isOverdraftOwed'] = this.isOverdraftOwed;
      data['isJointAccount'] = this.isJointAccount;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormBankingInfoDetailDto {
    id?: string;
    institution?: string | undefined;
    transitNumber?: string | undefined;
    accountNumber?: string | undefined;
    comments?: string | undefined;
    isOverdraftOwed?: boolean | undefined;
    isJointAccount?: boolean | undefined;
    clientUpdatedFields?: AppFormBankingInfoDetailUpdatedFieldsDto;
  }

  export class AppFormBankingInfoDto implements IAppFormBankingInfoDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    details?: AppFormBankingInfoDetailDto[] | undefined;
    spouseDetails?: AppFormBankingInfoDetailDto[] | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IAppFormBankingInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.isMarried = _data['isMarried'];
        if (Array.isArray(_data['details'])) {
          this.details = [] as any;
          for (let item of _data['details']) this.details!.push(AppFormBankingInfoDetailDto.fromJS(item));
        }
        if (Array.isArray(_data['spouseDetails'])) {
          this.spouseDetails = [] as any;
          for (let item of _data['spouseDetails']) this.spouseDetails!.push(AppFormBankingInfoDetailDto.fromJS(item));
        }
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
      }
    }

    static fromJS(data: any): AppFormBankingInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormBankingInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['isMarried'] = this.isMarried;
      if (Array.isArray(this.details)) {
        data['details'] = [];
        for (let item of this.details) data['details'].push(item.toJSON());
      }
      if (Array.isArray(this.spouseDetails)) {
        data['spouseDetails'] = [];
        for (let item of this.spouseDetails) data['spouseDetails'].push(item.toJSON());
      }
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      return data;
    }
  }

  export interface IAppFormBankingInfoDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    details?: AppFormBankingInfoDetailDto[] | undefined;
    spouseDetails?: AppFormBankingInfoDetailDto[] | undefined;
    documentIds?: string[] | undefined;
  }

  export class AppFormIncomeExpenseExpenseDetailDto implements IAppFormIncomeExpenseExpenseDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    clientUpdatedFields?: AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.isInitial = _data['isInitial'];
        this.expenseTypeId = _data['expenseTypeId'];
        this.expenseDescriptionId = _data['expenseDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.applicantAmount = _data['applicantAmount'];
        this.spouseAmount = _data['spouseAmount'];
        this.otherHouseholdMemberAmount = _data['otherHouseholdMemberAmount'];
        this.isSupportingDocumentsIncomplete = _data['isSupportingDocumentsIncomplete'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseExpenseDetailDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['isInitial'] = this.isInitial;
      data['expenseTypeId'] = this.expenseTypeId;
      data['expenseDescriptionId'] = this.expenseDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['applicantAmount'] = this.applicantAmount;
      data['spouseAmount'] = this.spouseAmount;
      data['otherHouseholdMemberAmount'] = this.otherHouseholdMemberAmount;
      data['isSupportingDocumentsIncomplete'] = this.isSupportingDocumentsIncomplete;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseExpenseDetailDto {
    id?: string;
    isInitial?: boolean;
    expenseTypeId?: string | undefined;
    expenseDescriptionId?: string | undefined;
    specifiedDescription?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    clientUpdatedFields?: AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto;
  }

  export class AppFormIncomeExpenseExpenseDetailListItem implements IAppFormIncomeExpenseExpenseDetailListItem {
    id?: string;
    expenseType?: LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    expenseDescription?: LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailListItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.expenseType = _data['expenseType']
          ? LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              _data['expenseType']
            )
          : <any>undefined;
        this.expenseDescription = _data['expenseDescription']
          ? LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              _data['expenseDescription']
            )
          : <any>undefined;
        this.specifiedDescription = _data['specifiedDescription'];
        this.amount = _data['amount'];
        this.isSupportingDocumentsIncomplete = _data['isSupportingDocumentsIncomplete'];
        this.updatedByClient = _data['updatedByClient'];
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailListItem {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseExpenseDetailListItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['expenseType'] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
      data['expenseDescription'] = this.expenseDescription ? this.expenseDescription.toJSON() : <any>undefined;
      data['specifiedDescription'] = this.specifiedDescription;
      data['amount'] = this.amount;
      data['isSupportingDocumentsIncomplete'] = this.isSupportingDocumentsIncomplete;
      data['updatedByClient'] = this.updatedByClient;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseExpenseDetailListItem {
    id?: string;
    expenseType?: LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    expenseDescription?: LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    specifiedDescription?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;
  }

  export class AppFormIncomeExpenseExpenseDto implements IAppFormIncomeExpenseExpenseDto {
    fileId?: string;
    isMarried?: boolean;
    documentIds?: string[] | undefined;
    expenseDetails?: AppFormIncomeExpenseExpenseDetailDto[] | undefined;

    constructor(data?: IAppFormIncomeExpenseExpenseDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.isMarried = _data['isMarried'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        if (Array.isArray(_data['expenseDetails'])) {
          this.expenseDetails = [] as any;
          for (let item of _data['expenseDetails'])
            this.expenseDetails!.push(AppFormIncomeExpenseExpenseDetailDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseExpenseDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['isMarried'] = this.isMarried;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      if (Array.isArray(this.expenseDetails)) {
        data['expenseDetails'] = [];
        for (let item of this.expenseDetails) data['expenseDetails'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IAppFormIncomeExpenseExpenseDto {
    fileId?: string;
    isMarried?: boolean;
    documentIds?: string[] | undefined;
    expenseDetails?: AppFormIncomeExpenseExpenseDetailDto[] | undefined;
  }

  export class AppFormIncomeExpenseIncomeDetailDto implements IAppFormIncomeExpenseIncomeDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    clientUpdatedFields?: AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.isInitial = _data['isInitial'];
        this.incomeTypeId = _data['incomeTypeId'];
        this.description = _data['description'];
        this.applicantAmount = _data['applicantAmount'];
        this.spouseAmount = _data['spouseAmount'];
        this.otherHouseholdMemberAmount = _data['otherHouseholdMemberAmount'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseIncomeDetailDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['isInitial'] = this.isInitial;
      data['incomeTypeId'] = this.incomeTypeId;
      data['description'] = this.description;
      data['applicantAmount'] = this.applicantAmount;
      data['spouseAmount'] = this.spouseAmount;
      data['otherHouseholdMemberAmount'] = this.otherHouseholdMemberAmount;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseIncomeDetailDto {
    id?: string;
    isInitial?: boolean;
    incomeTypeId?: string | undefined;
    description?: string | undefined;
    applicantAmount?: number | undefined;
    spouseAmount?: number | undefined;
    otherHouseholdMemberAmount?: number | undefined;
    clientUpdatedFields?: AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto;
  }

  export class AppFormIncomeExpenseIncomeDetailListItem implements IAppFormIncomeExpenseIncomeDetailListItem {
    id?: string;
    incomeType?: LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    description?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailListItem) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.incomeType = _data['incomeType']
          ? LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              _data['incomeType']
            )
          : <any>undefined;
        this.description = _data['description'];
        this.amount = _data['amount'];
        this.isSupportingDocumentsIncomplete = _data['isSupportingDocumentsIncomplete'];
        this.updatedByClient = _data['updatedByClient'];
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailListItem {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseIncomeDetailListItem();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['incomeType'] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
      data['description'] = this.description;
      data['amount'] = this.amount;
      data['isSupportingDocumentsIncomplete'] = this.isSupportingDocumentsIncomplete;
      data['updatedByClient'] = this.updatedByClient;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseIncomeDetailListItem {
    id?: string;
    incomeType?: LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null;
    description?: string | undefined;
    amount?: number | undefined;
    isSupportingDocumentsIncomplete?: boolean;
    updatedByClient?: boolean;
  }

  export class AppFormIncomeExpenseIncomeDto implements IAppFormIncomeExpenseIncomeDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    documentIds?: string[] | undefined;
    incomeDetails?: AppFormIncomeExpenseIncomeDetailDto[] | undefined;

    constructor(data?: IAppFormIncomeExpenseIncomeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.isMarried = _data['isMarried'];
        this.isSpouseRefusedToProvideIncomeData = _data['isSpouseRefusedToProvideIncomeData'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        if (Array.isArray(_data['incomeDetails'])) {
          this.incomeDetails = [] as any;
          for (let item of _data['incomeDetails'])
            this.incomeDetails!.push(AppFormIncomeExpenseIncomeDetailDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseIncomeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['isMarried'] = this.isMarried;
      data['isSpouseRefusedToProvideIncomeData'] = this.isSpouseRefusedToProvideIncomeData;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      if (Array.isArray(this.incomeDetails)) {
        data['incomeDetails'] = [];
        for (let item of this.incomeDetails) data['incomeDetails'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IAppFormIncomeExpenseIncomeDto {
    fileId?: string;
    isMarried?: boolean;
    isSpouseRefusedToProvideIncomeData?: boolean;
    documentIds?: string[] | undefined;
    incomeDetails?: AppFormIncomeExpenseIncomeDetailDto[] | undefined;
  }

  export class AppFormIncomeTaxDto implements IAppFormIncomeTaxDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    yearLastReturnFiled?: moment.Moment | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: moment.Moment | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormIncomeTaxUpdatedFieldsDto;

    constructor(data?: IAppFormIncomeTaxDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.isMarried = _data['isMarried'];
        this.yearLastReturnFiled = _data['yearLastReturnFiled']
          ? moment(_data['yearLastReturnFiled'].toString())
          : <any>undefined;
        this.refundAmount = _data['refundAmount'];
        this.amountOwing = _data['amountOwing'];
        this.spouseYearLastReturnFiled = _data['spouseYearLastReturnFiled']
          ? moment(_data['spouseYearLastReturnFiled'].toString())
          : <any>undefined;
        this.spouseRefundAmount = _data['spouseRefundAmount'];
        this.spouseAmountOwing = _data['spouseAmountOwing'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormIncomeTaxUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormIncomeTaxDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeTaxDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['isMarried'] = this.isMarried;
      data['yearLastReturnFiled'] = this.yearLastReturnFiled ? this.yearLastReturnFiled.toISOString() : <any>undefined;
      data['refundAmount'] = this.refundAmount;
      data['amountOwing'] = this.amountOwing;
      data['spouseYearLastReturnFiled'] = this.spouseYearLastReturnFiled
        ? this.spouseYearLastReturnFiled.toISOString()
        : <any>undefined;
      data['spouseRefundAmount'] = this.spouseRefundAmount;
      data['spouseAmountOwing'] = this.spouseAmountOwing;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormIncomeTaxDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    yearLastReturnFiled?: moment.Moment | undefined;
    refundAmount?: number | undefined;
    amountOwing?: number | undefined;
    spouseYearLastReturnFiled?: moment.Moment | undefined;
    spouseRefundAmount?: number | undefined;
    spouseAmountOwing?: number | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormIncomeTaxUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoAlternatePhoneDto implements IAppFormPersonalInfoAlternatePhoneDto {
    id?: string;
    phoneTypeId?: string | undefined;
    phoneNumber?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoAlternatePhoneDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.phoneTypeId = _data['phoneTypeId'];
        this.phoneNumber = _data['phoneNumber'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoAlternatePhoneDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoAlternatePhoneDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['phoneTypeId'] = this.phoneTypeId;
      data['phoneNumber'] = this.phoneNumber;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoAlternatePhoneDto {
    id?: string;
    phoneTypeId?: string | undefined;
    phoneNumber?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoDependantDto implements IAppFormPersonalInfoDependantDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationshipTypeId?: string | undefined;
    birthDate?: moment.Moment | undefined;
    isSameAsApplicantsContactInfo?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoDependantUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoDependantDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.firstName = _data['firstName'];
        this.lastName = _data['lastName'];
        this.relationshipTypeId = _data['relationshipTypeId'];
        this.birthDate = _data['birthDate'] ? moment(_data['birthDate'].toString()) : <any>undefined;
        this.isSameAsApplicantsContactInfo = _data['isSameAsApplicantsContactInfo'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoDependantUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoDependantDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoDependantDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['firstName'] = this.firstName;
      data['lastName'] = this.lastName;
      data['relationshipTypeId'] = this.relationshipTypeId;
      data['birthDate'] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
      data['isSameAsApplicantsContactInfo'] = this.isSameAsApplicantsContactInfo;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoDependantDto {
    id?: string;
    firstName?: string | undefined;
    lastName?: string | undefined;
    relationshipTypeId?: string | undefined;
    birthDate?: moment.Moment | undefined;
    isSameAsApplicantsContactInfo?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoDependantUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoDto implements IAppFormPersonalInfoDto {
    id?: string;
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    akaFirstName?: string | undefined;
    akaMiddleName?: string | undefined;
    akaLastName?: string | undefined;
    birthDate?: moment.Moment | undefined;
    sin?: string | undefined;
    maritalStatusId?: string | undefined;
    marriageDate?: moment.Moment | undefined;
    educationLevelId?: string | undefined;
    spouseFirstName?: string | undefined;
    spouseMiddleName?: string | undefined;
    spouseLastName?: string | undefined;
    spouseAkaFirstName?: string | undefined;
    spouseAkaMiddleName?: string | undefined;
    spouseAkaLastName?: string | undefined;
    spouseBirthDate?: moment.Moment | undefined;
    spouseSIN?: string | undefined;
    spouseEducationLevelId?: string | undefined;
    isJointFile?: boolean;
    additionalNotes?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    residenceDate?: moment.Moment | undefined;
    previousAddresses?: AppFormPersonalInfoPreviousAddressDto[] | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    alternatePhones?: AppFormPersonalInfoAlternatePhoneDto[] | undefined;
    emailAddress?: string | undefined;
    isSpouseAddressSame?: boolean;
    spouseAddress?: string | undefined;
    spouseStreetNumber?: string | undefined;
    spouseStreetName?: string | undefined;
    spouseUnit?: string | undefined;
    spouseCity?: string | undefined;
    spousePostalCode?: string | undefined;
    spouseProvinceId?: string | undefined;
    spouseCountryId?: string | undefined;
    spouseResidenceDate?: moment.Moment | undefined;
    spouseMainPhoneTypeId?: string | undefined;
    spouseMainPhoneNumber?: string | undefined;
    spouseEmailAddress?: string | undefined;
    isEmployedPastTwoYears?: boolean | undefined;
    employmentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    employmentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    isSpouseEmployedPastTwoYears?: boolean | undefined;
    spouseEmploymentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    spouseEmploymentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: string | undefined;
    reasonForNeedingFinancialHelp?: string | undefined;
    numberOfPersonsInHousehold?: number | undefined;
    hasDependants?: boolean | undefined;
    dependants?: AppFormPersonalInfoDependantDto[] | undefined;
    hasPreviousInsolvency?: boolean | undefined;
    previousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    hasSpousePreviousInsolvency?: boolean | undefined;
    spousePreviousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormPersonalInfoUpdatedFieldsDto;
    isPersoanlDetailUpdatedByClient?: boolean | undefined;
    isContactInformationUpdatedByClient?: boolean | undefined;
    isEmploymentUpdatedByClient?: boolean | undefined;
    isFinancialDifficultyByClient?: boolean | undefined;
    isFinancialDifficultyByClientSpouse?: boolean | undefined;
    isDependantsUpdatedByClient?: boolean | undefined;
    isPreviousInsolvencyUpdatedByClient?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    specifyFDReasonLegalMatters?: string | undefined;
    hasFDReasonLossOfIncome?: boolean;
    hasFDReasonMedicalReasons?: boolean;
    hasFDReasonTaxLiabilities?: boolean;
    hasFDReasonFinancialSupportOfOthers?: boolean;
    hasFDReasonStudentDebt?: boolean;
    hasFDReasonMovingOrRelocationExpenses?: boolean;
    hasFDReasonFailedProposal?: boolean;
    hasFDReasonFinancialMismanagement?: boolean;
    spouseHasFDReasonLossOfIncome?: boolean | undefined;
    spouseHasFDReasonMedicalReasons?: boolean | undefined;
    spouseHasFDReasonBusinessFailure?: boolean | undefined;
    spouseHasFDReasonGambling?: boolean | undefined;
    spouseHasFDReasonDrugAlcoholAddicition?: boolean | undefined;
    spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean | undefined;
    spouseHasFDReasonTaxLiabilities?: boolean | undefined;
    spouseHasFDReasonFinancialSupportOfOthers?: boolean | undefined;
    spouseHasFDReasonStudentDebt?: boolean | undefined;
    spouseHasFDReasonLitigationIssues?: boolean | undefined;
    spouseHasFDReasonMovingOrRelocationExpenses?: boolean | undefined;
    spouseHasFDReasonFailedProposal?: boolean | undefined;
    spouseHasFDReasonFinancialMismanagement?: boolean | undefined;
    spouseHasFDReasonOther?: boolean | undefined;
    spouseSpecifyFDReasonLegalMatters?: string | undefined;
    spouseSpecifiedFDReason?: string | undefined;
    spouseReasonForNeedingFinancialHelp?: string | undefined;
    isSelfIdentificationUpdatedByClient?: boolean | undefined;
    consentToSelfIdentification?: boolean | undefined;
    consentToSelfIdentificationSpouse?: boolean | undefined;
    selfIdentifications?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
    selfIdentificationsSpouse?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;

    constructor(data?: IAppFormPersonalInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.akaFirstName = _data['akaFirstName'];
        this.akaMiddleName = _data['akaMiddleName'];
        this.akaLastName = _data['akaLastName'];
        this.birthDate = _data['birthDate'] ? moment(_data['birthDate'].toString()) : <any>undefined;
        this.sin = _data['sin'];
        this.maritalStatusId = _data['maritalStatusId'];
        this.marriageDate = _data['marriageDate'] ? moment(_data['marriageDate'].toString()) : <any>undefined;
        this.educationLevelId = _data['educationLevelId'];
        this.spouseFirstName = _data['spouseFirstName'];
        this.spouseMiddleName = _data['spouseMiddleName'];
        this.spouseLastName = _data['spouseLastName'];
        this.spouseAkaFirstName = _data['spouseAkaFirstName'];
        this.spouseAkaMiddleName = _data['spouseAkaMiddleName'];
        this.spouseAkaLastName = _data['spouseAkaLastName'];
        this.spouseBirthDate = _data['spouseBirthDate'] ? moment(_data['spouseBirthDate'].toString()) : <any>undefined;
        this.spouseSIN = _data['spouseSIN'];
        this.spouseEducationLevelId = _data['spouseEducationLevelId'];
        this.isJointFile = _data['isJointFile'];
        this.additionalNotes = _data['additionalNotes'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.cityTypeId = _data['cityTypeId'];
        this.postalCode = _data['postalCode'];
        this.provinceCode = _data['provinceCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.residenceDate = _data['residenceDate'] ? moment(_data['residenceDate'].toString()) : <any>undefined;
        if (Array.isArray(_data['previousAddresses'])) {
          this.previousAddresses = [] as any;
          for (let item of _data['previousAddresses'])
            this.previousAddresses!.push(AppFormPersonalInfoPreviousAddressDto.fromJS(item));
        }
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
        if (Array.isArray(_data['alternatePhones'])) {
          this.alternatePhones = [] as any;
          for (let item of _data['alternatePhones'])
            this.alternatePhones!.push(AppFormPersonalInfoAlternatePhoneDto.fromJS(item));
        }
        this.emailAddress = _data['emailAddress'];
        this.isSpouseAddressSame = _data['isSpouseAddressSame'];
        this.spouseAddress = _data['spouseAddress'];
        this.spouseStreetNumber = _data['spouseStreetNumber'];
        this.spouseStreetName = _data['spouseStreetName'];
        this.spouseUnit = _data['spouseUnit'];
        this.spouseCity = _data['spouseCity'];
        this.spousePostalCode = _data['spousePostalCode'];
        this.spouseProvinceId = _data['spouseProvinceId'];
        this.spouseCountryId = _data['spouseCountryId'];
        this.spouseResidenceDate = _data['spouseResidenceDate']
          ? moment(_data['spouseResidenceDate'].toString())
          : <any>undefined;
        this.spouseMainPhoneTypeId = _data['spouseMainPhoneTypeId'];
        this.spouseMainPhoneNumber = _data['spouseMainPhoneNumber'];
        this.spouseEmailAddress = _data['spouseEmailAddress'];
        this.isEmployedPastTwoYears = _data['isEmployedPastTwoYears'];
        if (Array.isArray(_data['employmentDetails'])) {
          this.employmentDetails = [] as any;
          for (let item of _data['employmentDetails'])
            this.employmentDetails!.push(AppFormPersonalInfoEmploymentDetailDto.fromJS(item));
        }
        this.isReceivedEmploymentInsurancePastTwoYears = _data['isReceivedEmploymentInsurancePastTwoYears'];
        if (Array.isArray(_data['employmentInsurancePeriods'])) {
          this.employmentInsurancePeriods = [] as any;
          for (let item of _data['employmentInsurancePeriods'])
            this.employmentInsurancePeriods!.push(AppFormPersonalInfoEmploymentInsurancePeriodDto.fromJS(item));
        }
        this.isSpouseEmployedPastTwoYears = _data['isSpouseEmployedPastTwoYears'];
        if (Array.isArray(_data['spouseEmploymentDetails'])) {
          this.spouseEmploymentDetails = [] as any;
          for (let item of _data['spouseEmploymentDetails'])
            this.spouseEmploymentDetails!.push(AppFormPersonalInfoEmploymentDetailDto.fromJS(item));
        }
        this.isSpouseReceivedEmploymentInsurancePastTwoYears = _data['isSpouseReceivedEmploymentInsurancePastTwoYears'];
        if (Array.isArray(_data['spouseEmploymentInsurancePeriods'])) {
          this.spouseEmploymentInsurancePeriods = [] as any;
          for (let item of _data['spouseEmploymentInsurancePeriods'])
            this.spouseEmploymentInsurancePeriods!.push(AppFormPersonalInfoEmploymentInsurancePeriodDto.fromJS(item));
        }
        this.hasFDReasonBusinessFailure = _data['hasFDReasonBusinessFailure'];
        this.hasFDReasonMaritalSeparationOrRelationshipBreakdown =
          _data['hasFDReasonMaritalSeparationOrRelationshipBreakdown'];
        this.hasFDReasonGambling = _data['hasFDReasonGambling'];
        this.hasFDReasonLitigationIssues = _data['hasFDReasonLitigationIssues'];
        this.hasFDReasonDrugAlcoholAddicition = _data['hasFDReasonDrugAlcoholAddicition'];
        this.hasFDReasonOther = _data['hasFDReasonOther'];
        this.specifiedFDReason = _data['specifiedFDReason'];
        this.reasonForNeedingFinancialHelp = _data['reasonForNeedingFinancialHelp'];
        this.numberOfPersonsInHousehold = _data['numberOfPersonsInHousehold'];
        this.hasDependants = _data['hasDependants'];
        if (Array.isArray(_data['dependants'])) {
          this.dependants = [] as any;
          for (let item of _data['dependants']) this.dependants!.push(AppFormPersonalInfoDependantDto.fromJS(item));
        }
        this.hasPreviousInsolvency = _data['hasPreviousInsolvency'];
        if (Array.isArray(_data['previousInsolvencies'])) {
          this.previousInsolvencies = [] as any;
          for (let item of _data['previousInsolvencies'])
            this.previousInsolvencies!.push(AppFormPersonalInfoPreviousInsolvencyDto.fromJS(item));
        }
        this.hasSpousePreviousInsolvency = _data['hasSpousePreviousInsolvency'];
        if (Array.isArray(_data['spousePreviousInsolvencies'])) {
          this.spousePreviousInsolvencies = [] as any;
          for (let item of _data['spousePreviousInsolvencies'])
            this.spousePreviousInsolvencies!.push(AppFormPersonalInfoPreviousInsolvencyDto.fromJS(item));
        }
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
        this.isPersoanlDetailUpdatedByClient = _data['isPersoanlDetailUpdatedByClient'];
        this.isContactInformationUpdatedByClient = _data['isContactInformationUpdatedByClient'];
        this.isEmploymentUpdatedByClient = _data['isEmploymentUpdatedByClient'];
        this.isFinancialDifficultyByClient = _data['isFinancialDifficultyByClient'];
        this.isFinancialDifficultyByClientSpouse = _data['isFinancialDifficultyByClientSpouse'];
        this.isDependantsUpdatedByClient = _data['isDependantsUpdatedByClient'];
        this.isPreviousInsolvencyUpdatedByClient = _data['isPreviousInsolvencyUpdatedByClient'];
        this.isRegisteredToClientPortal = _data['isRegisteredToClientPortal'];
        this.specifyFDReasonLegalMatters = _data['specifyFDReasonLegalMatters'];
        this.hasFDReasonLossOfIncome = _data['hasFDReasonLossOfIncome'];
        this.hasFDReasonMedicalReasons = _data['hasFDReasonMedicalReasons'];
        this.hasFDReasonTaxLiabilities = _data['hasFDReasonTaxLiabilities'];
        this.hasFDReasonFinancialSupportOfOthers = _data['hasFDReasonFinancialSupportOfOthers'];
        this.hasFDReasonStudentDebt = _data['hasFDReasonStudentDebt'];
        this.hasFDReasonMovingOrRelocationExpenses = _data['hasFDReasonMovingOrRelocationExpenses'];
        this.hasFDReasonFailedProposal = _data['hasFDReasonFailedProposal'];
        this.hasFDReasonFinancialMismanagement = _data['hasFDReasonFinancialMismanagement'];
        this.spouseHasFDReasonLossOfIncome = _data['spouseHasFDReasonLossOfIncome'];
        this.spouseHasFDReasonMedicalReasons = _data['spouseHasFDReasonMedicalReasons'];
        this.spouseHasFDReasonBusinessFailure = _data['spouseHasFDReasonBusinessFailure'];
        this.spouseHasFDReasonGambling = _data['spouseHasFDReasonGambling'];
        this.spouseHasFDReasonDrugAlcoholAddicition = _data['spouseHasFDReasonDrugAlcoholAddicition'];
        this.spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown =
          _data['spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown'];
        this.spouseHasFDReasonTaxLiabilities = _data['spouseHasFDReasonTaxLiabilities'];
        this.spouseHasFDReasonFinancialSupportOfOthers = _data['spouseHasFDReasonFinancialSupportOfOthers'];
        this.spouseHasFDReasonStudentDebt = _data['spouseHasFDReasonStudentDebt'];
        this.spouseHasFDReasonLitigationIssues = _data['spouseHasFDReasonLitigationIssues'];
        this.spouseHasFDReasonMovingOrRelocationExpenses = _data['spouseHasFDReasonMovingOrRelocationExpenses'];
        this.spouseHasFDReasonFailedProposal = _data['spouseHasFDReasonFailedProposal'];
        this.spouseHasFDReasonFinancialMismanagement = _data['spouseHasFDReasonFinancialMismanagement'];
        this.spouseHasFDReasonOther = _data['spouseHasFDReasonOther'];
        this.spouseSpecifyFDReasonLegalMatters = _data['spouseSpecifyFDReasonLegalMatters'];
        this.spouseSpecifiedFDReason = _data['spouseSpecifiedFDReason'];
        this.spouseReasonForNeedingFinancialHelp = _data['spouseReasonForNeedingFinancialHelp'];
        this.isSelfIdentificationUpdatedByClient = _data['isSelfIdentificationUpdatedByClient'];
        this.consentToSelfIdentification = _data['consentToSelfIdentification'];
        this.consentToSelfIdentificationSpouse = _data['consentToSelfIdentificationSpouse'];
        if (Array.isArray(_data['selfIdentifications'])) {
          this.selfIdentifications = [] as any;
          for (let item of _data['selfIdentifications'])
            this.selfIdentifications!.push(AppFormPersonalInfoSelfIdentificationDto.fromJS(item));
        }
        if (Array.isArray(_data['selfIdentificationsSpouse'])) {
          this.selfIdentificationsSpouse = [] as any;
          for (let item of _data['selfIdentificationsSpouse'])
            this.selfIdentificationsSpouse!.push(AppFormPersonalInfoSelfIdentificationDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): AppFormPersonalInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['akaFirstName'] = this.akaFirstName;
      data['akaMiddleName'] = this.akaMiddleName;
      data['akaLastName'] = this.akaLastName;
      data['birthDate'] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
      data['sin'] = this.sin;
      data['maritalStatusId'] = this.maritalStatusId;
      data['marriageDate'] = this.marriageDate ? this.marriageDate.toISOString() : <any>undefined;
      data['educationLevelId'] = this.educationLevelId;
      data['spouseFirstName'] = this.spouseFirstName;
      data['spouseMiddleName'] = this.spouseMiddleName;
      data['spouseLastName'] = this.spouseLastName;
      data['spouseAkaFirstName'] = this.spouseAkaFirstName;
      data['spouseAkaMiddleName'] = this.spouseAkaMiddleName;
      data['spouseAkaLastName'] = this.spouseAkaLastName;
      data['spouseBirthDate'] = this.spouseBirthDate ? this.spouseBirthDate.toISOString() : <any>undefined;
      data['spouseSIN'] = this.spouseSIN;
      data['spouseEducationLevelId'] = this.spouseEducationLevelId;
      data['isJointFile'] = this.isJointFile;
      data['additionalNotes'] = this.additionalNotes;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['cityTypeId'] = this.cityTypeId;
      data['postalCode'] = this.postalCode;
      data['provinceCode'] = this.provinceCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['residenceDate'] = this.residenceDate ? this.residenceDate.toISOString() : <any>undefined;
      if (Array.isArray(this.previousAddresses)) {
        data['previousAddresses'] = [];
        for (let item of this.previousAddresses) data['previousAddresses'].push(item.toJSON());
      }
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      if (Array.isArray(this.alternatePhones)) {
        data['alternatePhones'] = [];
        for (let item of this.alternatePhones) data['alternatePhones'].push(item.toJSON());
      }
      data['emailAddress'] = this.emailAddress;
      data['isSpouseAddressSame'] = this.isSpouseAddressSame;
      data['spouseAddress'] = this.spouseAddress;
      data['spouseStreetNumber'] = this.spouseStreetNumber;
      data['spouseStreetName'] = this.spouseStreetName;
      data['spouseUnit'] = this.spouseUnit;
      data['spouseCity'] = this.spouseCity;
      data['spousePostalCode'] = this.spousePostalCode;
      data['spouseProvinceId'] = this.spouseProvinceId;
      data['spouseCountryId'] = this.spouseCountryId;
      data['spouseResidenceDate'] = this.spouseResidenceDate ? this.spouseResidenceDate.toISOString() : <any>undefined;
      data['spouseMainPhoneTypeId'] = this.spouseMainPhoneTypeId;
      data['spouseMainPhoneNumber'] = this.spouseMainPhoneNumber;
      data['spouseEmailAddress'] = this.spouseEmailAddress;
      data['isEmployedPastTwoYears'] = this.isEmployedPastTwoYears;
      if (Array.isArray(this.employmentDetails)) {
        data['employmentDetails'] = [];
        for (let item of this.employmentDetails) data['employmentDetails'].push(item.toJSON());
      }
      data['isReceivedEmploymentInsurancePastTwoYears'] = this.isReceivedEmploymentInsurancePastTwoYears;
      if (Array.isArray(this.employmentInsurancePeriods)) {
        data['employmentInsurancePeriods'] = [];
        for (let item of this.employmentInsurancePeriods) data['employmentInsurancePeriods'].push(item.toJSON());
      }
      data['isSpouseEmployedPastTwoYears'] = this.isSpouseEmployedPastTwoYears;
      if (Array.isArray(this.spouseEmploymentDetails)) {
        data['spouseEmploymentDetails'] = [];
        for (let item of this.spouseEmploymentDetails) data['spouseEmploymentDetails'].push(item.toJSON());
      }
      data['isSpouseReceivedEmploymentInsurancePastTwoYears'] = this.isSpouseReceivedEmploymentInsurancePastTwoYears;
      if (Array.isArray(this.spouseEmploymentInsurancePeriods)) {
        data['spouseEmploymentInsurancePeriods'] = [];
        for (let item of this.spouseEmploymentInsurancePeriods)
          data['spouseEmploymentInsurancePeriods'].push(item.toJSON());
      }
      data['hasFDReasonBusinessFailure'] = this.hasFDReasonBusinessFailure;
      data['hasFDReasonMaritalSeparationOrRelationshipBreakdown'] =
        this.hasFDReasonMaritalSeparationOrRelationshipBreakdown;
      data['hasFDReasonGambling'] = this.hasFDReasonGambling;
      data['hasFDReasonLitigationIssues'] = this.hasFDReasonLitigationIssues;
      data['hasFDReasonDrugAlcoholAddicition'] = this.hasFDReasonDrugAlcoholAddicition;
      data['hasFDReasonOther'] = this.hasFDReasonOther;
      data['specifiedFDReason'] = this.specifiedFDReason;
      data['reasonForNeedingFinancialHelp'] = this.reasonForNeedingFinancialHelp;
      data['numberOfPersonsInHousehold'] = this.numberOfPersonsInHousehold;
      data['hasDependants'] = this.hasDependants;
      if (Array.isArray(this.dependants)) {
        data['dependants'] = [];
        for (let item of this.dependants) data['dependants'].push(item.toJSON());
      }
      data['hasPreviousInsolvency'] = this.hasPreviousInsolvency;
      if (Array.isArray(this.previousInsolvencies)) {
        data['previousInsolvencies'] = [];
        for (let item of this.previousInsolvencies) data['previousInsolvencies'].push(item.toJSON());
      }
      data['hasSpousePreviousInsolvency'] = this.hasSpousePreviousInsolvency;
      if (Array.isArray(this.spousePreviousInsolvencies)) {
        data['spousePreviousInsolvencies'] = [];
        for (let item of this.spousePreviousInsolvencies) data['spousePreviousInsolvencies'].push(item.toJSON());
      }
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      data['isPersoanlDetailUpdatedByClient'] = this.isPersoanlDetailUpdatedByClient;
      data['isContactInformationUpdatedByClient'] = this.isContactInformationUpdatedByClient;
      data['isEmploymentUpdatedByClient'] = this.isEmploymentUpdatedByClient;
      data['isFinancialDifficultyByClient'] = this.isFinancialDifficultyByClient;
      data['isFinancialDifficultyByClientSpouse'] = this.isFinancialDifficultyByClientSpouse;
      data['isDependantsUpdatedByClient'] = this.isDependantsUpdatedByClient;
      data['isPreviousInsolvencyUpdatedByClient'] = this.isPreviousInsolvencyUpdatedByClient;
      data['isRegisteredToClientPortal'] = this.isRegisteredToClientPortal;
      data['specifyFDReasonLegalMatters'] = this.specifyFDReasonLegalMatters;
      data['hasFDReasonLossOfIncome'] = this.hasFDReasonLossOfIncome;
      data['hasFDReasonMedicalReasons'] = this.hasFDReasonMedicalReasons;
      data['hasFDReasonTaxLiabilities'] = this.hasFDReasonTaxLiabilities;
      data['hasFDReasonFinancialSupportOfOthers'] = this.hasFDReasonFinancialSupportOfOthers;
      data['hasFDReasonStudentDebt'] = this.hasFDReasonStudentDebt;
      data['hasFDReasonMovingOrRelocationExpenses'] = this.hasFDReasonMovingOrRelocationExpenses;
      data['hasFDReasonFailedProposal'] = this.hasFDReasonFailedProposal;
      data['hasFDReasonFinancialMismanagement'] = this.hasFDReasonFinancialMismanagement;
      data['spouseHasFDReasonLossOfIncome'] = this.spouseHasFDReasonLossOfIncome;
      data['spouseHasFDReasonMedicalReasons'] = this.spouseHasFDReasonMedicalReasons;
      data['spouseHasFDReasonBusinessFailure'] = this.spouseHasFDReasonBusinessFailure;
      data['spouseHasFDReasonGambling'] = this.spouseHasFDReasonGambling;
      data['spouseHasFDReasonDrugAlcoholAddicition'] = this.spouseHasFDReasonDrugAlcoholAddicition;
      data['spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown'] =
        this.spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown;
      data['spouseHasFDReasonTaxLiabilities'] = this.spouseHasFDReasonTaxLiabilities;
      data['spouseHasFDReasonFinancialSupportOfOthers'] = this.spouseHasFDReasonFinancialSupportOfOthers;
      data['spouseHasFDReasonStudentDebt'] = this.spouseHasFDReasonStudentDebt;
      data['spouseHasFDReasonLitigationIssues'] = this.spouseHasFDReasonLitigationIssues;
      data['spouseHasFDReasonMovingOrRelocationExpenses'] = this.spouseHasFDReasonMovingOrRelocationExpenses;
      data['spouseHasFDReasonFailedProposal'] = this.spouseHasFDReasonFailedProposal;
      data['spouseHasFDReasonFinancialMismanagement'] = this.spouseHasFDReasonFinancialMismanagement;
      data['spouseHasFDReasonOther'] = this.spouseHasFDReasonOther;
      data['spouseSpecifyFDReasonLegalMatters'] = this.spouseSpecifyFDReasonLegalMatters;
      data['spouseSpecifiedFDReason'] = this.spouseSpecifiedFDReason;
      data['spouseReasonForNeedingFinancialHelp'] = this.spouseReasonForNeedingFinancialHelp;
      data['isSelfIdentificationUpdatedByClient'] = this.isSelfIdentificationUpdatedByClient;
      data['consentToSelfIdentification'] = this.consentToSelfIdentification;
      data['consentToSelfIdentificationSpouse'] = this.consentToSelfIdentificationSpouse;
      if (Array.isArray(this.selfIdentifications)) {
        data['selfIdentifications'] = [];
        for (let item of this.selfIdentifications) data['selfIdentifications'].push(item.toJSON());
      }
      if (Array.isArray(this.selfIdentificationsSpouse)) {
        data['selfIdentificationsSpouse'] = [];
        for (let item of this.selfIdentificationsSpouse) data['selfIdentificationsSpouse'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IAppFormPersonalInfoDto {
    id?: string;
    fileId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    akaFirstName?: string | undefined;
    akaMiddleName?: string | undefined;
    akaLastName?: string | undefined;
    birthDate?: moment.Moment | undefined;
    sin?: string | undefined;
    maritalStatusId?: string | undefined;
    marriageDate?: moment.Moment | undefined;
    educationLevelId?: string | undefined;
    spouseFirstName?: string | undefined;
    spouseMiddleName?: string | undefined;
    spouseLastName?: string | undefined;
    spouseAkaFirstName?: string | undefined;
    spouseAkaMiddleName?: string | undefined;
    spouseAkaLastName?: string | undefined;
    spouseBirthDate?: moment.Moment | undefined;
    spouseSIN?: string | undefined;
    spouseEducationLevelId?: string | undefined;
    isJointFile?: boolean;
    additionalNotes?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    residenceDate?: moment.Moment | undefined;
    previousAddresses?: AppFormPersonalInfoPreviousAddressDto[] | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    alternatePhones?: AppFormPersonalInfoAlternatePhoneDto[] | undefined;
    emailAddress?: string | undefined;
    isSpouseAddressSame?: boolean;
    spouseAddress?: string | undefined;
    spouseStreetNumber?: string | undefined;
    spouseStreetName?: string | undefined;
    spouseUnit?: string | undefined;
    spouseCity?: string | undefined;
    spousePostalCode?: string | undefined;
    spouseProvinceId?: string | undefined;
    spouseCountryId?: string | undefined;
    spouseResidenceDate?: moment.Moment | undefined;
    spouseMainPhoneTypeId?: string | undefined;
    spouseMainPhoneNumber?: string | undefined;
    spouseEmailAddress?: string | undefined;
    isEmployedPastTwoYears?: boolean | undefined;
    employmentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    employmentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    isSpouseEmployedPastTwoYears?: boolean | undefined;
    spouseEmploymentDetails?: AppFormPersonalInfoEmploymentDetailDto[] | undefined;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean | undefined;
    spouseEmploymentInsurancePeriods?: AppFormPersonalInfoEmploymentInsurancePeriodDto[] | undefined;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: string | undefined;
    reasonForNeedingFinancialHelp?: string | undefined;
    numberOfPersonsInHousehold?: number | undefined;
    hasDependants?: boolean | undefined;
    dependants?: AppFormPersonalInfoDependantDto[] | undefined;
    hasPreviousInsolvency?: boolean | undefined;
    previousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    hasSpousePreviousInsolvency?: boolean | undefined;
    spousePreviousInsolvencies?: AppFormPersonalInfoPreviousInsolvencyDto[] | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormPersonalInfoUpdatedFieldsDto;
    isPersoanlDetailUpdatedByClient?: boolean | undefined;
    isContactInformationUpdatedByClient?: boolean | undefined;
    isEmploymentUpdatedByClient?: boolean | undefined;
    isFinancialDifficultyByClient?: boolean | undefined;
    isFinancialDifficultyByClientSpouse?: boolean | undefined;
    isDependantsUpdatedByClient?: boolean | undefined;
    isPreviousInsolvencyUpdatedByClient?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    specifyFDReasonLegalMatters?: string | undefined;
    hasFDReasonLossOfIncome?: boolean;
    hasFDReasonMedicalReasons?: boolean;
    hasFDReasonTaxLiabilities?: boolean;
    hasFDReasonFinancialSupportOfOthers?: boolean;
    hasFDReasonStudentDebt?: boolean;
    hasFDReasonMovingOrRelocationExpenses?: boolean;
    hasFDReasonFailedProposal?: boolean;
    hasFDReasonFinancialMismanagement?: boolean;
    spouseHasFDReasonLossOfIncome?: boolean | undefined;
    spouseHasFDReasonMedicalReasons?: boolean | undefined;
    spouseHasFDReasonBusinessFailure?: boolean | undefined;
    spouseHasFDReasonGambling?: boolean | undefined;
    spouseHasFDReasonDrugAlcoholAddicition?: boolean | undefined;
    spouseHasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean | undefined;
    spouseHasFDReasonTaxLiabilities?: boolean | undefined;
    spouseHasFDReasonFinancialSupportOfOthers?: boolean | undefined;
    spouseHasFDReasonStudentDebt?: boolean | undefined;
    spouseHasFDReasonLitigationIssues?: boolean | undefined;
    spouseHasFDReasonMovingOrRelocationExpenses?: boolean | undefined;
    spouseHasFDReasonFailedProposal?: boolean | undefined;
    spouseHasFDReasonFinancialMismanagement?: boolean | undefined;
    spouseHasFDReasonOther?: boolean | undefined;
    spouseSpecifyFDReasonLegalMatters?: string | undefined;
    spouseSpecifiedFDReason?: string | undefined;
    spouseReasonForNeedingFinancialHelp?: string | undefined;
    isSelfIdentificationUpdatedByClient?: boolean | undefined;
    consentToSelfIdentification?: boolean | undefined;
    consentToSelfIdentificationSpouse?: boolean | undefined;
    selfIdentifications?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
    selfIdentificationsSpouse?: AppFormPersonalInfoSelfIdentificationDto[] | undefined;
  }

  export class AppFormPersonalInfoEmploymentDetailDto implements IAppFormPersonalInfoEmploymentDetailDto {
    id?: string;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerStreetNumber?: string | undefined;
    employerStreetName?: string | undefined;
    employerUnit?: string | undefined;
    employerCity?: string | undefined;
    employerPostalCode?: string | undefined;
    employerProvinceId?: string | undefined;
    employerCountryId?: string | undefined;
    occupationName?: string | undefined;
    industryId?: string | undefined;
    employmentStatusId?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentEmployer?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoEmploymentDetailDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.employerName = _data['employerName'];
        this.employerAddress = _data['employerAddress'];
        this.employerStreetNumber = _data['employerStreetNumber'];
        this.employerStreetName = _data['employerStreetName'];
        this.employerUnit = _data['employerUnit'];
        this.employerCity = _data['employerCity'];
        this.employerPostalCode = _data['employerPostalCode'];
        this.employerProvinceId = _data['employerProvinceId'];
        this.employerCountryId = _data['employerCountryId'];
        this.occupationName = _data['occupationName'];
        this.industryId = _data['industryId'];
        this.employmentStatusId = _data['employmentStatusId'];
        this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
        this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
        this.isCurrentEmployer = _data['isCurrentEmployer'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentDetailDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoEmploymentDetailDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['employerName'] = this.employerName;
      data['employerAddress'] = this.employerAddress;
      data['employerStreetNumber'] = this.employerStreetNumber;
      data['employerStreetName'] = this.employerStreetName;
      data['employerUnit'] = this.employerUnit;
      data['employerCity'] = this.employerCity;
      data['employerPostalCode'] = this.employerPostalCode;
      data['employerProvinceId'] = this.employerProvinceId;
      data['employerCountryId'] = this.employerCountryId;
      data['occupationName'] = this.occupationName;
      data['industryId'] = this.industryId;
      data['employmentStatusId'] = this.employmentStatusId;
      data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
      data['isCurrentEmployer'] = this.isCurrentEmployer;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoEmploymentDetailDto {
    id?: string;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerStreetNumber?: string | undefined;
    employerStreetName?: string | undefined;
    employerUnit?: string | undefined;
    employerCity?: string | undefined;
    employerPostalCode?: string | undefined;
    employerProvinceId?: string | undefined;
    employerCountryId?: string | undefined;
    occupationName?: string | undefined;
    industryId?: string | undefined;
    employmentStatusId?: string | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentEmployer?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoEmploymentInsurancePeriodDto
    implements IAppFormPersonalInfoEmploymentInsurancePeriodDto
  {
    id?: string;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentPeriod?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoEmploymentInsurancePeriodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
        this.endDate = _data['endDate'] ? moment(_data['endDate'].toString()) : <any>undefined;
        this.isCurrentPeriod = _data['isCurrentPeriod'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentInsurancePeriodDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoEmploymentInsurancePeriodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
      data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
      data['isCurrentPeriod'] = this.isCurrentPeriod;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoEmploymentInsurancePeriodDto {
    id?: string;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    isCurrentPeriod?: boolean;
    clientUpdatedFields?: AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoPreviousAddressDto implements IAppFormPersonalInfoPreviousAddressDto {
    id?: string;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousAddressUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoPreviousAddressDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoPreviousAddressUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousAddressDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoPreviousAddressDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoPreviousAddressDto {
    id?: string;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousAddressUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoPreviousInsolvencyDto implements IAppFormPersonalInfoPreviousInsolvencyDto {
    id?: string;
    insolvencyTypeId?: string | undefined;
    applicantName?: string | undefined;
    trusteeName?: string | undefined;
    estateNumber?: string | undefined;
    bankruptcyDate?: moment.Moment | undefined;
    dischargeDate?: moment.Moment | undefined;
    proposalDate?: moment.Moment | undefined;
    proposalResultId?: string | undefined;
    filingLocation?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    bankruptcyDischargeTypeId?: string | undefined;
    proposalDischargeDate?: moment.Moment | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto;

    constructor(data?: IAppFormPersonalInfoPreviousInsolvencyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.insolvencyTypeId = _data['insolvencyTypeId'];
        this.applicantName = _data['applicantName'];
        this.trusteeName = _data['trusteeName'];
        this.estateNumber = _data['estateNumber'];
        this.bankruptcyDate = _data['bankruptcyDate'] ? moment(_data['bankruptcyDate'].toString()) : <any>undefined;
        this.dischargeDate = _data['dischargeDate'] ? moment(_data['dischargeDate'].toString()) : <any>undefined;
        this.proposalDate = _data['proposalDate'] ? moment(_data['proposalDate'].toString()) : <any>undefined;
        this.proposalResultId = _data['proposalResultId'];
        this.filingLocation = _data['filingLocation'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.bankruptcyDischargeTypeId = _data['bankruptcyDischargeTypeId'];
        this.proposalDischargeDate = _data['proposalDischargeDate']
          ? moment(_data['proposalDischargeDate'].toString())
          : <any>undefined;
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousInsolvencyDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoPreviousInsolvencyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['insolvencyTypeId'] = this.insolvencyTypeId;
      data['applicantName'] = this.applicantName;
      data['trusteeName'] = this.trusteeName;
      data['estateNumber'] = this.estateNumber;
      data['bankruptcyDate'] = this.bankruptcyDate ? this.bankruptcyDate.toISOString() : <any>undefined;
      data['dischargeDate'] = this.dischargeDate ? this.dischargeDate.toISOString() : <any>undefined;
      data['proposalDate'] = this.proposalDate ? this.proposalDate.toISOString() : <any>undefined;
      data['proposalResultId'] = this.proposalResultId;
      data['filingLocation'] = this.filingLocation;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['bankruptcyDischargeTypeId'] = this.bankruptcyDischargeTypeId;
      data['proposalDischargeDate'] = this.proposalDischargeDate
        ? this.proposalDischargeDate.toISOString()
        : <any>undefined;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormPersonalInfoPreviousInsolvencyDto {
    id?: string;
    insolvencyTypeId?: string | undefined;
    applicantName?: string | undefined;
    trusteeName?: string | undefined;
    estateNumber?: string | undefined;
    bankruptcyDate?: moment.Moment | undefined;
    dischargeDate?: moment.Moment | undefined;
    proposalDate?: moment.Moment | undefined;
    proposalResultId?: string | undefined;
    filingLocation?: string | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    bankruptcyDischargeTypeId?: string | undefined;
    proposalDischargeDate?: moment.Moment | undefined;
    clientUpdatedFields?: AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto;
  }

  export class AppFormPersonalInfoSelfIdentificationDto implements IAppFormPersonalInfoSelfIdentificationDto {
    id?: string;
    appFormPersonalInfoId?: string;
    isForSpouse?: boolean;
    genderId?: string | undefined;
    educationLevelId?: string | undefined;
    isAboriginal?: AnswerEnum;
    isNorthAmericanIndianFirstNation?: boolean;
    isInuit?: boolean;
    isMétis?: boolean;
    hasDisability?: AnswerEnum;
    hasDisabilityCoordinationOrDexterity?: boolean;
    hasDisabilityMobility?: boolean;
    hasDisabilityBlindOrVisualImpairment?: boolean;
    hasDisabilityDeafOrHardOfHearing?: boolean;
    hasDisabilitySpeechImpairment?: boolean;
    hasDisabilityOther?: boolean;
    disabilityOtherDescription?: string | undefined;
    isMemberOfMinorityGroup?: AnswerEnum;
    isBlack?: boolean;
    isChinese?: boolean;
    isFilipino?: boolean;
    isJapanese?: boolean;
    isKorean?: boolean;
    isSouthAsianEastIndian?: boolean;
    isSoutheastAsian?: boolean;
    isNonWhiteWestAsianNorthAfricanOrArab?: boolean;
    isNonWhiteLatinAmerican?: boolean;
    isPersonOfMixedOrigin?: boolean;
    isOtherVisibleMinorityGroup?: boolean;
    otherVisibleMinorityGroupDescription?: string | undefined;
    consentDate?: moment.Moment | undefined;
    consentCity?: string | undefined;
    consentProvinceId?: string | undefined;

    constructor(data?: IAppFormPersonalInfoSelfIdentificationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.appFormPersonalInfoId = _data['appFormPersonalInfoId'];
        this.isForSpouse = _data['isForSpouse'];
        this.genderId = _data['genderId'];
        this.educationLevelId = _data['educationLevelId'];
        this.isAboriginal = _data['isAboriginal'];
        this.isNorthAmericanIndianFirstNation = _data['isNorthAmericanIndianFirstNation'];
        this.isInuit = _data['isInuit'];
        this.isMétis = _data['isMétis'];
        this.hasDisability = _data['hasDisability'];
        this.hasDisabilityCoordinationOrDexterity = _data['hasDisabilityCoordinationOrDexterity'];
        this.hasDisabilityMobility = _data['hasDisabilityMobility'];
        this.hasDisabilityBlindOrVisualImpairment = _data['hasDisabilityBlindOrVisualImpairment'];
        this.hasDisabilityDeafOrHardOfHearing = _data['hasDisabilityDeafOrHardOfHearing'];
        this.hasDisabilitySpeechImpairment = _data['hasDisabilitySpeechImpairment'];
        this.hasDisabilityOther = _data['hasDisabilityOther'];
        this.disabilityOtherDescription = _data['disabilityOtherDescription'];
        this.isMemberOfMinorityGroup = _data['isMemberOfMinorityGroup'];
        this.isBlack = _data['isBlack'];
        this.isChinese = _data['isChinese'];
        this.isFilipino = _data['isFilipino'];
        this.isJapanese = _data['isJapanese'];
        this.isKorean = _data['isKorean'];
        this.isSouthAsianEastIndian = _data['isSouthAsianEastIndian'];
        this.isSoutheastAsian = _data['isSoutheastAsian'];
        this.isNonWhiteWestAsianNorthAfricanOrArab = _data['isNonWhiteWestAsianNorthAfricanOrArab'];
        this.isNonWhiteLatinAmerican = _data['isNonWhiteLatinAmerican'];
        this.isPersonOfMixedOrigin = _data['isPersonOfMixedOrigin'];
        this.isOtherVisibleMinorityGroup = _data['isOtherVisibleMinorityGroup'];
        this.otherVisibleMinorityGroupDescription = _data['otherVisibleMinorityGroupDescription'];
        this.consentDate = _data['consentDate'] ? moment(_data['consentDate'].toString()) : <any>undefined;
        this.consentCity = _data['consentCity'];
        this.consentProvinceId = _data['consentProvinceId'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoSelfIdentificationDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoSelfIdentificationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['appFormPersonalInfoId'] = this.appFormPersonalInfoId;
      data['isForSpouse'] = this.isForSpouse;
      data['genderId'] = this.genderId;
      data['educationLevelId'] = this.educationLevelId;
      data['isAboriginal'] = this.isAboriginal;
      data['isNorthAmericanIndianFirstNation'] = this.isNorthAmericanIndianFirstNation;
      data['isInuit'] = this.isInuit;
      data['isMétis'] = this.isMétis;
      data['hasDisability'] = this.hasDisability;
      data['hasDisabilityCoordinationOrDexterity'] = this.hasDisabilityCoordinationOrDexterity;
      data['hasDisabilityMobility'] = this.hasDisabilityMobility;
      data['hasDisabilityBlindOrVisualImpairment'] = this.hasDisabilityBlindOrVisualImpairment;
      data['hasDisabilityDeafOrHardOfHearing'] = this.hasDisabilityDeafOrHardOfHearing;
      data['hasDisabilitySpeechImpairment'] = this.hasDisabilitySpeechImpairment;
      data['hasDisabilityOther'] = this.hasDisabilityOther;
      data['disabilityOtherDescription'] = this.disabilityOtherDescription;
      data['isMemberOfMinorityGroup'] = this.isMemberOfMinorityGroup;
      data['isBlack'] = this.isBlack;
      data['isChinese'] = this.isChinese;
      data['isFilipino'] = this.isFilipino;
      data['isJapanese'] = this.isJapanese;
      data['isKorean'] = this.isKorean;
      data['isSouthAsianEastIndian'] = this.isSouthAsianEastIndian;
      data['isSoutheastAsian'] = this.isSoutheastAsian;
      data['isNonWhiteWestAsianNorthAfricanOrArab'] = this.isNonWhiteWestAsianNorthAfricanOrArab;
      data['isNonWhiteLatinAmerican'] = this.isNonWhiteLatinAmerican;
      data['isPersonOfMixedOrigin'] = this.isPersonOfMixedOrigin;
      data['isOtherVisibleMinorityGroup'] = this.isOtherVisibleMinorityGroup;
      data['otherVisibleMinorityGroupDescription'] = this.otherVisibleMinorityGroupDescription;
      data['consentDate'] = this.consentDate ? this.consentDate.toISOString() : <any>undefined;
      data['consentCity'] = this.consentCity;
      data['consentProvinceId'] = this.consentProvinceId;
      return data;
    }
  }

  export interface IAppFormPersonalInfoSelfIdentificationDto {
    id?: string;
    appFormPersonalInfoId?: string;
    isForSpouse?: boolean;
    genderId?: string | undefined;
    educationLevelId?: string | undefined;
    isAboriginal?: AnswerEnum;
    isNorthAmericanIndianFirstNation?: boolean;
    isInuit?: boolean;
    isMétis?: boolean;
    hasDisability?: AnswerEnum;
    hasDisabilityCoordinationOrDexterity?: boolean;
    hasDisabilityMobility?: boolean;
    hasDisabilityBlindOrVisualImpairment?: boolean;
    hasDisabilityDeafOrHardOfHearing?: boolean;
    hasDisabilitySpeechImpairment?: boolean;
    hasDisabilityOther?: boolean;
    disabilityOtherDescription?: string | undefined;
    isMemberOfMinorityGroup?: AnswerEnum;
    isBlack?: boolean;
    isChinese?: boolean;
    isFilipino?: boolean;
    isJapanese?: boolean;
    isKorean?: boolean;
    isSouthAsianEastIndian?: boolean;
    isSoutheastAsian?: boolean;
    isNonWhiteWestAsianNorthAfricanOrArab?: boolean;
    isNonWhiteLatinAmerican?: boolean;
    isPersonOfMixedOrigin?: boolean;
    isOtherVisibleMinorityGroup?: boolean;
    otherVisibleMinorityGroupDescription?: string | undefined;
    consentDate?: moment.Moment | undefined;
    consentCity?: string | undefined;
    consentProvinceId?: string | undefined;
  }

  export class AppFormQuestionnaireBusinessDto implements IAppFormQuestionnaireBusinessDto {
    id?: string;
    businessName?: string | undefined;
    businessAddress?: string | undefined;
    businessStreetNumber?: string | undefined;
    businessStreetName?: string | undefined;
    businessUnit?: string | undefined;
    businessCity?: string | undefined;
    businessPostalCode?: string | undefined;
    businessProvinceId?: string | undefined;
    businessCountryId?: string | undefined;
    businessOwnershipTypeId?: string | undefined;
    businessTypeId?: string | undefined;
    isDirector?: boolean | undefined;
    nameOfPartnersOrDirectors?: string | undefined;
    startDate?: moment.Moment | undefined;
    dateOperationsCeased?: moment.Moment | undefined;
    isCorporationBankrupt?: boolean | undefined;
    hasEmployeesOrSubContractors?: boolean | undefined;
    isOwingWagesToEmployees?: boolean | undefined;
    isOwingSourceDeductionOnWages?: boolean | undefined;
    otherDetails?: string | undefined;
    maximumNumberOfEmployeesInThePast12Months?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireBusinessUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireBusinessDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.businessName = _data['businessName'];
        this.businessAddress = _data['businessAddress'];
        this.businessStreetNumber = _data['businessStreetNumber'];
        this.businessStreetName = _data['businessStreetName'];
        this.businessUnit = _data['businessUnit'];
        this.businessCity = _data['businessCity'];
        this.businessPostalCode = _data['businessPostalCode'];
        this.businessProvinceId = _data['businessProvinceId'];
        this.businessCountryId = _data['businessCountryId'];
        this.businessOwnershipTypeId = _data['businessOwnershipTypeId'];
        this.businessTypeId = _data['businessTypeId'];
        this.isDirector = _data['isDirector'];
        this.nameOfPartnersOrDirectors = _data['nameOfPartnersOrDirectors'];
        this.startDate = _data['startDate'] ? moment(_data['startDate'].toString()) : <any>undefined;
        this.dateOperationsCeased = _data['dateOperationsCeased']
          ? moment(_data['dateOperationsCeased'].toString())
          : <any>undefined;
        this.isCorporationBankrupt = _data['isCorporationBankrupt'];
        this.hasEmployeesOrSubContractors = _data['hasEmployeesOrSubContractors'];
        this.isOwingWagesToEmployees = _data['isOwingWagesToEmployees'];
        this.isOwingSourceDeductionOnWages = _data['isOwingSourceDeductionOnWages'];
        this.otherDetails = _data['otherDetails'];
        this.maximumNumberOfEmployeesInThePast12Months = _data['maximumNumberOfEmployeesInThePast12Months'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormQuestionnaireBusinessUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormQuestionnaireBusinessDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireBusinessDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['businessName'] = this.businessName;
      data['businessAddress'] = this.businessAddress;
      data['businessStreetNumber'] = this.businessStreetNumber;
      data['businessStreetName'] = this.businessStreetName;
      data['businessUnit'] = this.businessUnit;
      data['businessCity'] = this.businessCity;
      data['businessPostalCode'] = this.businessPostalCode;
      data['businessProvinceId'] = this.businessProvinceId;
      data['businessCountryId'] = this.businessCountryId;
      data['businessOwnershipTypeId'] = this.businessOwnershipTypeId;
      data['businessTypeId'] = this.businessTypeId;
      data['isDirector'] = this.isDirector;
      data['nameOfPartnersOrDirectors'] = this.nameOfPartnersOrDirectors;
      data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
      data['dateOperationsCeased'] = this.dateOperationsCeased
        ? this.dateOperationsCeased.toISOString()
        : <any>undefined;
      data['isCorporationBankrupt'] = this.isCorporationBankrupt;
      data['hasEmployeesOrSubContractors'] = this.hasEmployeesOrSubContractors;
      data['isOwingWagesToEmployees'] = this.isOwingWagesToEmployees;
      data['isOwingSourceDeductionOnWages'] = this.isOwingSourceDeductionOnWages;
      data['otherDetails'] = this.otherDetails;
      data['maximumNumberOfEmployeesInThePast12Months'] = this.maximumNumberOfEmployeesInThePast12Months;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormQuestionnaireBusinessDto {
    id?: string;
    businessName?: string | undefined;
    businessAddress?: string | undefined;
    businessStreetNumber?: string | undefined;
    businessStreetName?: string | undefined;
    businessUnit?: string | undefined;
    businessCity?: string | undefined;
    businessPostalCode?: string | undefined;
    businessProvinceId?: string | undefined;
    businessCountryId?: string | undefined;
    businessOwnershipTypeId?: string | undefined;
    businessTypeId?: string | undefined;
    isDirector?: boolean | undefined;
    nameOfPartnersOrDirectors?: string | undefined;
    startDate?: moment.Moment | undefined;
    dateOperationsCeased?: moment.Moment | undefined;
    isCorporationBankrupt?: boolean | undefined;
    hasEmployeesOrSubContractors?: boolean | undefined;
    isOwingWagesToEmployees?: boolean | undefined;
    isOwingSourceDeductionOnWages?: boolean | undefined;
    otherDetails?: string | undefined;
    maximumNumberOfEmployeesInThePast12Months?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireBusinessUpdatedFieldsDto;
  }

  export class AppFormQuestionnaireCoSignOrGuaranteedLoanDto implements IAppFormQuestionnaireCoSignOrGuaranteedLoanDto {
    id?: string;
    isBySpouse?: boolean;
    lendersName?: string | undefined;
    lendersAddress?: string | undefined;
    lendersStreetNumber?: string | undefined;
    lendersStreetName?: string | undefined;
    lendersUnit?: string | undefined;
    lendersCity?: string | undefined;
    lendersPostalCode?: string | undefined;
    lendersProvinceId?: string | undefined;
    lendersCountryId?: string | undefined;
    borrowersName?: string | undefined;
    borrowersAddress?: string | undefined;
    borrowersStreetNumber?: string | undefined;
    borrowersStreetName?: string | undefined;
    borrowersUnit?: string | undefined;
    borrowersCity?: string | undefined;
    borrowersPostalCode?: string | undefined;
    borrowersProvinceId?: string | undefined;
    borrowersCountryId?: string | undefined;
    clientUpdatedFields?: AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireCoSignOrGuaranteedLoanDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.isBySpouse = _data['isBySpouse'];
        this.lendersName = _data['lendersName'];
        this.lendersAddress = _data['lendersAddress'];
        this.lendersStreetNumber = _data['lendersStreetNumber'];
        this.lendersStreetName = _data['lendersStreetName'];
        this.lendersUnit = _data['lendersUnit'];
        this.lendersCity = _data['lendersCity'];
        this.lendersPostalCode = _data['lendersPostalCode'];
        this.lendersProvinceId = _data['lendersProvinceId'];
        this.lendersCountryId = _data['lendersCountryId'];
        this.borrowersName = _data['borrowersName'];
        this.borrowersAddress = _data['borrowersAddress'];
        this.borrowersStreetNumber = _data['borrowersStreetNumber'];
        this.borrowersStreetName = _data['borrowersStreetName'];
        this.borrowersUnit = _data['borrowersUnit'];
        this.borrowersCity = _data['borrowersCity'];
        this.borrowersPostalCode = _data['borrowersPostalCode'];
        this.borrowersProvinceId = _data['borrowersProvinceId'];
        this.borrowersCountryId = _data['borrowersCountryId'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormQuestionnaireCoSignOrGuaranteedLoanDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireCoSignOrGuaranteedLoanDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['isBySpouse'] = this.isBySpouse;
      data['lendersName'] = this.lendersName;
      data['lendersAddress'] = this.lendersAddress;
      data['lendersStreetNumber'] = this.lendersStreetNumber;
      data['lendersStreetName'] = this.lendersStreetName;
      data['lendersUnit'] = this.lendersUnit;
      data['lendersCity'] = this.lendersCity;
      data['lendersPostalCode'] = this.lendersPostalCode;
      data['lendersProvinceId'] = this.lendersProvinceId;
      data['lendersCountryId'] = this.lendersCountryId;
      data['borrowersName'] = this.borrowersName;
      data['borrowersAddress'] = this.borrowersAddress;
      data['borrowersStreetNumber'] = this.borrowersStreetNumber;
      data['borrowersStreetName'] = this.borrowersStreetName;
      data['borrowersUnit'] = this.borrowersUnit;
      data['borrowersCity'] = this.borrowersCity;
      data['borrowersPostalCode'] = this.borrowersPostalCode;
      data['borrowersProvinceId'] = this.borrowersProvinceId;
      data['borrowersCountryId'] = this.borrowersCountryId;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormQuestionnaireCoSignOrGuaranteedLoanDto {
    id?: string;
    isBySpouse?: boolean;
    lendersName?: string | undefined;
    lendersAddress?: string | undefined;
    lendersStreetNumber?: string | undefined;
    lendersStreetName?: string | undefined;
    lendersUnit?: string | undefined;
    lendersCity?: string | undefined;
    lendersPostalCode?: string | undefined;
    lendersProvinceId?: string | undefined;
    lendersCountryId?: string | undefined;
    borrowersName?: string | undefined;
    borrowersAddress?: string | undefined;
    borrowersStreetNumber?: string | undefined;
    borrowersStreetName?: string | undefined;
    borrowersUnit?: string | undefined;
    borrowersCity?: string | undefined;
    borrowersPostalCode?: string | undefined;
    borrowersProvinceId?: string | undefined;
    borrowersCountryId?: string | undefined;
    clientUpdatedFields?: AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto;
  }

  export class AppFormQuestionnaireDto implements IAppFormQuestionnaireDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    debtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isDebtFromRecognizanceOfBailBond?: boolean | undefined;
    debtFromRecognizanceOfBailBondDetails?: string | undefined;
    isDebtFromAlimony?: boolean | undefined;
    debtFromAlimonyDetails?: string | undefined;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    debtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isDebtFromFraud?: boolean | undefined;
    debtFromFraudDetails?: string | undefined;
    isDebtFromEmbezzlement?: boolean | undefined;
    debtFromEmbezzlementDetails?: string | undefined;
    isDebtFromMisappropriation?: boolean | undefined;
    debtFromMisappropriationDetails?: string | undefined;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isDebtFromStudentLoansOutstanding?: boolean | undefined;
    debtFromStudentLoansOutstandingDetails?: string | undefined;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean | undefined;
    spouseDebtFromRecognizanceOfBailBondDetails?: string | undefined;
    isSpouseDebtFromAlimony?: boolean | undefined;
    spouseDebtFromAlimonyDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isSpouseDebtFromFraud?: boolean | undefined;
    spouseDebtFromFraudDetails?: string | undefined;
    isSpouseDebtFromEmbezzlement?: boolean | undefined;
    spouseDebtFromEmbezzlementDetails?: string | undefined;
    isSpouseDebtFromMisappropriation?: boolean | undefined;
    spouseDebtFromMisappropriationDetails?: string | undefined;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isSpouseDebtFromStudentLoansOutstanding?: boolean | undefined;
    spouseDebtFromStudentLoansOutstandingDetails?: string | undefined;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    hasCoSignedOrGuaranteedLoan?: boolean | undefined;
    coSignedOrGuaranteedLoans?: AppFormQuestionnaireCoSignOrGuaranteedLoanDto[] | undefined;
    hasMadeExessPaymentsPast12Months?: boolean | undefined;
    hasMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasSpouseMadeExessPaymentsPast12Months?: boolean | undefined;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasOwnedBusinessPast5Years?: boolean | undefined;
    doesBusinessAccountForHalfOfDebt?: boolean | undefined;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean | undefined;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean | undefined;
    spouseNAICSCode?: string | undefined;
    businesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    spouseBusinesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    debtorHasAFinancialAdviceProvider?: boolean | undefined;
    debtorSpouseHasAFinancialAdviceProvider?: boolean | undefined;
    financialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    spouseFinancialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    isConsentChecked?: boolean | undefined;
    consentDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormQuestionnaireUpdatedFieldsDto;
    isDebtAreasApplicantUpdatedByClient?: boolean | undefined;
    isDebtAreasSpouseUpdatedByClient?: boolean | undefined;
    isCoSignsGuaranteedLoansUpdatedByClient?: boolean | undefined;
    isTransactionsApplicantUpdatedByClient?: boolean | undefined;
    isTransactionsSpouseUpdatedByClient?: boolean | undefined;
    isBusinessUpdatedByClient?: boolean | undefined;
    isCreditBureauConsentUpdatedByClient?: boolean | undefined;
    isAdviceReceivedApplicantUpdatedByClient?: boolean | undefined;

    constructor(data?: IAppFormQuestionnaireDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.fileId = _data['fileId'];
        this.isMarried = _data['isMarried'];
        this.isDebtFromFineOrPenaltyImposedByCourt = _data['isDebtFromFineOrPenaltyImposedByCourt'];
        this.debtFromFineOrPenaltyImposedByCourtDetails = _data['debtFromFineOrPenaltyImposedByCourtDetails'];
        this.isDebtFromRecognizanceOfBailBond = _data['isDebtFromRecognizanceOfBailBond'];
        this.debtFromRecognizanceOfBailBondDetails = _data['debtFromRecognizanceOfBailBondDetails'];
        this.isDebtFromAlimony = _data['isDebtFromAlimony'];
        this.debtFromAlimonyDetails = _data['debtFromAlimonyDetails'];
        this.isDebtFromMaintenanceOfAffiliationOrder = _data['isDebtFromMaintenanceOfAffiliationOrder'];
        this.debtFromMaintenanceOfAffiliationOrderDetails = _data['debtFromMaintenanceOfAffiliationOrderDetails'];
        this.isDebtFromMaintenanceOfSupportOfSeparatedFamily = _data['isDebtFromMaintenanceOfSupportOfSeparatedFamily'];
        this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails =
          _data['debtFromMaintenanceOfSupportOfSeparatedFamilyDetails'];
        this.isDebtFromFraud = _data['isDebtFromFraud'];
        this.debtFromFraudDetails = _data['debtFromFraudDetails'];
        this.isDebtFromEmbezzlement = _data['isDebtFromEmbezzlement'];
        this.debtFromEmbezzlementDetails = _data['debtFromEmbezzlementDetails'];
        this.isDebtFromMisappropriation = _data['isDebtFromMisappropriation'];
        this.debtFromMisappropriationDetails = _data['debtFromMisappropriationDetails'];
        this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity =
          _data['isDebtFromDefalcationWhileActingInAFiduciaryCapacity'];
        this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails =
          _data['debtFromDefalcationWhileActingInAFiduciaryCapacityDetails'];
        this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud =
          _data['isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'];
        this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails =
          _data['debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'];
        this.isDebtFromStudentLoansOutstanding = _data['isDebtFromStudentLoansOutstanding'];
        this.debtFromStudentLoansOutstandingDetails = _data['debtFromStudentLoansOutstandingDetails'];
        this.debtFromStudentLoansOutstandingDateCeasedBeingStudent = _data[
          'debtFromStudentLoansOutstandingDateCeasedBeingStudent'
        ]
          ? moment(_data['debtFromStudentLoansOutstandingDateCeasedBeingStudent'].toString())
          : <any>undefined;
        this.isSpouseDebtFromFineOrPenaltyImposedByCourt = _data['isSpouseDebtFromFineOrPenaltyImposedByCourt'];
        this.spouseDebtFromFineOrPenaltyImposedByCourtDetails =
          _data['spouseDebtFromFineOrPenaltyImposedByCourtDetails'];
        this.isSpouseDebtFromRecognizanceOfBailBond = _data['isSpouseDebtFromRecognizanceOfBailBond'];
        this.spouseDebtFromRecognizanceOfBailBondDetails = _data['spouseDebtFromRecognizanceOfBailBondDetails'];
        this.isSpouseDebtFromAlimony = _data['isSpouseDebtFromAlimony'];
        this.spouseDebtFromAlimonyDetails = _data['spouseDebtFromAlimonyDetails'];
        this.isSpouseDebtFromMaintenanceOfAffiliationOrder = _data['isSpouseDebtFromMaintenanceOfAffiliationOrder'];
        this.spouseDebtFromMaintenanceOfAffiliationOrderDetails =
          _data['spouseDebtFromMaintenanceOfAffiliationOrderDetails'];
        this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily =
          _data['isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily'];
        this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails =
          _data['spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails'];
        this.isSpouseDebtFromFraud = _data['isSpouseDebtFromFraud'];
        this.spouseDebtFromFraudDetails = _data['spouseDebtFromFraudDetails'];
        this.isSpouseDebtFromEmbezzlement = _data['isSpouseDebtFromEmbezzlement'];
        this.spouseDebtFromEmbezzlementDetails = _data['spouseDebtFromEmbezzlementDetails'];
        this.isSpouseDebtFromMisappropriation = _data['isSpouseDebtFromMisappropriation'];
        this.spouseDebtFromMisappropriationDetails = _data['spouseDebtFromMisappropriationDetails'];
        this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity =
          _data['isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity'];
        this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails =
          _data['spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails'];
        this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud =
          _data['isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'];
        this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails =
          _data['spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'];
        this.isSpouseDebtFromStudentLoansOutstanding = _data['isSpouseDebtFromStudentLoansOutstanding'];
        this.spouseDebtFromStudentLoansOutstandingDetails = _data['spouseDebtFromStudentLoansOutstandingDetails'];
        this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent = _data[
          'spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent'
        ]
          ? moment(_data['spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent'].toString())
          : <any>undefined;
        this.hasCoSignedOrGuaranteedLoan = _data['hasCoSignedOrGuaranteedLoan'];
        if (Array.isArray(_data['coSignedOrGuaranteedLoans'])) {
          this.coSignedOrGuaranteedLoans = [] as any;
          for (let item of _data['coSignedOrGuaranteedLoans'])
            this.coSignedOrGuaranteedLoans!.push(AppFormQuestionnaireCoSignOrGuaranteedLoanDto.fromJS(item));
        }
        this.hasMadeExessPaymentsPast12Months = _data['hasMadeExessPaymentsPast12Months'];
        this.hasMadeExessPaymentsPast12MonthsDetails = _data['hasMadeExessPaymentsPast12MonthsDetails'];
        this.hasAssetsSiezedOrGarnishedPast12Months = _data['hasAssetsSiezedOrGarnishedPast12Months'];
        this.hasAssetsSiezedOrGarnishedPast12MonthsDetail = _data['hasAssetsSiezedOrGarnishedPast12MonthsDetail'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'];
        this.hasGivenGiftsOver500WhileInsolventPast5Years = _data['hasGivenGiftsOver500WhileInsolventPast5Years'];
        this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails =
          _data['hasGivenGiftsOver500WhileInsolventPast5YearsDetails'];
        this.isExpectedToReceiveNonIncomeFundsNext12Months = _data['isExpectedToReceiveNonIncomeFundsNext12Months'];
        this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails =
          _data['isExpectedToReceiveNonIncomeFundsNext12MonthsDetails'];
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty =
          _data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'];
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails =
          _data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'];
        this.hasMadeArragementsToContinuePayingCreditors = _data['hasMadeArragementsToContinuePayingCreditors'];
        this.hasMadeArragementsToContinuePayingCreditorsDetails =
          _data['hasMadeArragementsToContinuePayingCreditorsDetails'];
        this.hasSpouseMadeExessPaymentsPast12Months = _data['hasSpouseMadeExessPaymentsPast12Months'];
        this.hasSpouseMadeExessPaymentsPast12MonthsDetails = _data['hasSpouseMadeExessPaymentsPast12MonthsDetails'];
        this.hasSpouseAssetsSiezedOrGarnishedPast12Months = _data['hasSpouseAssetsSiezedOrGarnishedPast12Months'];
        this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail =
          _data['hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'];
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years =
          _data['hasSpouseGivenGiftsOver500WhileInsolventPast5Years'];
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails =
          _data['hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails'];
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months =
          _data['isSpouseExpectedToReceiveNonIncomeFundsNext12Months'];
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails =
          _data['isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails'];
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty =
          _data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'];
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails =
          _data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'];
        this.hasSpouseMadeArragementsToContinuePayingCreditors =
          _data['hasSpouseMadeArragementsToContinuePayingCreditors'];
        this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails =
          _data['hasSpouseMadeArragementsToContinuePayingCreditorsDetails'];
        this.hasOwnedBusinessPast5Years = _data['hasOwnedBusinessPast5Years'];
        this.doesBusinessAccountForHalfOfDebt = _data['doesBusinessAccountForHalfOfDebt'];
        this.naicsCode = _data['naicsCode'];
        this.hasSpouseOwnedBusinessPast5Years = _data['hasSpouseOwnedBusinessPast5Years'];
        this.doesSpouseBusinessAccountForHalfOfDebt = _data['doesSpouseBusinessAccountForHalfOfDebt'];
        this.spouseNAICSCode = _data['spouseNAICSCode'];
        if (Array.isArray(_data['businesses'])) {
          this.businesses = [] as any;
          for (let item of _data['businesses']) this.businesses!.push(AppFormQuestionnaireBusinessDto.fromJS(item));
        }
        if (Array.isArray(_data['spouseBusinesses'])) {
          this.spouseBusinesses = [] as any;
          for (let item of _data['spouseBusinesses'])
            this.spouseBusinesses!.push(AppFormQuestionnaireBusinessDto.fromJS(item));
        }
        this.debtorHasAFinancialAdviceProvider = _data['debtorHasAFinancialAdviceProvider'];
        this.debtorSpouseHasAFinancialAdviceProvider = _data['debtorSpouseHasAFinancialAdviceProvider'];
        if (Array.isArray(_data['financialAdvices'])) {
          this.financialAdvices = [] as any;
          for (let item of _data['financialAdvices'])
            this.financialAdvices!.push(AppFormQuestionnaireFinancialAdviceProviderDto.fromJS(item));
        }
        if (Array.isArray(_data['spouseFinancialAdvices'])) {
          this.spouseFinancialAdvices = [] as any;
          for (let item of _data['spouseFinancialAdvices'])
            this.spouseFinancialAdvices!.push(AppFormQuestionnaireFinancialAdviceProviderDto.fromJS(item));
        }
        this.isConsentChecked = _data['isConsentChecked'];
        this.consentDate = _data['consentDate'] ? moment(_data['consentDate'].toString()) : <any>undefined;
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormQuestionnaireUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
        this.isDebtAreasApplicantUpdatedByClient = _data['isDebtAreasApplicantUpdatedByClient'];
        this.isDebtAreasSpouseUpdatedByClient = _data['isDebtAreasSpouseUpdatedByClient'];
        this.isCoSignsGuaranteedLoansUpdatedByClient = _data['isCoSignsGuaranteedLoansUpdatedByClient'];
        this.isTransactionsApplicantUpdatedByClient = _data['isTransactionsApplicantUpdatedByClient'];
        this.isTransactionsSpouseUpdatedByClient = _data['isTransactionsSpouseUpdatedByClient'];
        this.isBusinessUpdatedByClient = _data['isBusinessUpdatedByClient'];
        this.isCreditBureauConsentUpdatedByClient = _data['isCreditBureauConsentUpdatedByClient'];
        this.isAdviceReceivedApplicantUpdatedByClient = _data['isAdviceReceivedApplicantUpdatedByClient'];
      }
    }

    static fromJS(data: any): AppFormQuestionnaireDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['fileId'] = this.fileId;
      data['isMarried'] = this.isMarried;
      data['isDebtFromFineOrPenaltyImposedByCourt'] = this.isDebtFromFineOrPenaltyImposedByCourt;
      data['debtFromFineOrPenaltyImposedByCourtDetails'] = this.debtFromFineOrPenaltyImposedByCourtDetails;
      data['isDebtFromRecognizanceOfBailBond'] = this.isDebtFromRecognizanceOfBailBond;
      data['debtFromRecognizanceOfBailBondDetails'] = this.debtFromRecognizanceOfBailBondDetails;
      data['isDebtFromAlimony'] = this.isDebtFromAlimony;
      data['debtFromAlimonyDetails'] = this.debtFromAlimonyDetails;
      data['isDebtFromMaintenanceOfAffiliationOrder'] = this.isDebtFromMaintenanceOfAffiliationOrder;
      data['debtFromMaintenanceOfAffiliationOrderDetails'] = this.debtFromMaintenanceOfAffiliationOrderDetails;
      data['isDebtFromMaintenanceOfSupportOfSeparatedFamily'] = this.isDebtFromMaintenanceOfSupportOfSeparatedFamily;
      data['debtFromMaintenanceOfSupportOfSeparatedFamilyDetails'] =
        this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
      data['isDebtFromFraud'] = this.isDebtFromFraud;
      data['debtFromFraudDetails'] = this.debtFromFraudDetails;
      data['isDebtFromEmbezzlement'] = this.isDebtFromEmbezzlement;
      data['debtFromEmbezzlementDetails'] = this.debtFromEmbezzlementDetails;
      data['isDebtFromMisappropriation'] = this.isDebtFromMisappropriation;
      data['debtFromMisappropriationDetails'] = this.debtFromMisappropriationDetails;
      data['isDebtFromDefalcationWhileActingInAFiduciaryCapacity'] =
        this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity;
      data['debtFromDefalcationWhileActingInAFiduciaryCapacityDetails'] =
        this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
      data['isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'] =
        this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
      data['debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'] =
        this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
      data['isDebtFromStudentLoansOutstanding'] = this.isDebtFromStudentLoansOutstanding;
      data['debtFromStudentLoansOutstandingDetails'] = this.debtFromStudentLoansOutstandingDetails;
      data['debtFromStudentLoansOutstandingDateCeasedBeingStudent'] = this
        .debtFromStudentLoansOutstandingDateCeasedBeingStudent
        ? this.debtFromStudentLoansOutstandingDateCeasedBeingStudent.toISOString()
        : <any>undefined;
      data['isSpouseDebtFromFineOrPenaltyImposedByCourt'] = this.isSpouseDebtFromFineOrPenaltyImposedByCourt;
      data['spouseDebtFromFineOrPenaltyImposedByCourtDetails'] = this.spouseDebtFromFineOrPenaltyImposedByCourtDetails;
      data['isSpouseDebtFromRecognizanceOfBailBond'] = this.isSpouseDebtFromRecognizanceOfBailBond;
      data['spouseDebtFromRecognizanceOfBailBondDetails'] = this.spouseDebtFromRecognizanceOfBailBondDetails;
      data['isSpouseDebtFromAlimony'] = this.isSpouseDebtFromAlimony;
      data['spouseDebtFromAlimonyDetails'] = this.spouseDebtFromAlimonyDetails;
      data['isSpouseDebtFromMaintenanceOfAffiliationOrder'] = this.isSpouseDebtFromMaintenanceOfAffiliationOrder;
      data['spouseDebtFromMaintenanceOfAffiliationOrderDetails'] =
        this.spouseDebtFromMaintenanceOfAffiliationOrderDetails;
      data['isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily'] =
        this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily;
      data['spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails'] =
        this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
      data['isSpouseDebtFromFraud'] = this.isSpouseDebtFromFraud;
      data['spouseDebtFromFraudDetails'] = this.spouseDebtFromFraudDetails;
      data['isSpouseDebtFromEmbezzlement'] = this.isSpouseDebtFromEmbezzlement;
      data['spouseDebtFromEmbezzlementDetails'] = this.spouseDebtFromEmbezzlementDetails;
      data['isSpouseDebtFromMisappropriation'] = this.isSpouseDebtFromMisappropriation;
      data['spouseDebtFromMisappropriationDetails'] = this.spouseDebtFromMisappropriationDetails;
      data['isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity'] =
        this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity;
      data['spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails'] =
        this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
      data['isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'] =
        this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
      data['spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'] =
        this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
      data['isSpouseDebtFromStudentLoansOutstanding'] = this.isSpouseDebtFromStudentLoansOutstanding;
      data['spouseDebtFromStudentLoansOutstandingDetails'] = this.spouseDebtFromStudentLoansOutstandingDetails;
      data['spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent'] = this
        .spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent
        ? this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent.toISOString()
        : <any>undefined;
      data['hasCoSignedOrGuaranteedLoan'] = this.hasCoSignedOrGuaranteedLoan;
      if (Array.isArray(this.coSignedOrGuaranteedLoans)) {
        data['coSignedOrGuaranteedLoans'] = [];
        for (let item of this.coSignedOrGuaranteedLoans) data['coSignedOrGuaranteedLoans'].push(item.toJSON());
      }
      data['hasMadeExessPaymentsPast12Months'] = this.hasMadeExessPaymentsPast12Months;
      data['hasMadeExessPaymentsPast12MonthsDetails'] = this.hasMadeExessPaymentsPast12MonthsDetails;
      data['hasAssetsSiezedOrGarnishedPast12Months'] = this.hasAssetsSiezedOrGarnishedPast12Months;
      data['hasAssetsSiezedOrGarnishedPast12MonthsDetail'] = this.hasAssetsSiezedOrGarnishedPast12MonthsDetail;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
      data['hasGivenGiftsOver500WhileInsolventPast5Years'] = this.hasGivenGiftsOver500WhileInsolventPast5Years;
      data['hasGivenGiftsOver500WhileInsolventPast5YearsDetails'] =
        this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails;
      data['isExpectedToReceiveNonIncomeFundsNext12Months'] = this.isExpectedToReceiveNonIncomeFundsNext12Months;
      data['isExpectedToReceiveNonIncomeFundsNext12MonthsDetails'] =
        this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
      data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'] =
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
      data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'] =
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
      data['hasMadeArragementsToContinuePayingCreditors'] = this.hasMadeArragementsToContinuePayingCreditors;
      data['hasMadeArragementsToContinuePayingCreditorsDetails'] =
        this.hasMadeArragementsToContinuePayingCreditorsDetails;
      data['hasSpouseMadeExessPaymentsPast12Months'] = this.hasSpouseMadeExessPaymentsPast12Months;
      data['hasSpouseMadeExessPaymentsPast12MonthsDetails'] = this.hasSpouseMadeExessPaymentsPast12MonthsDetails;
      data['hasSpouseAssetsSiezedOrGarnishedPast12Months'] = this.hasSpouseAssetsSiezedOrGarnishedPast12Months;
      data['hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail'] =
        this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
      data['hasSpouseGivenGiftsOver500WhileInsolventPast5Years'] =
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years;
      data['hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails'] =
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails;
      data['isSpouseExpectedToReceiveNonIncomeFundsNext12Months'] =
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months;
      data['isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails'] =
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
      data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'] =
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
      data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'] =
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
      data['hasSpouseMadeArragementsToContinuePayingCreditors'] =
        this.hasSpouseMadeArragementsToContinuePayingCreditors;
      data['hasSpouseMadeArragementsToContinuePayingCreditorsDetails'] =
        this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails;
      data['hasOwnedBusinessPast5Years'] = this.hasOwnedBusinessPast5Years;
      data['doesBusinessAccountForHalfOfDebt'] = this.doesBusinessAccountForHalfOfDebt;
      data['naicsCode'] = this.naicsCode;
      data['hasSpouseOwnedBusinessPast5Years'] = this.hasSpouseOwnedBusinessPast5Years;
      data['doesSpouseBusinessAccountForHalfOfDebt'] = this.doesSpouseBusinessAccountForHalfOfDebt;
      data['spouseNAICSCode'] = this.spouseNAICSCode;
      if (Array.isArray(this.businesses)) {
        data['businesses'] = [];
        for (let item of this.businesses) data['businesses'].push(item.toJSON());
      }
      if (Array.isArray(this.spouseBusinesses)) {
        data['spouseBusinesses'] = [];
        for (let item of this.spouseBusinesses) data['spouseBusinesses'].push(item.toJSON());
      }
      data['debtorHasAFinancialAdviceProvider'] = this.debtorHasAFinancialAdviceProvider;
      data['debtorSpouseHasAFinancialAdviceProvider'] = this.debtorSpouseHasAFinancialAdviceProvider;
      if (Array.isArray(this.financialAdvices)) {
        data['financialAdvices'] = [];
        for (let item of this.financialAdvices) data['financialAdvices'].push(item.toJSON());
      }
      if (Array.isArray(this.spouseFinancialAdvices)) {
        data['spouseFinancialAdvices'] = [];
        for (let item of this.spouseFinancialAdvices) data['spouseFinancialAdvices'].push(item.toJSON());
      }
      data['isConsentChecked'] = this.isConsentChecked;
      data['consentDate'] = this.consentDate ? this.consentDate.toISOString() : <any>undefined;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      data['isDebtAreasApplicantUpdatedByClient'] = this.isDebtAreasApplicantUpdatedByClient;
      data['isDebtAreasSpouseUpdatedByClient'] = this.isDebtAreasSpouseUpdatedByClient;
      data['isCoSignsGuaranteedLoansUpdatedByClient'] = this.isCoSignsGuaranteedLoansUpdatedByClient;
      data['isTransactionsApplicantUpdatedByClient'] = this.isTransactionsApplicantUpdatedByClient;
      data['isTransactionsSpouseUpdatedByClient'] = this.isTransactionsSpouseUpdatedByClient;
      data['isBusinessUpdatedByClient'] = this.isBusinessUpdatedByClient;
      data['isCreditBureauConsentUpdatedByClient'] = this.isCreditBureauConsentUpdatedByClient;
      data['isAdviceReceivedApplicantUpdatedByClient'] = this.isAdviceReceivedApplicantUpdatedByClient;
      return data;
    }
  }

  export interface IAppFormQuestionnaireDto {
    id?: string;
    fileId?: string;
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    debtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isDebtFromRecognizanceOfBailBond?: boolean | undefined;
    debtFromRecognizanceOfBailBondDetails?: string | undefined;
    isDebtFromAlimony?: boolean | undefined;
    debtFromAlimonyDetails?: string | undefined;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    debtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isDebtFromFraud?: boolean | undefined;
    debtFromFraudDetails?: string | undefined;
    isDebtFromEmbezzlement?: boolean | undefined;
    debtFromEmbezzlementDetails?: string | undefined;
    isDebtFromMisappropriation?: boolean | undefined;
    debtFromMisappropriationDetails?: string | undefined;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isDebtFromStudentLoansOutstanding?: boolean | undefined;
    debtFromStudentLoansOutstandingDetails?: string | undefined;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean | undefined;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: string | undefined;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean | undefined;
    spouseDebtFromRecognizanceOfBailBondDetails?: string | undefined;
    isSpouseDebtFromAlimony?: boolean | undefined;
    spouseDebtFromAlimonyDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean | undefined;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: string | undefined;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean | undefined;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: string | undefined;
    isSpouseDebtFromFraud?: boolean | undefined;
    spouseDebtFromFraudDetails?: string | undefined;
    isSpouseDebtFromEmbezzlement?: boolean | undefined;
    spouseDebtFromEmbezzlementDetails?: string | undefined;
    isSpouseDebtFromMisappropriation?: boolean | undefined;
    spouseDebtFromMisappropriationDetails?: string | undefined;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean | undefined;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: string | undefined;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean | undefined;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: string | undefined;
    isSpouseDebtFromStudentLoansOutstanding?: boolean | undefined;
    spouseDebtFromStudentLoansOutstandingDetails?: string | undefined;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: moment.Moment | undefined;
    hasCoSignedOrGuaranteedLoan?: boolean | undefined;
    coSignedOrGuaranteedLoans?: AppFormQuestionnaireCoSignOrGuaranteedLoanDto[] | undefined;
    hasMadeExessPaymentsPast12Months?: boolean | undefined;
    hasMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasSpouseMadeExessPaymentsPast12Months?: boolean | undefined;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: string | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean | undefined;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: string | undefined;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean | undefined;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: string | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean | undefined;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: string | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean | undefined;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: string | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean | undefined;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: string | undefined;
    hasOwnedBusinessPast5Years?: boolean | undefined;
    doesBusinessAccountForHalfOfDebt?: boolean | undefined;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean | undefined;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean | undefined;
    spouseNAICSCode?: string | undefined;
    businesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    spouseBusinesses?: AppFormQuestionnaireBusinessDto[] | undefined;
    debtorHasAFinancialAdviceProvider?: boolean | undefined;
    debtorSpouseHasAFinancialAdviceProvider?: boolean | undefined;
    financialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    spouseFinancialAdvices?: AppFormQuestionnaireFinancialAdviceProviderDto[] | undefined;
    isConsentChecked?: boolean | undefined;
    consentDate?: moment.Moment | undefined;
    documentIds?: string[] | undefined;
    clientUpdatedFields?: AppFormQuestionnaireUpdatedFieldsDto;
    isDebtAreasApplicantUpdatedByClient?: boolean | undefined;
    isDebtAreasSpouseUpdatedByClient?: boolean | undefined;
    isCoSignsGuaranteedLoansUpdatedByClient?: boolean | undefined;
    isTransactionsApplicantUpdatedByClient?: boolean | undefined;
    isTransactionsSpouseUpdatedByClient?: boolean | undefined;
    isBusinessUpdatedByClient?: boolean | undefined;
    isCreditBureauConsentUpdatedByClient?: boolean | undefined;
    isAdviceReceivedApplicantUpdatedByClient?: boolean | undefined;
  }

  export class AppFormQuestionnaireFinancialAdviceProviderDto
    implements IAppFormQuestionnaireFinancialAdviceProviderDto
  {
    id?: string;
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    firmStreetNumber?: string | undefined;
    firmStreetName?: string | undefined;
    firmCity?: string | undefined;
    firmPostalCode?: string | undefined;
    firmProvinceId?: string | undefined;
    firmCountryId?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto;

    constructor(data?: IAppFormQuestionnaireFinancialAdviceProviderDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.isSpouse = _data['isSpouse'];
        this.surname = _data['surname'];
        this.givenName = _data['givenName'];
        this.firmName = _data['firmName'];
        this.firmAddress = _data['firmAddress'];
        this.addressUnit = _data['addressUnit'];
        this.firmStreetNumber = _data['firmStreetNumber'];
        this.firmStreetName = _data['firmStreetName'];
        this.firmCity = _data['firmCity'];
        this.firmPostalCode = _data['firmPostalCode'];
        this.firmProvinceId = _data['firmProvinceId'];
        this.firmCountryId = _data['firmCountryId'];
        this.totalAmountPaidToDate = _data['totalAmountPaidToDate'];
        this.totalRemainingAmountToBePaid = _data['totalRemainingAmountToBePaid'];
        this.clientUpdatedFields = _data['clientUpdatedFields']
          ? AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto.fromJS(_data['clientUpdatedFields'])
          : <any>undefined;
      }
    }

    static fromJS(data: any): AppFormQuestionnaireFinancialAdviceProviderDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireFinancialAdviceProviderDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['isSpouse'] = this.isSpouse;
      data['surname'] = this.surname;
      data['givenName'] = this.givenName;
      data['firmName'] = this.firmName;
      data['firmAddress'] = this.firmAddress;
      data['addressUnit'] = this.addressUnit;
      data['firmStreetNumber'] = this.firmStreetNumber;
      data['firmStreetName'] = this.firmStreetName;
      data['firmCity'] = this.firmCity;
      data['firmPostalCode'] = this.firmPostalCode;
      data['firmProvinceId'] = this.firmProvinceId;
      data['firmCountryId'] = this.firmCountryId;
      data['totalAmountPaidToDate'] = this.totalAmountPaidToDate;
      data['totalRemainingAmountToBePaid'] = this.totalRemainingAmountToBePaid;
      data['clientUpdatedFields'] = this.clientUpdatedFields ? this.clientUpdatedFields.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IAppFormQuestionnaireFinancialAdviceProviderDto {
    id?: string;
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    firmStreetNumber?: string | undefined;
    firmStreetName?: string | undefined;
    firmCity?: string | undefined;
    firmPostalCode?: string | undefined;
    firmProvinceId?: string | undefined;
    firmCountryId?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
    clientUpdatedFields?: AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto;
  }

  export class AppFormSectionStatusDto implements IAppFormSectionStatusDto {
    status?: AppFormStatusEnum;

    constructor(data?: IAppFormSectionStatusDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.status = _data['status'];
      }
    }

    static fromJS(data: any): AppFormSectionStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormSectionStatusDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['status'] = this.status;
      return data;
    }
  }

  export interface IAppFormSectionStatusDto {
    status?: AppFormStatusEnum;
  }

  export class AppFormStatusDto implements IAppFormStatusDto {
    personalInfoStatus?: AppFormStatusEnum;
    assetsDebtsStatus?: AppFormStatusEnum;
    incomeExpenseStatus?: AppFormStatusEnum;
    incomeTaxStatus?: AppFormStatusEnum;
    bankingInformationStatus?: AppFormStatusEnum;
    questionnaireStatus?: AppFormStatusEnum;
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;

    constructor(data?: IAppFormStatusDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.personalInfoStatus = _data['personalInfoStatus'];
        this.assetsDebtsStatus = _data['assetsDebtsStatus'];
        this.incomeExpenseStatus = _data['incomeExpenseStatus'];
        this.incomeTaxStatus = _data['incomeTaxStatus'];
        this.bankingInformationStatus = _data['bankingInformationStatus'];
        this.questionnaireStatus = _data['questionnaireStatus'];
        this.supportingDocumentStatus = _data['supportingDocumentStatus'];
        this.numberOfRequiredSupportingDocuments = _data['numberOfRequiredSupportingDocuments'];
        this.numberOfUploadedSupportingDocuments = _data['numberOfUploadedSupportingDocuments'];
      }
    }

    static fromJS(data: any): AppFormStatusDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormStatusDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['personalInfoStatus'] = this.personalInfoStatus;
      data['assetsDebtsStatus'] = this.assetsDebtsStatus;
      data['incomeExpenseStatus'] = this.incomeExpenseStatus;
      data['incomeTaxStatus'] = this.incomeTaxStatus;
      data['bankingInformationStatus'] = this.bankingInformationStatus;
      data['questionnaireStatus'] = this.questionnaireStatus;
      data['supportingDocumentStatus'] = this.supportingDocumentStatus;
      data['numberOfRequiredSupportingDocuments'] = this.numberOfRequiredSupportingDocuments;
      data['numberOfUploadedSupportingDocuments'] = this.numberOfUploadedSupportingDocuments;
      return data;
    }
  }

  export interface IAppFormStatusDto {
    personalInfoStatus?: AppFormStatusEnum;
    assetsDebtsStatus?: AppFormStatusEnum;
    incomeExpenseStatus?: AppFormStatusEnum;
    incomeTaxStatus?: AppFormStatusEnum;
    bankingInformationStatus?: AppFormStatusEnum;
    questionnaireStatus?: AppFormStatusEnum;
    supportingDocumentStatus?: AppFormStatusEnum;
    numberOfRequiredSupportingDocuments?: number;
    numberOfUploadedSupportingDocuments?: number;
  }

  export class AppFormAssetsDebtsAssetUpdatedFieldsDto implements IAppFormAssetsDebtsAssetUpdatedFieldsDto {
    assetType?: boolean;
    assetDescription?: boolean;
    assetDescriptionName?: boolean;
    assetTypeId?: boolean;
    assetDescriptionId?: boolean;
    specifiedDescription?: boolean;
    value?: boolean;
    ownershipTypeId?: boolean;
    comments?: boolean;
    isExempt?: boolean;
    basisOfValue?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    applicantOwnershipPercentage?: boolean;
    spouseOwnershipPercentage?: boolean;
    otherOwnershipPercentage?: boolean;
    totalNumberOfOwners?: boolean;
    isOwnershipHeldInJointTenancy?: boolean;
    isPrincipalResidence?: boolean;
    nameOfInstitution?: boolean;
    policyNumber?: boolean;
    contributionsInLast12Months?: boolean;
    grantToBeRepaid?: boolean;
    estimatedTaxOnDisposition?: boolean;
    debtorsOwnershipInterest?: boolean;
    year?: boolean;
    make?: boolean;
    model?: boolean;
    trim?: boolean;
    style?: boolean;
    kilometers?: boolean;
    vin?: boolean;
    isVehicleNeededForEmployment?: boolean;

    constructor(data?: IAppFormAssetsDebtsAssetUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.assetType = _data['assetType'];
        this.assetDescription = _data['assetDescription'];
        this.assetDescriptionName = _data['assetDescriptionName'];
        this.assetTypeId = _data['assetTypeId'];
        this.assetDescriptionId = _data['assetDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.value = _data['value'];
        this.ownershipTypeId = _data['ownershipTypeId'];
        this.comments = _data['comments'];
        this.isExempt = _data['isExempt'];
        this.basisOfValue = _data['basisOfValue'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.applicantOwnershipPercentage = _data['applicantOwnershipPercentage'];
        this.spouseOwnershipPercentage = _data['spouseOwnershipPercentage'];
        this.otherOwnershipPercentage = _data['otherOwnershipPercentage'];
        this.totalNumberOfOwners = _data['totalNumberOfOwners'];
        this.isOwnershipHeldInJointTenancy = _data['isOwnershipHeldInJointTenancy'];
        this.isPrincipalResidence = _data['isPrincipalResidence'];
        this.nameOfInstitution = _data['nameOfInstitution'];
        this.policyNumber = _data['policyNumber'];
        this.contributionsInLast12Months = _data['contributionsInLast12Months'];
        this.grantToBeRepaid = _data['grantToBeRepaid'];
        this.estimatedTaxOnDisposition = _data['estimatedTaxOnDisposition'];
        this.debtorsOwnershipInterest = _data['debtorsOwnershipInterest'];
        this.year = _data['year'];
        this.make = _data['make'];
        this.model = _data['model'];
        this.trim = _data['trim'];
        this.style = _data['style'];
        this.kilometers = _data['kilometers'];
        this.vin = _data['vin'];
        this.isVehicleNeededForEmployment = _data['isVehicleNeededForEmployment'];
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsAssetUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsAssetUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['assetType'] = this.assetType;
      data['assetDescription'] = this.assetDescription;
      data['assetDescriptionName'] = this.assetDescriptionName;
      data['assetTypeId'] = this.assetTypeId;
      data['assetDescriptionId'] = this.assetDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['value'] = this.value;
      data['ownershipTypeId'] = this.ownershipTypeId;
      data['comments'] = this.comments;
      data['isExempt'] = this.isExempt;
      data['basisOfValue'] = this.basisOfValue;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['applicantOwnershipPercentage'] = this.applicantOwnershipPercentage;
      data['spouseOwnershipPercentage'] = this.spouseOwnershipPercentage;
      data['otherOwnershipPercentage'] = this.otherOwnershipPercentage;
      data['totalNumberOfOwners'] = this.totalNumberOfOwners;
      data['isOwnershipHeldInJointTenancy'] = this.isOwnershipHeldInJointTenancy;
      data['isPrincipalResidence'] = this.isPrincipalResidence;
      data['nameOfInstitution'] = this.nameOfInstitution;
      data['policyNumber'] = this.policyNumber;
      data['contributionsInLast12Months'] = this.contributionsInLast12Months;
      data['grantToBeRepaid'] = this.grantToBeRepaid;
      data['estimatedTaxOnDisposition'] = this.estimatedTaxOnDisposition;
      data['debtorsOwnershipInterest'] = this.debtorsOwnershipInterest;
      data['year'] = this.year;
      data['make'] = this.make;
      data['model'] = this.model;
      data['trim'] = this.trim;
      data['style'] = this.style;
      data['kilometers'] = this.kilometers;
      data['vin'] = this.vin;
      data['isVehicleNeededForEmployment'] = this.isVehicleNeededForEmployment;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsAssetUpdatedFieldsDto {
    assetType?: boolean;
    assetDescription?: boolean;
    assetDescriptionName?: boolean;
    assetTypeId?: boolean;
    assetDescriptionId?: boolean;
    specifiedDescription?: boolean;
    value?: boolean;
    ownershipTypeId?: boolean;
    comments?: boolean;
    isExempt?: boolean;
    basisOfValue?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    applicantOwnershipPercentage?: boolean;
    spouseOwnershipPercentage?: boolean;
    otherOwnershipPercentage?: boolean;
    totalNumberOfOwners?: boolean;
    isOwnershipHeldInJointTenancy?: boolean;
    isPrincipalResidence?: boolean;
    nameOfInstitution?: boolean;
    policyNumber?: boolean;
    contributionsInLast12Months?: boolean;
    grantToBeRepaid?: boolean;
    estimatedTaxOnDisposition?: boolean;
    debtorsOwnershipInterest?: boolean;
    year?: boolean;
    make?: boolean;
    model?: boolean;
    trim?: boolean;
    style?: boolean;
    kilometers?: boolean;
    vin?: boolean;
    isVehicleNeededForEmployment?: boolean;
  }

  export class AppFormAssetsDebtsDebtUpdatedFieldsDto implements IAppFormAssetsDebtsDebtUpdatedFieldsDto {
    debtDescriptionId?: boolean;
    specifiedDescription?: boolean;
    creditorName?: boolean;
    amount?: boolean;
    ownershipTypeId?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isBusinessDebt?: boolean;
    creditorAddress?: boolean;
    creditorStreetNumber?: boolean;
    creditorStreetName?: boolean;
    creditorUnit?: boolean;
    creditorCity?: boolean;
    creditorPostalCode?: boolean;
    creditorProvinceCode?: boolean;
    creditorCountryCode?: boolean;
    creditorEmailAddress?: boolean;

    constructor(data?: IAppFormAssetsDebtsDebtUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.debtDescriptionId = _data['debtDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.creditorName = _data['creditorName'];
        this.amount = _data['amount'];
        this.ownershipTypeId = _data['ownershipTypeId'];
        this.accountNumber = _data['accountNumber'];
        this.comments = _data['comments'];
        this.isBusinessDebt = _data['isBusinessDebt'];
        this.creditorAddress = _data['creditorAddress'];
        this.creditorStreetNumber = _data['creditorStreetNumber'];
        this.creditorStreetName = _data['creditorStreetName'];
        this.creditorUnit = _data['creditorUnit'];
        this.creditorCity = _data['creditorCity'];
        this.creditorPostalCode = _data['creditorPostalCode'];
        this.creditorProvinceCode = _data['creditorProvinceCode'];
        this.creditorCountryCode = _data['creditorCountryCode'];
        this.creditorEmailAddress = _data['creditorEmailAddress'];
      }
    }

    static fromJS(data: any): AppFormAssetsDebtsDebtUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormAssetsDebtsDebtUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['debtDescriptionId'] = this.debtDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['creditorName'] = this.creditorName;
      data['amount'] = this.amount;
      data['ownershipTypeId'] = this.ownershipTypeId;
      data['accountNumber'] = this.accountNumber;
      data['comments'] = this.comments;
      data['isBusinessDebt'] = this.isBusinessDebt;
      data['creditorAddress'] = this.creditorAddress;
      data['creditorStreetNumber'] = this.creditorStreetNumber;
      data['creditorStreetName'] = this.creditorStreetName;
      data['creditorUnit'] = this.creditorUnit;
      data['creditorCity'] = this.creditorCity;
      data['creditorPostalCode'] = this.creditorPostalCode;
      data['creditorProvinceCode'] = this.creditorProvinceCode;
      data['creditorCountryCode'] = this.creditorCountryCode;
      data['creditorEmailAddress'] = this.creditorEmailAddress;
      return data;
    }
  }

  export interface IAppFormAssetsDebtsDebtUpdatedFieldsDto {
    debtDescriptionId?: boolean;
    specifiedDescription?: boolean;
    creditorName?: boolean;
    amount?: boolean;
    ownershipTypeId?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isBusinessDebt?: boolean;
    creditorAddress?: boolean;
    creditorStreetNumber?: boolean;
    creditorStreetName?: boolean;
    creditorUnit?: boolean;
    creditorCity?: boolean;
    creditorPostalCode?: boolean;
    creditorProvinceCode?: boolean;
    creditorCountryCode?: boolean;
    creditorEmailAddress?: boolean;
  }

  export class AppFormBankingInfoDetailUpdatedFieldsDto implements IAppFormBankingInfoDetailUpdatedFieldsDto {
    institution?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isOverdraftOwed?: boolean;
    isJointAccount?: boolean;

    constructor(data?: IAppFormBankingInfoDetailUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.institution = _data['institution'];
        this.accountNumber = _data['accountNumber'];
        this.comments = _data['comments'];
        this.isOverdraftOwed = _data['isOverdraftOwed'];
        this.isJointAccount = _data['isJointAccount'];
      }
    }

    static fromJS(data: any): AppFormBankingInfoDetailUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormBankingInfoDetailUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['institution'] = this.institution;
      data['accountNumber'] = this.accountNumber;
      data['comments'] = this.comments;
      data['isOverdraftOwed'] = this.isOverdraftOwed;
      data['isJointAccount'] = this.isJointAccount;
      return data;
    }
  }

  export interface IAppFormBankingInfoDetailUpdatedFieldsDto {
    institution?: boolean;
    accountNumber?: boolean;
    comments?: boolean;
    isOverdraftOwed?: boolean;
    isJointAccount?: boolean;
  }

  export class AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto
    implements IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto
  {
    isInitial?: boolean;
    expenseTypeId?: boolean;
    expenseDescriptionId?: boolean;
    specifiedDescription?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;

    constructor(data?: IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isInitial = _data['isInitial'];
        this.expenseTypeId = _data['expenseTypeId'];
        this.expenseDescriptionId = _data['expenseDescriptionId'];
        this.specifiedDescription = _data['specifiedDescription'];
        this.applicantAmount = _data['applicantAmount'];
        this.spouseAmount = _data['spouseAmount'];
        this.otherHouseholdMemberAmount = _data['otherHouseholdMemberAmount'];
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseExpenseDetailUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isInitial'] = this.isInitial;
      data['expenseTypeId'] = this.expenseTypeId;
      data['expenseDescriptionId'] = this.expenseDescriptionId;
      data['specifiedDescription'] = this.specifiedDescription;
      data['applicantAmount'] = this.applicantAmount;
      data['spouseAmount'] = this.spouseAmount;
      data['otherHouseholdMemberAmount'] = this.otherHouseholdMemberAmount;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseExpenseDetailUpdatedFieldsDto {
    isInitial?: boolean;
    expenseTypeId?: boolean;
    expenseDescriptionId?: boolean;
    specifiedDescription?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;
  }

  export class AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto
    implements IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto
  {
    isInitial?: boolean;
    incomeTypeId?: boolean;
    description?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;

    constructor(data?: IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isInitial = _data['isInitial'];
        this.incomeTypeId = _data['incomeTypeId'];
        this.description = _data['description'];
        this.applicantAmount = _data['applicantAmount'];
        this.spouseAmount = _data['spouseAmount'];
        this.otherHouseholdMemberAmount = _data['otherHouseholdMemberAmount'];
      }
    }

    static fromJS(data: any): AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeExpenseIncomeDetailUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isInitial'] = this.isInitial;
      data['incomeTypeId'] = this.incomeTypeId;
      data['description'] = this.description;
      data['applicantAmount'] = this.applicantAmount;
      data['spouseAmount'] = this.spouseAmount;
      data['otherHouseholdMemberAmount'] = this.otherHouseholdMemberAmount;
      return data;
    }
  }

  export interface IAppFormIncomeExpenseIncomeDetailUpdatedFieldsDto {
    isInitial?: boolean;
    incomeTypeId?: boolean;
    description?: boolean;
    applicantAmount?: boolean;
    spouseAmount?: boolean;
    otherHouseholdMemberAmount?: boolean;
  }

  export class AppFormIncomeTaxUpdatedFieldsDto implements IAppFormIncomeTaxUpdatedFieldsDto {
    isMarried?: boolean;
    yearLastReturnFiled?: boolean;
    refundAmount?: boolean;
    amountOwing?: boolean;
    spouseYearLastReturnFiled?: boolean;
    spouseRefundAmount?: boolean;
    spouseAmountOwing?: boolean;

    constructor(data?: IAppFormIncomeTaxUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isMarried = _data['isMarried'];
        this.yearLastReturnFiled = _data['yearLastReturnFiled'];
        this.refundAmount = _data['refundAmount'];
        this.amountOwing = _data['amountOwing'];
        this.spouseYearLastReturnFiled = _data['spouseYearLastReturnFiled'];
        this.spouseRefundAmount = _data['spouseRefundAmount'];
        this.spouseAmountOwing = _data['spouseAmountOwing'];
      }
    }

    static fromJS(data: any): AppFormIncomeTaxUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormIncomeTaxUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isMarried'] = this.isMarried;
      data['yearLastReturnFiled'] = this.yearLastReturnFiled;
      data['refundAmount'] = this.refundAmount;
      data['amountOwing'] = this.amountOwing;
      data['spouseYearLastReturnFiled'] = this.spouseYearLastReturnFiled;
      data['spouseRefundAmount'] = this.spouseRefundAmount;
      data['spouseAmountOwing'] = this.spouseAmountOwing;
      return data;
    }
  }

  export interface IAppFormIncomeTaxUpdatedFieldsDto {
    isMarried?: boolean;
    yearLastReturnFiled?: boolean;
    refundAmount?: boolean;
    amountOwing?: boolean;
    spouseYearLastReturnFiled?: boolean;
    spouseRefundAmount?: boolean;
    spouseAmountOwing?: boolean;
  }

  export class AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto
    implements IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto
  {
    phoneTypeId?: boolean;
    phoneNumber?: boolean;

    constructor(data?: IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.phoneTypeId = _data['phoneTypeId'];
        this.phoneNumber = _data['phoneNumber'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoAlternatePhoneUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['phoneTypeId'] = this.phoneTypeId;
      data['phoneNumber'] = this.phoneNumber;
      return data;
    }
  }

  export interface IAppFormPersonalInfoAlternatePhoneUpdatedFieldsDto {
    phoneTypeId?: boolean;
    phoneNumber?: boolean;
  }

  export class AppFormPersonalInfoDependantUpdatedFieldsDto implements IAppFormPersonalInfoDependantUpdatedFieldsDto {
    firstName?: boolean;
    lastName?: boolean;
    relationshipTypeId?: boolean;
    birthDate?: boolean;

    constructor(data?: IAppFormPersonalInfoDependantUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.firstName = _data['firstName'];
        this.lastName = _data['lastName'];
        this.relationshipTypeId = _data['relationshipTypeId'];
        this.birthDate = _data['birthDate'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoDependantUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoDependantUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['firstName'] = this.firstName;
      data['lastName'] = this.lastName;
      data['relationshipTypeId'] = this.relationshipTypeId;
      data['birthDate'] = this.birthDate;
      return data;
    }
  }

  export interface IAppFormPersonalInfoDependantUpdatedFieldsDto {
    firstName?: boolean;
    lastName?: boolean;
    relationshipTypeId?: boolean;
    birthDate?: boolean;
  }

  export class AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto
    implements IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto
  {
    employerName?: boolean;
    employerAddress?: boolean;
    employerStreetNumber?: boolean;
    employerStreetName?: boolean;
    employerUnit?: boolean;
    employerCity?: boolean;
    employerPostalCode?: boolean;
    employerProvinceId?: boolean;
    employerCountryId?: boolean;
    employmentStatusId?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    isCurrentEmployer?: boolean;

    constructor(data?: IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.employerName = _data['employerName'];
        this.employerAddress = _data['employerAddress'];
        this.employerStreetNumber = _data['employerStreetNumber'];
        this.employerStreetName = _data['employerStreetName'];
        this.employerUnit = _data['employerUnit'];
        this.employerCity = _data['employerCity'];
        this.employerPostalCode = _data['employerPostalCode'];
        this.employerProvinceId = _data['employerProvinceId'];
        this.employerCountryId = _data['employerCountryId'];
        this.employmentStatusId = _data['employmentStatusId'];
        this.startDate = _data['startDate'];
        this.endDate = _data['endDate'];
        this.isCurrentEmployer = _data['isCurrentEmployer'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoEmploymentDetailUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['employerName'] = this.employerName;
      data['employerAddress'] = this.employerAddress;
      data['employerStreetNumber'] = this.employerStreetNumber;
      data['employerStreetName'] = this.employerStreetName;
      data['employerUnit'] = this.employerUnit;
      data['employerCity'] = this.employerCity;
      data['employerPostalCode'] = this.employerPostalCode;
      data['employerProvinceId'] = this.employerProvinceId;
      data['employerCountryId'] = this.employerCountryId;
      data['employmentStatusId'] = this.employmentStatusId;
      data['startDate'] = this.startDate;
      data['endDate'] = this.endDate;
      data['isCurrentEmployer'] = this.isCurrentEmployer;
      return data;
    }
  }

  export interface IAppFormPersonalInfoEmploymentDetailUpdatedFieldsDto {
    employerName?: boolean;
    employerAddress?: boolean;
    employerStreetNumber?: boolean;
    employerStreetName?: boolean;
    employerUnit?: boolean;
    employerCity?: boolean;
    employerPostalCode?: boolean;
    employerProvinceId?: boolean;
    employerCountryId?: boolean;
    employmentStatusId?: boolean;
    startDate?: boolean;
    endDate?: boolean;
    isCurrentEmployer?: boolean;
  }

  export class AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto
    implements IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto
  {
    startDate?: boolean;
    endDate?: boolean;
    isCurrentPeriod?: boolean;

    constructor(data?: IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.startDate = _data['startDate'];
        this.endDate = _data['endDate'];
        this.isCurrentPeriod = _data['isCurrentPeriod'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['startDate'] = this.startDate;
      data['endDate'] = this.endDate;
      data['isCurrentPeriod'] = this.isCurrentPeriod;
      return data;
    }
  }

  export interface IAppFormPersonalInfoEmploymentInsurancePeriodUpdatedFieldsDto {
    startDate?: boolean;
    endDate?: boolean;
    isCurrentPeriod?: boolean;
  }

  export class AppFormPersonalInfoPreviousAddressUpdatedFieldsDto
    implements IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto
  {
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;

    constructor(data?: IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousAddressUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoPreviousAddressUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      return data;
    }
  }

  export interface IAppFormPersonalInfoPreviousAddressUpdatedFieldsDto {
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
  }

  export class AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto
    implements IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto
  {
    insolvencyTypeId?: boolean;
    applicantName?: boolean;
    trusteeName?: boolean;
    estateNumber?: boolean;
    bankruptcyDate?: boolean;
    dischargeDate?: boolean;
    proposalDate?: boolean;
    proposalResultId?: boolean;
    filingLocation?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;

    constructor(data?: IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.insolvencyTypeId = _data['insolvencyTypeId'];
        this.applicantName = _data['applicantName'];
        this.trusteeName = _data['trusteeName'];
        this.estateNumber = _data['estateNumber'];
        this.bankruptcyDate = _data['bankruptcyDate'];
        this.dischargeDate = _data['dischargeDate'];
        this.proposalDate = _data['proposalDate'];
        this.proposalResultId = _data['proposalResultId'];
        this.filingLocation = _data['filingLocation'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['insolvencyTypeId'] = this.insolvencyTypeId;
      data['applicantName'] = this.applicantName;
      data['trusteeName'] = this.trusteeName;
      data['estateNumber'] = this.estateNumber;
      data['bankruptcyDate'] = this.bankruptcyDate;
      data['dischargeDate'] = this.dischargeDate;
      data['proposalDate'] = this.proposalDate;
      data['proposalResultId'] = this.proposalResultId;
      data['filingLocation'] = this.filingLocation;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      return data;
    }
  }

  export interface IAppFormPersonalInfoPreviousInsolvencyUpdatedFieldsDto {
    insolvencyTypeId?: boolean;
    applicantName?: boolean;
    trusteeName?: boolean;
    estateNumber?: boolean;
    bankruptcyDate?: boolean;
    dischargeDate?: boolean;
    proposalDate?: boolean;
    proposalResultId?: boolean;
    filingLocation?: boolean;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
  }

  export class AppFormPersonalInfoUpdatedFieldsDto implements IAppFormPersonalInfoUpdatedFieldsDto {
    firstName?: boolean;
    middleName?: boolean;
    lastName?: boolean;
    akaFirstName?: boolean;
    akaMiddleName?: boolean;
    akaLastName?: boolean;
    birthDate?: boolean;
    sin?: boolean;
    maritalStatusId?: boolean;
    marriageDate?: boolean;
    educationLevelId?: boolean;
    spouseFirstName?: boolean;
    spouseMiddleName?: boolean;
    spouseLastName?: boolean;
    spouseAkaFirstName?: boolean;
    spouseAkaMiddleName?: boolean;
    spouseAkaLastName?: boolean;
    spouseBirthDate?: boolean;
    spouseSIN?: boolean;
    spouseEducationLevelId?: boolean;
    isJointFile?: boolean;
    additionalNotes?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    residenceDate?: boolean;
    mainPhoneTypeId?: boolean;
    mainPhoneNumber?: boolean;
    emailAddress?: boolean;
    isSpouseAddressSame?: boolean;
    spouseAddress?: boolean;
    spouseStreetNumber?: boolean;
    spouseStreetName?: boolean;
    spouseUnit?: boolean;
    spouseCity?: boolean;
    spousePostalCode?: boolean;
    spouseProvinceId?: boolean;
    spouseCountryId?: boolean;
    spouseResidenceDate?: boolean;
    spouseMainPhoneTypeId?: boolean;
    spouseMainPhoneNumber?: boolean;
    spouseEmailAddress?: boolean;
    isEmployedPastTwoYears?: boolean;
    isReceivedEmploymentInsurancePastTwoYears?: boolean;
    isSpouseEmployedPastTwoYears?: boolean;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean;
    hasFDReasonOverExtensionOfCredit?: boolean;
    hasFDReasonInconsistentEmployment?: boolean;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMismanagementOfFinances?: boolean;
    hasFDReasonReductionInIncome?: boolean;
    hasFDReasonJobLoss?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonMedicalRelatedIssue?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonInsolvencyOfCoSignor?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: boolean;
    reasonForNeedingFinancialHelp?: boolean;
    numberOfPersonsInHousehold?: boolean;
    hasDependants?: boolean;
    hasPreviousInsolvency?: boolean;
    hasSpousePreviousInsolvency?: boolean;

    constructor(data?: IAppFormPersonalInfoUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.akaFirstName = _data['akaFirstName'];
        this.akaMiddleName = _data['akaMiddleName'];
        this.akaLastName = _data['akaLastName'];
        this.birthDate = _data['birthDate'];
        this.sin = _data['sin'];
        this.maritalStatusId = _data['maritalStatusId'];
        this.marriageDate = _data['marriageDate'];
        this.educationLevelId = _data['educationLevelId'];
        this.spouseFirstName = _data['spouseFirstName'];
        this.spouseMiddleName = _data['spouseMiddleName'];
        this.spouseLastName = _data['spouseLastName'];
        this.spouseAkaFirstName = _data['spouseAkaFirstName'];
        this.spouseAkaMiddleName = _data['spouseAkaMiddleName'];
        this.spouseAkaLastName = _data['spouseAkaLastName'];
        this.spouseBirthDate = _data['spouseBirthDate'];
        this.spouseSIN = _data['spouseSIN'];
        this.spouseEducationLevelId = _data['spouseEducationLevelId'];
        this.isJointFile = _data['isJointFile'];
        this.additionalNotes = _data['additionalNotes'];
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceCode = _data['provinceCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.residenceDate = _data['residenceDate'];
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
        this.emailAddress = _data['emailAddress'];
        this.isSpouseAddressSame = _data['isSpouseAddressSame'];
        this.spouseAddress = _data['spouseAddress'];
        this.spouseStreetNumber = _data['spouseStreetNumber'];
        this.spouseStreetName = _data['spouseStreetName'];
        this.spouseUnit = _data['spouseUnit'];
        this.spouseCity = _data['spouseCity'];
        this.spousePostalCode = _data['spousePostalCode'];
        this.spouseProvinceId = _data['spouseProvinceId'];
        this.spouseCountryId = _data['spouseCountryId'];
        this.spouseResidenceDate = _data['spouseResidenceDate'];
        this.spouseMainPhoneTypeId = _data['spouseMainPhoneTypeId'];
        this.spouseMainPhoneNumber = _data['spouseMainPhoneNumber'];
        this.spouseEmailAddress = _data['spouseEmailAddress'];
        this.isEmployedPastTwoYears = _data['isEmployedPastTwoYears'];
        this.isReceivedEmploymentInsurancePastTwoYears = _data['isReceivedEmploymentInsurancePastTwoYears'];
        this.isSpouseEmployedPastTwoYears = _data['isSpouseEmployedPastTwoYears'];
        this.isSpouseReceivedEmploymentInsurancePastTwoYears = _data['isSpouseReceivedEmploymentInsurancePastTwoYears'];
        this.hasFDReasonOverExtensionOfCredit = _data['hasFDReasonOverExtensionOfCredit'];
        this.hasFDReasonInconsistentEmployment = _data['hasFDReasonInconsistentEmployment'];
        this.hasFDReasonBusinessFailure = _data['hasFDReasonBusinessFailure'];
        this.hasFDReasonMismanagementOfFinances = _data['hasFDReasonMismanagementOfFinances'];
        this.hasFDReasonReductionInIncome = _data['hasFDReasonReductionInIncome'];
        this.hasFDReasonJobLoss = _data['hasFDReasonJobLoss'];
        this.hasFDReasonMaritalSeparationOrRelationshipBreakdown =
          _data['hasFDReasonMaritalSeparationOrRelationshipBreakdown'];
        this.hasFDReasonMedicalRelatedIssue = _data['hasFDReasonMedicalRelatedIssue'];
        this.hasFDReasonGambling = _data['hasFDReasonGambling'];
        this.hasFDReasonInsolvencyOfCoSignor = _data['hasFDReasonInsolvencyOfCoSignor'];
        this.hasFDReasonLitigationIssues = _data['hasFDReasonLitigationIssues'];
        this.hasFDReasonDrugAlcoholAddicition = _data['hasFDReasonDrugAlcoholAddicition'];
        this.hasFDReasonOther = _data['hasFDReasonOther'];
        this.specifiedFDReason = _data['specifiedFDReason'];
        this.reasonForNeedingFinancialHelp = _data['reasonForNeedingFinancialHelp'];
        this.numberOfPersonsInHousehold = _data['numberOfPersonsInHousehold'];
        this.hasDependants = _data['hasDependants'];
        this.hasPreviousInsolvency = _data['hasPreviousInsolvency'];
        this.hasSpousePreviousInsolvency = _data['hasSpousePreviousInsolvency'];
      }
    }

    static fromJS(data: any): AppFormPersonalInfoUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormPersonalInfoUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['akaFirstName'] = this.akaFirstName;
      data['akaMiddleName'] = this.akaMiddleName;
      data['akaLastName'] = this.akaLastName;
      data['birthDate'] = this.birthDate;
      data['sin'] = this.sin;
      data['maritalStatusId'] = this.maritalStatusId;
      data['marriageDate'] = this.marriageDate;
      data['educationLevelId'] = this.educationLevelId;
      data['spouseFirstName'] = this.spouseFirstName;
      data['spouseMiddleName'] = this.spouseMiddleName;
      data['spouseLastName'] = this.spouseLastName;
      data['spouseAkaFirstName'] = this.spouseAkaFirstName;
      data['spouseAkaMiddleName'] = this.spouseAkaMiddleName;
      data['spouseAkaLastName'] = this.spouseAkaLastName;
      data['spouseBirthDate'] = this.spouseBirthDate;
      data['spouseSIN'] = this.spouseSIN;
      data['spouseEducationLevelId'] = this.spouseEducationLevelId;
      data['isJointFile'] = this.isJointFile;
      data['additionalNotes'] = this.additionalNotes;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceCode'] = this.provinceCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['residenceDate'] = this.residenceDate;
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      data['emailAddress'] = this.emailAddress;
      data['isSpouseAddressSame'] = this.isSpouseAddressSame;
      data['spouseAddress'] = this.spouseAddress;
      data['spouseStreetNumber'] = this.spouseStreetNumber;
      data['spouseStreetName'] = this.spouseStreetName;
      data['spouseUnit'] = this.spouseUnit;
      data['spouseCity'] = this.spouseCity;
      data['spousePostalCode'] = this.spousePostalCode;
      data['spouseProvinceId'] = this.spouseProvinceId;
      data['spouseCountryId'] = this.spouseCountryId;
      data['spouseResidenceDate'] = this.spouseResidenceDate;
      data['spouseMainPhoneTypeId'] = this.spouseMainPhoneTypeId;
      data['spouseMainPhoneNumber'] = this.spouseMainPhoneNumber;
      data['spouseEmailAddress'] = this.spouseEmailAddress;
      data['isEmployedPastTwoYears'] = this.isEmployedPastTwoYears;
      data['isReceivedEmploymentInsurancePastTwoYears'] = this.isReceivedEmploymentInsurancePastTwoYears;
      data['isSpouseEmployedPastTwoYears'] = this.isSpouseEmployedPastTwoYears;
      data['isSpouseReceivedEmploymentInsurancePastTwoYears'] = this.isSpouseReceivedEmploymentInsurancePastTwoYears;
      data['hasFDReasonOverExtensionOfCredit'] = this.hasFDReasonOverExtensionOfCredit;
      data['hasFDReasonInconsistentEmployment'] = this.hasFDReasonInconsistentEmployment;
      data['hasFDReasonBusinessFailure'] = this.hasFDReasonBusinessFailure;
      data['hasFDReasonMismanagementOfFinances'] = this.hasFDReasonMismanagementOfFinances;
      data['hasFDReasonReductionInIncome'] = this.hasFDReasonReductionInIncome;
      data['hasFDReasonJobLoss'] = this.hasFDReasonJobLoss;
      data['hasFDReasonMaritalSeparationOrRelationshipBreakdown'] =
        this.hasFDReasonMaritalSeparationOrRelationshipBreakdown;
      data['hasFDReasonMedicalRelatedIssue'] = this.hasFDReasonMedicalRelatedIssue;
      data['hasFDReasonGambling'] = this.hasFDReasonGambling;
      data['hasFDReasonInsolvencyOfCoSignor'] = this.hasFDReasonInsolvencyOfCoSignor;
      data['hasFDReasonLitigationIssues'] = this.hasFDReasonLitigationIssues;
      data['hasFDReasonDrugAlcoholAddicition'] = this.hasFDReasonDrugAlcoholAddicition;
      data['hasFDReasonOther'] = this.hasFDReasonOther;
      data['specifiedFDReason'] = this.specifiedFDReason;
      data['reasonForNeedingFinancialHelp'] = this.reasonForNeedingFinancialHelp;
      data['numberOfPersonsInHousehold'] = this.numberOfPersonsInHousehold;
      data['hasDependants'] = this.hasDependants;
      data['hasPreviousInsolvency'] = this.hasPreviousInsolvency;
      data['hasSpousePreviousInsolvency'] = this.hasSpousePreviousInsolvency;
      return data;
    }
  }

  export interface IAppFormPersonalInfoUpdatedFieldsDto {
    firstName?: boolean;
    middleName?: boolean;
    lastName?: boolean;
    akaFirstName?: boolean;
    akaMiddleName?: boolean;
    akaLastName?: boolean;
    birthDate?: boolean;
    sin?: boolean;
    maritalStatusId?: boolean;
    marriageDate?: boolean;
    educationLevelId?: boolean;
    spouseFirstName?: boolean;
    spouseMiddleName?: boolean;
    spouseLastName?: boolean;
    spouseAkaFirstName?: boolean;
    spouseAkaMiddleName?: boolean;
    spouseAkaLastName?: boolean;
    spouseBirthDate?: boolean;
    spouseSIN?: boolean;
    spouseEducationLevelId?: boolean;
    isJointFile?: boolean;
    additionalNotes?: boolean;
    address?: boolean;
    streetNumber?: boolean;
    streetName?: boolean;
    unit?: boolean;
    city?: boolean;
    postalCode?: boolean;
    provinceCode?: boolean;
    provinceId?: boolean;
    countryId?: boolean;
    residenceDate?: boolean;
    mainPhoneTypeId?: boolean;
    mainPhoneNumber?: boolean;
    emailAddress?: boolean;
    isSpouseAddressSame?: boolean;
    spouseAddress?: boolean;
    spouseStreetNumber?: boolean;
    spouseStreetName?: boolean;
    spouseUnit?: boolean;
    spouseCity?: boolean;
    spousePostalCode?: boolean;
    spouseProvinceId?: boolean;
    spouseCountryId?: boolean;
    spouseResidenceDate?: boolean;
    spouseMainPhoneTypeId?: boolean;
    spouseMainPhoneNumber?: boolean;
    spouseEmailAddress?: boolean;
    isEmployedPastTwoYears?: boolean;
    isReceivedEmploymentInsurancePastTwoYears?: boolean;
    isSpouseEmployedPastTwoYears?: boolean;
    isSpouseReceivedEmploymentInsurancePastTwoYears?: boolean;
    hasFDReasonOverExtensionOfCredit?: boolean;
    hasFDReasonInconsistentEmployment?: boolean;
    hasFDReasonBusinessFailure?: boolean;
    hasFDReasonMismanagementOfFinances?: boolean;
    hasFDReasonReductionInIncome?: boolean;
    hasFDReasonJobLoss?: boolean;
    hasFDReasonMaritalSeparationOrRelationshipBreakdown?: boolean;
    hasFDReasonMedicalRelatedIssue?: boolean;
    hasFDReasonGambling?: boolean;
    hasFDReasonInsolvencyOfCoSignor?: boolean;
    hasFDReasonLitigationIssues?: boolean;
    hasFDReasonDrugAlcoholAddicition?: boolean;
    hasFDReasonOther?: boolean;
    specifiedFDReason?: boolean;
    reasonForNeedingFinancialHelp?: boolean;
    numberOfPersonsInHousehold?: boolean;
    hasDependants?: boolean;
    hasPreviousInsolvency?: boolean;
    hasSpousePreviousInsolvency?: boolean;
  }

  export class AppFormQuestionnaireBusinessUpdatedFieldsDto implements IAppFormQuestionnaireBusinessUpdatedFieldsDto {
    businessName?: boolean;
    businessAddress?: boolean;
    businessStreetNumber?: boolean;
    businessStreetName?: boolean;
    businessUnit?: boolean;
    businessCity?: boolean;
    businessPostalCode?: boolean;
    businessProvinceId?: boolean;
    businessCountryId?: boolean;
    businessOwnershipTypeId?: boolean;
    businessTypeId?: boolean;
    isDirector?: boolean;
    nameOfPartnersOrDirectors?: boolean;
    startDate?: boolean;
    dateOperationsCeased?: boolean;
    isCorporationBankrupt?: boolean;
    hasEmployeesOrSubContractors?: boolean;
    isOwingWagesToEmployees?: boolean;
    isOwingSourceDeductionOnWages?: boolean;
    otherDetails?: boolean;

    constructor(data?: IAppFormQuestionnaireBusinessUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.businessName = _data['businessName'];
        this.businessAddress = _data['businessAddress'];
        this.businessStreetNumber = _data['businessStreetNumber'];
        this.businessStreetName = _data['businessStreetName'];
        this.businessUnit = _data['businessUnit'];
        this.businessCity = _data['businessCity'];
        this.businessPostalCode = _data['businessPostalCode'];
        this.businessProvinceId = _data['businessProvinceId'];
        this.businessCountryId = _data['businessCountryId'];
        this.businessOwnershipTypeId = _data['businessOwnershipTypeId'];
        this.businessTypeId = _data['businessTypeId'];
        this.isDirector = _data['isDirector'];
        this.nameOfPartnersOrDirectors = _data['nameOfPartnersOrDirectors'];
        this.startDate = _data['startDate'];
        this.dateOperationsCeased = _data['dateOperationsCeased'];
        this.isCorporationBankrupt = _data['isCorporationBankrupt'];
        this.hasEmployeesOrSubContractors = _data['hasEmployeesOrSubContractors'];
        this.isOwingWagesToEmployees = _data['isOwingWagesToEmployees'];
        this.isOwingSourceDeductionOnWages = _data['isOwingSourceDeductionOnWages'];
        this.otherDetails = _data['otherDetails'];
      }
    }

    static fromJS(data: any): AppFormQuestionnaireBusinessUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireBusinessUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['businessName'] = this.businessName;
      data['businessAddress'] = this.businessAddress;
      data['businessStreetNumber'] = this.businessStreetNumber;
      data['businessStreetName'] = this.businessStreetName;
      data['businessUnit'] = this.businessUnit;
      data['businessCity'] = this.businessCity;
      data['businessPostalCode'] = this.businessPostalCode;
      data['businessProvinceId'] = this.businessProvinceId;
      data['businessCountryId'] = this.businessCountryId;
      data['businessOwnershipTypeId'] = this.businessOwnershipTypeId;
      data['businessTypeId'] = this.businessTypeId;
      data['isDirector'] = this.isDirector;
      data['nameOfPartnersOrDirectors'] = this.nameOfPartnersOrDirectors;
      data['startDate'] = this.startDate;
      data['dateOperationsCeased'] = this.dateOperationsCeased;
      data['isCorporationBankrupt'] = this.isCorporationBankrupt;
      data['hasEmployeesOrSubContractors'] = this.hasEmployeesOrSubContractors;
      data['isOwingWagesToEmployees'] = this.isOwingWagesToEmployees;
      data['isOwingSourceDeductionOnWages'] = this.isOwingSourceDeductionOnWages;
      data['otherDetails'] = this.otherDetails;
      return data;
    }
  }

  export interface IAppFormQuestionnaireBusinessUpdatedFieldsDto {
    businessName?: boolean;
    businessAddress?: boolean;
    businessStreetNumber?: boolean;
    businessStreetName?: boolean;
    businessUnit?: boolean;
    businessCity?: boolean;
    businessPostalCode?: boolean;
    businessProvinceId?: boolean;
    businessCountryId?: boolean;
    businessOwnershipTypeId?: boolean;
    businessTypeId?: boolean;
    isDirector?: boolean;
    nameOfPartnersOrDirectors?: boolean;
    startDate?: boolean;
    dateOperationsCeased?: boolean;
    isCorporationBankrupt?: boolean;
    hasEmployeesOrSubContractors?: boolean;
    isOwingWagesToEmployees?: boolean;
    isOwingSourceDeductionOnWages?: boolean;
    otherDetails?: boolean;
  }

  export class AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto
    implements IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto
  {
    isBySpouse?: boolean;
    lendersName?: boolean;
    lendersAddress?: boolean;
    lendersStreetNumber?: boolean;
    lendersStreetName?: boolean;
    lendersUnit?: boolean;
    lendersCity?: boolean;
    lendersPostalCode?: boolean;
    lendersProvinceId?: boolean;
    lendersCountryId?: boolean;
    borrowersName?: boolean;
    borrowersAddress?: boolean;
    borrowersStreetNumber?: boolean;
    borrowersStreetName?: boolean;
    borrowersUnit?: boolean;
    borrowersCity?: boolean;
    borrowersPostalCode?: boolean;
    borrowersProvinceId?: boolean;
    borrowersCountryId?: boolean;

    constructor(data?: IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isBySpouse = _data['isBySpouse'];
        this.lendersName = _data['lendersName'];
        this.lendersAddress = _data['lendersAddress'];
        this.lendersStreetNumber = _data['lendersStreetNumber'];
        this.lendersStreetName = _data['lendersStreetName'];
        this.lendersUnit = _data['lendersUnit'];
        this.lendersCity = _data['lendersCity'];
        this.lendersPostalCode = _data['lendersPostalCode'];
        this.lendersProvinceId = _data['lendersProvinceId'];
        this.lendersCountryId = _data['lendersCountryId'];
        this.borrowersName = _data['borrowersName'];
        this.borrowersAddress = _data['borrowersAddress'];
        this.borrowersStreetNumber = _data['borrowersStreetNumber'];
        this.borrowersStreetName = _data['borrowersStreetName'];
        this.borrowersUnit = _data['borrowersUnit'];
        this.borrowersCity = _data['borrowersCity'];
        this.borrowersPostalCode = _data['borrowersPostalCode'];
        this.borrowersProvinceId = _data['borrowersProvinceId'];
        this.borrowersCountryId = _data['borrowersCountryId'];
      }
    }

    static fromJS(data: any): AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isBySpouse'] = this.isBySpouse;
      data['lendersName'] = this.lendersName;
      data['lendersAddress'] = this.lendersAddress;
      data['lendersStreetNumber'] = this.lendersStreetNumber;
      data['lendersStreetName'] = this.lendersStreetName;
      data['lendersUnit'] = this.lendersUnit;
      data['lendersCity'] = this.lendersCity;
      data['lendersPostalCode'] = this.lendersPostalCode;
      data['lendersProvinceId'] = this.lendersProvinceId;
      data['lendersCountryId'] = this.lendersCountryId;
      data['borrowersName'] = this.borrowersName;
      data['borrowersAddress'] = this.borrowersAddress;
      data['borrowersStreetNumber'] = this.borrowersStreetNumber;
      data['borrowersStreetName'] = this.borrowersStreetName;
      data['borrowersUnit'] = this.borrowersUnit;
      data['borrowersCity'] = this.borrowersCity;
      data['borrowersPostalCode'] = this.borrowersPostalCode;
      data['borrowersProvinceId'] = this.borrowersProvinceId;
      data['borrowersCountryId'] = this.borrowersCountryId;
      return data;
    }
  }

  export interface IAppFormQuestionnaireCoSignOrGuaranteedLoanUpdatedFieldsDto {
    isBySpouse?: boolean;
    lendersName?: boolean;
    lendersAddress?: boolean;
    lendersStreetNumber?: boolean;
    lendersStreetName?: boolean;
    lendersUnit?: boolean;
    lendersCity?: boolean;
    lendersPostalCode?: boolean;
    lendersProvinceId?: boolean;
    lendersCountryId?: boolean;
    borrowersName?: boolean;
    borrowersAddress?: boolean;
    borrowersStreetNumber?: boolean;
    borrowersStreetName?: boolean;
    borrowersUnit?: boolean;
    borrowersCity?: boolean;
    borrowersPostalCode?: boolean;
    borrowersProvinceId?: boolean;
    borrowersCountryId?: boolean;
  }

  export class AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto
    implements IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto
  {
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;

    constructor(data?: IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isSpouse = _data['isSpouse'];
        this.surname = _data['surname'];
        this.givenName = _data['givenName'];
        this.firmName = _data['firmName'];
        this.firmAddress = _data['firmAddress'];
        this.addressUnit = _data['addressUnit'];
        this.totalAmountPaidToDate = _data['totalAmountPaidToDate'];
        this.totalRemainingAmountToBePaid = _data['totalRemainingAmountToBePaid'];
      }
    }

    static fromJS(data: any): AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isSpouse'] = this.isSpouse;
      data['surname'] = this.surname;
      data['givenName'] = this.givenName;
      data['firmName'] = this.firmName;
      data['firmAddress'] = this.firmAddress;
      data['addressUnit'] = this.addressUnit;
      data['totalAmountPaidToDate'] = this.totalAmountPaidToDate;
      data['totalRemainingAmountToBePaid'] = this.totalRemainingAmountToBePaid;
      return data;
    }
  }

  export interface IAppFormQuestionnaireFinancialAdviceProviderUpdatedFieldsDto {
    isSpouse?: boolean;
    surname?: string | undefined;
    givenName?: string | undefined;
    firmName?: string | undefined;
    firmAddress?: string | undefined;
    addressUnit?: string | undefined;
    totalAmountPaidToDate?: number | undefined;
    totalRemainingAmountToBePaid?: number | undefined;
  }

  export class AppFormQuestionnaireUpdatedFieldsDto implements IAppFormQuestionnaireUpdatedFieldsDto {
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean;
    debtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isDebtFromRecognizanceOfBailBond?: boolean;
    debtFromRecognizanceOfBailBondDetails?: boolean;
    isDebtFromAlimony?: boolean;
    debtFromAlimonyDetails?: boolean;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean;
    debtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isDebtFromFraud?: boolean;
    debtFromFraudDetails?: boolean;
    isDebtFromEmbezzlement?: boolean;
    debtFromEmbezzlementDetails?: boolean;
    isDebtFromMisappropriation?: boolean;
    debtFromMisappropriationDetails?: boolean;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isDebtFromStudentLoansOutstanding?: boolean;
    debtFromStudentLoansOutstandingDetails?: boolean;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean;
    spouseDebtFromRecognizanceOfBailBondDetails?: boolean;
    isSpouseDebtFromAlimony?: boolean;
    spouseDebtFromAlimonyDetails?: boolean;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isSpouseDebtFromFraud?: boolean;
    spouseDebtFromFraudDetails?: boolean;
    isSpouseDebtFromEmbezzlement?: boolean;
    spouseDebtFromEmbezzlementDetails?: boolean;
    isSpouseDebtFromMisappropriation?: boolean;
    spouseDebtFromMisappropriationDetails?: boolean;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isSpouseDebtFromStudentLoansOutstanding?: boolean;
    spouseDebtFromStudentLoansOutstandingDetails?: boolean;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    hasCoSignedOrGuaranteedLoan?: boolean;
    hasMadeExessPaymentsPast12Months?: boolean;
    hasMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasMadeArragementsToContinuePayingCreditors?: boolean;
    hasMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails?: boolean;
    hasSpouseMadeExessPaymentsPast12Months?: boolean;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasOwnedBusinessPast5Years?: boolean;
    doesBusinessAccountForHalfOfDebt?: boolean;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean;
    spouseNAICSCode?: string | undefined;
    isConsentChecked?: boolean;
    consentDate?: boolean;

    constructor(data?: IAppFormQuestionnaireUpdatedFieldsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isMarried = _data['isMarried'];
        this.isDebtFromFineOrPenaltyImposedByCourt = _data['isDebtFromFineOrPenaltyImposedByCourt'];
        this.debtFromFineOrPenaltyImposedByCourtDetails = _data['debtFromFineOrPenaltyImposedByCourtDetails'];
        this.isDebtFromRecognizanceOfBailBond = _data['isDebtFromRecognizanceOfBailBond'];
        this.debtFromRecognizanceOfBailBondDetails = _data['debtFromRecognizanceOfBailBondDetails'];
        this.isDebtFromAlimony = _data['isDebtFromAlimony'];
        this.debtFromAlimonyDetails = _data['debtFromAlimonyDetails'];
        this.isDebtFromMaintenanceOfAffiliationOrder = _data['isDebtFromMaintenanceOfAffiliationOrder'];
        this.debtFromMaintenanceOfAffiliationOrderDetails = _data['debtFromMaintenanceOfAffiliationOrderDetails'];
        this.isDebtFromMaintenanceOfSupportOfSeparatedFamily = _data['isDebtFromMaintenanceOfSupportOfSeparatedFamily'];
        this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails =
          _data['debtFromMaintenanceOfSupportOfSeparatedFamilyDetails'];
        this.isDebtFromFraud = _data['isDebtFromFraud'];
        this.debtFromFraudDetails = _data['debtFromFraudDetails'];
        this.isDebtFromEmbezzlement = _data['isDebtFromEmbezzlement'];
        this.debtFromEmbezzlementDetails = _data['debtFromEmbezzlementDetails'];
        this.isDebtFromMisappropriation = _data['isDebtFromMisappropriation'];
        this.debtFromMisappropriationDetails = _data['debtFromMisappropriationDetails'];
        this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity =
          _data['isDebtFromDefalcationWhileActingInAFiduciaryCapacity'];
        this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails =
          _data['debtFromDefalcationWhileActingInAFiduciaryCapacityDetails'];
        this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud =
          _data['isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'];
        this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails =
          _data['debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'];
        this.isDebtFromStudentLoansOutstanding = _data['isDebtFromStudentLoansOutstanding'];
        this.debtFromStudentLoansOutstandingDetails = _data['debtFromStudentLoansOutstandingDetails'];
        this.debtFromStudentLoansOutstandingDateCeasedBeingStudent =
          _data['debtFromStudentLoansOutstandingDateCeasedBeingStudent'];
        this.isSpouseDebtFromFineOrPenaltyImposedByCourt = _data['isSpouseDebtFromFineOrPenaltyImposedByCourt'];
        this.spouseDebtFromFineOrPenaltyImposedByCourtDetails =
          _data['spouseDebtFromFineOrPenaltyImposedByCourtDetails'];
        this.isSpouseDebtFromRecognizanceOfBailBond = _data['isSpouseDebtFromRecognizanceOfBailBond'];
        this.spouseDebtFromRecognizanceOfBailBondDetails = _data['spouseDebtFromRecognizanceOfBailBondDetails'];
        this.isSpouseDebtFromAlimony = _data['isSpouseDebtFromAlimony'];
        this.spouseDebtFromAlimonyDetails = _data['spouseDebtFromAlimonyDetails'];
        this.isSpouseDebtFromMaintenanceOfAffiliationOrder = _data['isSpouseDebtFromMaintenanceOfAffiliationOrder'];
        this.spouseDebtFromMaintenanceOfAffiliationOrderDetails =
          _data['spouseDebtFromMaintenanceOfAffiliationOrderDetails'];
        this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily =
          _data['isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily'];
        this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails =
          _data['spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails'];
        this.isSpouseDebtFromFraud = _data['isSpouseDebtFromFraud'];
        this.spouseDebtFromFraudDetails = _data['spouseDebtFromFraudDetails'];
        this.isSpouseDebtFromEmbezzlement = _data['isSpouseDebtFromEmbezzlement'];
        this.spouseDebtFromEmbezzlementDetails = _data['spouseDebtFromEmbezzlementDetails'];
        this.isSpouseDebtFromMisappropriation = _data['isSpouseDebtFromMisappropriation'];
        this.spouseDebtFromMisappropriationDetails = _data['spouseDebtFromMisappropriationDetails'];
        this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity =
          _data['isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity'];
        this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails =
          _data['spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails'];
        this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud =
          _data['isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'];
        this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails =
          _data['spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'];
        this.isSpouseDebtFromStudentLoansOutstanding = _data['isSpouseDebtFromStudentLoansOutstanding'];
        this.spouseDebtFromStudentLoansOutstandingDetails = _data['spouseDebtFromStudentLoansOutstandingDetails'];
        this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent =
          _data['spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent'];
        this.hasCoSignedOrGuaranteedLoan = _data['hasCoSignedOrGuaranteedLoan'];
        this.hasMadeExessPaymentsPast12Months = _data['hasMadeExessPaymentsPast12Months'];
        this.hasMadeExessPaymentsPast12MonthsDetails = _data['hasMadeExessPaymentsPast12MonthsDetails'];
        this.hasAssetsSiezedOrGarnishedPast12Months = _data['hasAssetsSiezedOrGarnishedPast12Months'];
        this.hasAssetsSiezedOrGarnishedPast12MonthsDetail = _data['hasAssetsSiezedOrGarnishedPast12MonthsDetail'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'];
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime =
          _data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'];
        this.hasGivenGiftsOver500WhileInsolventPast5Years = _data['hasGivenGiftsOver500WhileInsolventPast5Years'];
        this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails =
          _data['hasGivenGiftsOver500WhileInsolventPast5YearsDetails'];
        this.isExpectedToReceiveNonIncomeFundsNext12Months = _data['isExpectedToReceiveNonIncomeFundsNext12Months'];
        this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails =
          _data['isExpectedToReceiveNonIncomeFundsNext12MonthsDetails'];
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty =
          _data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'];
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails =
          _data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'];
        this.hasMadeArragementsToContinuePayingCreditors = _data['hasMadeArragementsToContinuePayingCreditors'];
        this.hasMadeArragementsToContinuePayingCreditorsDetails =
          _data['hasMadeArragementsToContinuePayingCreditorsDetails'];
        this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months =
          _data['hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months'];
        this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails =
          _data['hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails'];
        this.hasSpouseMadeExessPaymentsPast12Months = _data['hasSpouseMadeExessPaymentsPast12Months'];
        this.hasSpouseMadeExessPaymentsPast12MonthsDetails = _data['hasSpouseMadeExessPaymentsPast12MonthsDetails'];
        this.hasSpouseAssetsSiezedOrGarnishedPast12Months = _data['hasSpouseAssetsSiezedOrGarnishedPast12Months'];
        this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail =
          _data['hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'];
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime =
          _data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'];
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years =
          _data['hasSpouseGivenGiftsOver500WhileInsolventPast5Years'];
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails =
          _data['hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails'];
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months =
          _data['isSpouseExpectedToReceiveNonIncomeFundsNext12Months'];
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails =
          _data['isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails'];
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty =
          _data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'];
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails =
          _data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'];
        this.hasSpouseMadeArragementsToContinuePayingCreditors =
          _data['hasSpouseMadeArragementsToContinuePayingCreditors'];
        this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails =
          _data['hasSpouseMadeArragementsToContinuePayingCreditorsDetails'];
        this.hasOwnedBusinessPast5Years = _data['hasOwnedBusinessPast5Years'];
        this.doesBusinessAccountForHalfOfDebt = _data['doesBusinessAccountForHalfOfDebt'];
        this.naicsCode = _data['naicsCode'];
        this.hasSpouseOwnedBusinessPast5Years = _data['hasSpouseOwnedBusinessPast5Years'];
        this.doesSpouseBusinessAccountForHalfOfDebt = _data['doesSpouseBusinessAccountForHalfOfDebt'];
        this.spouseNAICSCode = _data['spouseNAICSCode'];
        this.isConsentChecked = _data['isConsentChecked'];
        this.consentDate = _data['consentDate'];
      }
    }

    static fromJS(data: any): AppFormQuestionnaireUpdatedFieldsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppFormQuestionnaireUpdatedFieldsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isMarried'] = this.isMarried;
      data['isDebtFromFineOrPenaltyImposedByCourt'] = this.isDebtFromFineOrPenaltyImposedByCourt;
      data['debtFromFineOrPenaltyImposedByCourtDetails'] = this.debtFromFineOrPenaltyImposedByCourtDetails;
      data['isDebtFromRecognizanceOfBailBond'] = this.isDebtFromRecognizanceOfBailBond;
      data['debtFromRecognizanceOfBailBondDetails'] = this.debtFromRecognizanceOfBailBondDetails;
      data['isDebtFromAlimony'] = this.isDebtFromAlimony;
      data['debtFromAlimonyDetails'] = this.debtFromAlimonyDetails;
      data['isDebtFromMaintenanceOfAffiliationOrder'] = this.isDebtFromMaintenanceOfAffiliationOrder;
      data['debtFromMaintenanceOfAffiliationOrderDetails'] = this.debtFromMaintenanceOfAffiliationOrderDetails;
      data['isDebtFromMaintenanceOfSupportOfSeparatedFamily'] = this.isDebtFromMaintenanceOfSupportOfSeparatedFamily;
      data['debtFromMaintenanceOfSupportOfSeparatedFamilyDetails'] =
        this.debtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
      data['isDebtFromFraud'] = this.isDebtFromFraud;
      data['debtFromFraudDetails'] = this.debtFromFraudDetails;
      data['isDebtFromEmbezzlement'] = this.isDebtFromEmbezzlement;
      data['debtFromEmbezzlementDetails'] = this.debtFromEmbezzlementDetails;
      data['isDebtFromMisappropriation'] = this.isDebtFromMisappropriation;
      data['debtFromMisappropriationDetails'] = this.debtFromMisappropriationDetails;
      data['isDebtFromDefalcationWhileActingInAFiduciaryCapacity'] =
        this.isDebtFromDefalcationWhileActingInAFiduciaryCapacity;
      data['debtFromDefalcationWhileActingInAFiduciaryCapacityDetails'] =
        this.debtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
      data['isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'] =
        this.isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
      data['debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'] =
        this.debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
      data['isDebtFromStudentLoansOutstanding'] = this.isDebtFromStudentLoansOutstanding;
      data['debtFromStudentLoansOutstandingDetails'] = this.debtFromStudentLoansOutstandingDetails;
      data['debtFromStudentLoansOutstandingDateCeasedBeingStudent'] =
        this.debtFromStudentLoansOutstandingDateCeasedBeingStudent;
      data['isSpouseDebtFromFineOrPenaltyImposedByCourt'] = this.isSpouseDebtFromFineOrPenaltyImposedByCourt;
      data['spouseDebtFromFineOrPenaltyImposedByCourtDetails'] = this.spouseDebtFromFineOrPenaltyImposedByCourtDetails;
      data['isSpouseDebtFromRecognizanceOfBailBond'] = this.isSpouseDebtFromRecognizanceOfBailBond;
      data['spouseDebtFromRecognizanceOfBailBondDetails'] = this.spouseDebtFromRecognizanceOfBailBondDetails;
      data['isSpouseDebtFromAlimony'] = this.isSpouseDebtFromAlimony;
      data['spouseDebtFromAlimonyDetails'] = this.spouseDebtFromAlimonyDetails;
      data['isSpouseDebtFromMaintenanceOfAffiliationOrder'] = this.isSpouseDebtFromMaintenanceOfAffiliationOrder;
      data['spouseDebtFromMaintenanceOfAffiliationOrderDetails'] =
        this.spouseDebtFromMaintenanceOfAffiliationOrderDetails;
      data['isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily'] =
        this.isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily;
      data['spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails'] =
        this.spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails;
      data['isSpouseDebtFromFraud'] = this.isSpouseDebtFromFraud;
      data['spouseDebtFromFraudDetails'] = this.spouseDebtFromFraudDetails;
      data['isSpouseDebtFromEmbezzlement'] = this.isSpouseDebtFromEmbezzlement;
      data['spouseDebtFromEmbezzlementDetails'] = this.spouseDebtFromEmbezzlementDetails;
      data['isSpouseDebtFromMisappropriation'] = this.isSpouseDebtFromMisappropriation;
      data['spouseDebtFromMisappropriationDetails'] = this.spouseDebtFromMisappropriationDetails;
      data['isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity'] =
        this.isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity;
      data['spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails'] =
        this.spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails;
      data['isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud'] =
        this.isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud;
      data['spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails'] =
        this.spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails;
      data['isSpouseDebtFromStudentLoansOutstanding'] = this.isSpouseDebtFromStudentLoansOutstanding;
      data['spouseDebtFromStudentLoansOutstandingDetails'] = this.spouseDebtFromStudentLoansOutstandingDetails;
      data['spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent'] =
        this.spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent;
      data['hasCoSignedOrGuaranteedLoan'] = this.hasCoSignedOrGuaranteedLoan;
      data['hasMadeExessPaymentsPast12Months'] = this.hasMadeExessPaymentsPast12Months;
      data['hasMadeExessPaymentsPast12MonthsDetails'] = this.hasMadeExessPaymentsPast12MonthsDetails;
      data['hasAssetsSiezedOrGarnishedPast12Months'] = this.hasAssetsSiezedOrGarnishedPast12Months;
      data['hasAssetsSiezedOrGarnishedPast12MonthsDetail'] = this.hasAssetsSiezedOrGarnishedPast12MonthsDetail;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
      data['hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'] =
        this.hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
      data['hasGivenGiftsOver500WhileInsolventPast5Years'] = this.hasGivenGiftsOver500WhileInsolventPast5Years;
      data['hasGivenGiftsOver500WhileInsolventPast5YearsDetails'] =
        this.hasGivenGiftsOver500WhileInsolventPast5YearsDetails;
      data['isExpectedToReceiveNonIncomeFundsNext12Months'] = this.isExpectedToReceiveNonIncomeFundsNext12Months;
      data['isExpectedToReceiveNonIncomeFundsNext12MonthsDetails'] =
        this.isExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
      data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'] =
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
      data['hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'] =
        this.hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
      data['hasMadeArragementsToContinuePayingCreditors'] = this.hasMadeArragementsToContinuePayingCreditors;
      data['hasMadeArragementsToContinuePayingCreditorsDetails'] =
        this.hasMadeArragementsToContinuePayingCreditorsDetails;
      data['hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months'] =
        this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months;
      data['hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails'] =
        this.hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails;
      data['hasSpouseMadeExessPaymentsPast12Months'] = this.hasSpouseMadeExessPaymentsPast12Months;
      data['hasSpouseMadeExessPaymentsPast12MonthsDetails'] = this.hasSpouseMadeExessPaymentsPast12MonthsDetails;
      data['hasSpouseAssetsSiezedOrGarnishedPast12Months'] = this.hasSpouseAssetsSiezedOrGarnishedPast12Months;
      data['hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail'] =
        this.hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails;
      data['hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime'] =
        this.hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime;
      data['hasSpouseGivenGiftsOver500WhileInsolventPast5Years'] =
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5Years;
      data['hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails'] =
        this.hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails;
      data['isSpouseExpectedToReceiveNonIncomeFundsNext12Months'] =
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12Months;
      data['isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails'] =
        this.isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails;
      data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty'] =
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty;
      data['hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails'] =
        this.hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails;
      data['hasSpouseMadeArragementsToContinuePayingCreditors'] =
        this.hasSpouseMadeArragementsToContinuePayingCreditors;
      data['hasSpouseMadeArragementsToContinuePayingCreditorsDetails'] =
        this.hasSpouseMadeArragementsToContinuePayingCreditorsDetails;
      data['hasOwnedBusinessPast5Years'] = this.hasOwnedBusinessPast5Years;
      data['doesBusinessAccountForHalfOfDebt'] = this.doesBusinessAccountForHalfOfDebt;
      data['naicsCode'] = this.naicsCode;
      data['hasSpouseOwnedBusinessPast5Years'] = this.hasSpouseOwnedBusinessPast5Years;
      data['doesSpouseBusinessAccountForHalfOfDebt'] = this.doesSpouseBusinessAccountForHalfOfDebt;
      data['spouseNAICSCode'] = this.spouseNAICSCode;
      data['isConsentChecked'] = this.isConsentChecked;
      data['consentDate'] = this.consentDate;
      return data;
    }
  }

  export interface IAppFormQuestionnaireUpdatedFieldsDto {
    isMarried?: boolean;
    isDebtFromFineOrPenaltyImposedByCourt?: boolean;
    debtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isDebtFromRecognizanceOfBailBond?: boolean;
    debtFromRecognizanceOfBailBondDetails?: boolean;
    isDebtFromAlimony?: boolean;
    debtFromAlimonyDetails?: boolean;
    isDebtFromMaintenanceOfAffiliationOrder?: boolean;
    debtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    debtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isDebtFromFraud?: boolean;
    debtFromFraudDetails?: boolean;
    isDebtFromEmbezzlement?: boolean;
    debtFromEmbezzlementDetails?: boolean;
    isDebtFromMisappropriation?: boolean;
    debtFromMisappropriationDetails?: boolean;
    isDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    debtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    debtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isDebtFromStudentLoansOutstanding?: boolean;
    debtFromStudentLoansOutstandingDetails?: boolean;
    debtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    isSpouseDebtFromFineOrPenaltyImposedByCourt?: boolean;
    spouseDebtFromFineOrPenaltyImposedByCourtDetails?: boolean;
    isSpouseDebtFromRecognizanceOfBailBond?: boolean;
    spouseDebtFromRecognizanceOfBailBondDetails?: boolean;
    isSpouseDebtFromAlimony?: boolean;
    spouseDebtFromAlimonyDetails?: boolean;
    isSpouseDebtFromMaintenanceOfAffiliationOrder?: boolean;
    spouseDebtFromMaintenanceOfAffiliationOrderDetails?: boolean;
    isSpouseDebtFromMaintenanceOfSupportOfSeparatedFamily?: boolean;
    spouseDebtFromMaintenanceOfSupportOfSeparatedFamilyDetails?: boolean;
    isSpouseDebtFromFraud?: boolean;
    spouseDebtFromFraudDetails?: boolean;
    isSpouseDebtFromEmbezzlement?: boolean;
    spouseDebtFromEmbezzlementDetails?: boolean;
    isSpouseDebtFromMisappropriation?: boolean;
    spouseDebtFromMisappropriationDetails?: boolean;
    isSpouseDebtFromDefalcationWhileActingInAFiduciaryCapacity?: boolean;
    spouseDebtFromDefalcationWhileActingInAFiduciaryCapacityDetails?: boolean;
    isSpouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraud?: boolean;
    spouseDebtFromPropertyOrServicesObtainedByFalseMeansOrFraudDetails?: boolean;
    isSpouseDebtFromStudentLoansOutstanding?: boolean;
    spouseDebtFromStudentLoansOutstandingDetails?: boolean;
    spouseDebtFromStudentLoansOutstandingDateCeasedBeingStudent?: boolean;
    hasCoSignedOrGuaranteedLoan?: boolean;
    hasMadeExessPaymentsPast12Months?: boolean;
    hasMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasMadeArragementsToContinuePayingCreditors?: boolean;
    hasMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12Months?: boolean;
    hasSpouseSoldDisposedOrTransferredAssetsCashedRRSPOrChangedBeneficiaryPast12MonthsDetails?: boolean;
    hasSpouseMadeExessPaymentsPast12Months?: boolean;
    hasSpouseMadeExessPaymentsPast12MonthsDetails?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12Months?: boolean;
    hasSpouseAssetsSiezedOrGarnishedPast12MonthsDetail?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5Years?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsDetails?: boolean;
    hasSpouseSoldDisposedOrTransferredRealProperlyOrOtherAssetsPast5YearsInsolventAtTime?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5Years?: boolean;
    hasSpouseGivenGiftsOver500WhileInsolventPast5YearsDetails?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12Months?: boolean;
    isSpouseExpectedToReceiveNonIncomeFundsNext12MonthsDetails?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrProperty?: boolean;
    hasSpouseBeenInvolvedInCivilLitigationReceivingMoneyOrPropertyDetails?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditors?: boolean;
    hasSpouseMadeArragementsToContinuePayingCreditorsDetails?: boolean;
    hasOwnedBusinessPast5Years?: boolean;
    doesBusinessAccountForHalfOfDebt?: boolean;
    naicsCode?: string | undefined;
    hasSpouseOwnedBusinessPast5Years?: boolean;
    doesSpouseBusinessAccountForHalfOfDebt?: boolean;
    spouseNAICSCode?: string | undefined;
    isConsentChecked?: boolean;
    consentDate?: boolean;
  }

  export class AppTaskAndTaskActionCreateDto implements IAppTaskAndTaskActionCreateDto {
    fileId?: string;
    agentId?: string | undefined;
    teamTypeEnum?: TeamTypeEnum;
    fileProcessEnum?: FileProcessEnum;
    taskNameEnum?: AppTaskNameEnum;
    taskActionEnum?: AppTaskActionNameEnum;
    taskDescription?: string | undefined;
    actionDescription?: string | undefined;
    useExistingTaskIfNotComplete?: boolean;

    constructor(data?: IAppTaskAndTaskActionCreateDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.agentId = _data['agentId'];
        this.teamTypeEnum = _data['teamTypeEnum'];
        this.fileProcessEnum = _data['fileProcessEnum'];
        this.taskNameEnum = _data['taskNameEnum'];
        this.taskActionEnum = _data['taskActionEnum'];
        this.taskDescription = _data['taskDescription'];
        this.actionDescription = _data['actionDescription'];
        this.useExistingTaskIfNotComplete = _data['useExistingTaskIfNotComplete'];
      }
    }

    static fromJS(data: any): AppTaskAndTaskActionCreateDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppTaskAndTaskActionCreateDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['agentId'] = this.agentId;
      data['teamTypeEnum'] = this.teamTypeEnum;
      data['fileProcessEnum'] = this.fileProcessEnum;
      data['taskNameEnum'] = this.taskNameEnum;
      data['taskActionEnum'] = this.taskActionEnum;
      data['taskDescription'] = this.taskDescription;
      data['actionDescription'] = this.actionDescription;
      data['useExistingTaskIfNotComplete'] = this.useExistingTaskIfNotComplete;
      return data;
    }
  }

  export interface IAppTaskAndTaskActionCreateDto {
    fileId?: string;
    agentId?: string | undefined;
    teamTypeEnum?: TeamTypeEnum;
    fileProcessEnum?: FileProcessEnum;
    taskNameEnum?: AppTaskNameEnum;
    taskActionEnum?: AppTaskActionNameEnum;
    taskDescription?: string | undefined;
    actionDescription?: string | undefined;
    useExistingTaskIfNotComplete?: boolean;
  }

  export class AdminInfoDischargeDto implements IAdminInfoDischargeDto {
    dischargeProcessStatus?: FileProcessStatusEnum;
    totalDue?: number;
    totalPayments?: number;
    isProcessAllowedToBeCompleted?: boolean;

    constructor(data?: IAdminInfoDischargeDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.dischargeProcessStatus = _data['dischargeProcessStatus'];
        this.totalDue = _data['totalDue'];
        this.totalPayments = _data['totalPayments'];
        this.isProcessAllowedToBeCompleted = _data['isProcessAllowedToBeCompleted'];
      }
    }

    static fromJS(data: any): AdminInfoDischargeDto {
      data = typeof data === 'object' ? data : {};
      let result = new AdminInfoDischargeDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['dischargeProcessStatus'] = this.dischargeProcessStatus;
      data['totalDue'] = this.totalDue;
      data['totalPayments'] = this.totalPayments;
      data['isProcessAllowedToBeCompleted'] = this.isProcessAllowedToBeCompleted;
      return data;
    }
  }

  export interface IAdminInfoDischargeDto {
    dischargeProcessStatus?: FileProcessStatusEnum;
    totalDue?: number;
    totalPayments?: number;
    isProcessAllowedToBeCompleted?: boolean;
  }

  export class AdminInfoSignupPublicDto implements IAdminInfoSignupPublicDto {
    fileId?: string;
    preSignupProgress?: PreSignupProgressEnum;

    constructor(data?: IAdminInfoSignupPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.preSignupProgress = _data['preSignupProgress'];
      }
    }

    static fromJS(data: any): AdminInfoSignupPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new AdminInfoSignupPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['preSignupProgress'] = this.preSignupProgress;
      return data;
    }
  }

  export interface IAdminInfoSignupPublicDto {
    fileId?: string;
    preSignupProgress?: PreSignupProgressEnum;
  }

  export class ApplicationFileDto implements IApplicationFileDto {
    id?: string;
    applicationFileName?: string | undefined;
    debtorName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    filingTypeEnum?: FilingTypeEnum;
    serviceLocationId?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: FileStageDto;
    descendantFileId?: string | undefined;
    descendantFileType?: AppFileDescendantType;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    migratedFileStage?: FileStageEnum;
    isDuplicate?: boolean | undefined;
    insolvencyDate?: moment.Moment | undefined;
    bankruptcyDuration?: string | undefined;
    copiedFromFileId?: string | undefined;

    constructor(data?: IApplicationFileDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.applicationFileName = _data['applicationFileName'];
        this.debtorName = _data['debtorName'];
        this.estateNumber = _data['estateNumber'];
        this.filingType = _data['filingType'];
        this.filingTypeEnum = _data['filingTypeEnum'];
        this.serviceLocationId = _data['serviceLocationId'];
        this.serviceLocation = _data['serviceLocation'];
        this.agentName = _data['agentName'];
        this.estateAdministrator = _data['estateAdministrator'];
        this.trustee = _data['trustee'];
        this.fileStage = _data['fileStage'] ? FileStageDto.fromJS(_data['fileStage']) : <any>undefined;
        this.descendantFileId = _data['descendantFileId'];
        this.descendantFileType = _data['descendantFileType'];
        this.courtName = _data['courtName'];
        this.courtNumber = _data['courtNumber'];
        this.isLocked = _data['isLocked'];
        this.isAppFormLocked = _data['isAppFormLocked'];
        this.isMigrated = _data['isMigrated'];
        this.migratedFileStage = _data['migratedFileStage'];
        this.isDuplicate = _data['isDuplicate'];
        this.insolvencyDate = _data['insolvencyDate'] ? moment(_data['insolvencyDate'].toString()) : <any>undefined;
        this.bankruptcyDuration = _data['bankruptcyDuration'];
        this.copiedFromFileId = _data['copiedFromFileId'];
      }
    }

    static fromJS(data: any): ApplicationFileDto {
      data = typeof data === 'object' ? data : {};
      let result = new ApplicationFileDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['applicationFileName'] = this.applicationFileName;
      data['debtorName'] = this.debtorName;
      data['estateNumber'] = this.estateNumber;
      data['filingType'] = this.filingType;
      data['filingTypeEnum'] = this.filingTypeEnum;
      data['serviceLocationId'] = this.serviceLocationId;
      data['serviceLocation'] = this.serviceLocation;
      data['agentName'] = this.agentName;
      data['estateAdministrator'] = this.estateAdministrator;
      data['trustee'] = this.trustee;
      data['fileStage'] = this.fileStage ? this.fileStage.toJSON() : <any>undefined;
      data['descendantFileId'] = this.descendantFileId;
      data['descendantFileType'] = this.descendantFileType;
      data['courtName'] = this.courtName;
      data['courtNumber'] = this.courtNumber;
      data['isLocked'] = this.isLocked;
      data['isAppFormLocked'] = this.isAppFormLocked;
      data['isMigrated'] = this.isMigrated;
      data['migratedFileStage'] = this.migratedFileStage;
      data['isDuplicate'] = this.isDuplicate;
      data['insolvencyDate'] = this.insolvencyDate ? this.insolvencyDate.toISOString() : <any>undefined;
      data['bankruptcyDuration'] = this.bankruptcyDuration;
      data['copiedFromFileId'] = this.copiedFromFileId;
      return data;
    }
  }

  export interface IApplicationFileDto {
    id?: string;
    applicationFileName?: string | undefined;
    debtorName?: string | undefined;
    estateNumber?: string | undefined;
    filingType?: string | undefined;
    filingTypeEnum?: FilingTypeEnum;
    serviceLocationId?: string | undefined;
    serviceLocation?: string | undefined;
    agentName?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    fileStage?: FileStageDto;
    descendantFileId?: string | undefined;
    descendantFileType?: AppFileDescendantType;
    courtName?: string | undefined;
    courtNumber?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    migratedFileStage?: FileStageEnum;
    isDuplicate?: boolean | undefined;
    insolvencyDate?: moment.Moment | undefined;
    bankruptcyDuration?: string | undefined;
    copiedFromFileId?: string | undefined;
  }

  export class FileStageDto implements IFileStageDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileStageEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: IFileStageDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.enumValue = _data['enumValue'];
        this.code = _data['code'];
        this.name = _data['name'];
      }
    }

    static fromJS(data: any): FileStageDto {
      data = typeof data === 'object' ? data : {};
      let result = new FileStageDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['enumValue'] = this.enumValue;
      data['code'] = this.code;
      data['name'] = this.name;
      return data;
    }
  }

  export interface IFileStageDto {
    id?: string;
    orderNumber?: number;
    enumValue?: FileStageEnum;
    code?: string | undefined;
    name?: string | undefined;
  }

  export class AppointmentInfoDto implements IAppointmentInfoDto {
    id?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    officeAddress?: string | undefined;
    officeLocationId?: string | undefined;
    startDateTimeLocal?: moment.Moment;
    timeZoneCode?: string | undefined;
    duration?: number;
    meetingTypeId?: string;
    appointmentTypeId?: string;
    appointmentStatusId?: string;
    agentId?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;

    constructor(data?: IAppointmentInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.emailAddress = _data['emailAddress'];
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
        this.officeAddress = _data['officeAddress'];
        this.officeLocationId = _data['officeLocationId'];
        this.startDateTimeLocal = _data['startDateTimeLocal']
          ? moment(_data['startDateTimeLocal'].toString())
          : <any>undefined;
        this.timeZoneCode = _data['timeZoneCode'];
        this.duration = _data['duration'];
        this.meetingTypeId = _data['meetingTypeId'];
        this.appointmentTypeId = _data['appointmentTypeId'];
        this.appointmentStatusId = _data['appointmentStatusId'];
        this.agentId = _data['agentId'];
        this.appointmentType = _data['appointmentType'];
        this.agentName = _data['agentName'];
        this.meetingType = _data['meetingType'];
        this.appointmentStatus = _data['appointmentStatus'];
      }
    }

    static fromJS(data: any): AppointmentInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new AppointmentInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['emailAddress'] = this.emailAddress;
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      data['officeAddress'] = this.officeAddress;
      data['officeLocationId'] = this.officeLocationId;
      data['startDateTimeLocal'] = this.startDateTimeLocal ? this.startDateTimeLocal.toISOString() : <any>undefined;
      data['timeZoneCode'] = this.timeZoneCode;
      data['duration'] = this.duration;
      data['meetingTypeId'] = this.meetingTypeId;
      data['appointmentTypeId'] = this.appointmentTypeId;
      data['appointmentStatusId'] = this.appointmentStatusId;
      data['agentId'] = this.agentId;
      data['appointmentType'] = this.appointmentType;
      data['agentName'] = this.agentName;
      data['meetingType'] = this.meetingType;
      data['appointmentStatus'] = this.appointmentStatus;
      return data;
    }
  }

  export interface IAppointmentInfoDto {
    id?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    emailAddress?: string | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    officeAddress?: string | undefined;
    officeLocationId?: string | undefined;
    startDateTimeLocal?: moment.Moment;
    timeZoneCode?: string | undefined;
    duration?: number;
    meetingTypeId?: string;
    appointmentTypeId?: string;
    appointmentStatusId?: string;
    agentId?: string | undefined;
    appointmentType?: string | undefined;
    agentName?: string | undefined;
    meetingType?: string | undefined;
    appointmentStatus?: string | undefined;
  }

  export class AvailableTimeSlotsDto implements IAvailableTimeSlotsDto {
    timeZone?: string | undefined;
    timeSlots?: moment.Moment[] | undefined;

    constructor(data?: IAvailableTimeSlotsDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.timeZone = _data['timeZone'];
        if (Array.isArray(_data['timeSlots'])) {
          this.timeSlots = [] as any;
          for (let item of _data['timeSlots']) this.timeSlots!.push(moment(item));
        }
      }
    }

    static fromJS(data: any): AvailableTimeSlotsDto {
      data = typeof data === 'object' ? data : {};
      let result = new AvailableTimeSlotsDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['timeZone'] = this.timeZone;
      if (Array.isArray(this.timeSlots)) {
        data['timeSlots'] = [];
        for (let item of this.timeSlots) data['timeSlots'].push(item.toISOString());
      }
      return data;
    }
  }

  export interface IAvailableTimeSlotsDto {
    timeZone?: string | undefined;
    timeSlots?: moment.Moment[] | undefined;
  }

  export class BookAppointmentInputPublicDto implements IBookAppointmentInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;

    constructor(data?: IBookAppointmentInputPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.dateTime = _data['dateTime'] ? moment(_data['dateTime'].toString()) : <any>undefined;
        this.meetingTypeEnum = _data['meetingTypeEnum'];
        this.officeLocationId = _data['officeLocationId'];
      }
    }

    static fromJS(data: any): BookAppointmentInputPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new BookAppointmentInputPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['dateTime'] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
      data['meetingTypeEnum'] = this.meetingTypeEnum;
      data['officeLocationId'] = this.officeLocationId;
      return data;
    }
  }

  export interface IBookAppointmentInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
  }

  export class BookInitialAppointmenInputPublicDto implements IBookInitialAppointmenInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
    agentId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
    isEmailPhoneEnabled?: boolean;
    isPreferedLanguageEnglish?: boolean;
    url?: string | undefined;

    constructor(data?: IBookInitialAppointmenInputPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.dateTime = _data['dateTime'] ? moment(_data['dateTime'].toString()) : <any>undefined;
        this.meetingTypeEnum = _data['meetingTypeEnum'];
        this.officeLocationId = _data['officeLocationId'];
        this.agentId = _data['agentId'];
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
        this.emailAddress = _data['emailAddress'];
        this.referralSourceTypeId = _data['referralSourceTypeId'];
        this.referralDetails = _data['referralDetails'];
        this.isEmailPhoneEnabled = _data['isEmailPhoneEnabled'];
        this.isPreferedLanguageEnglish = _data['isPreferedLanguageEnglish'];
        this.url = _data['url'];
      }
    }

    static fromJS(data: any): BookInitialAppointmenInputPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new BookInitialAppointmenInputPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['dateTime'] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
      data['meetingTypeEnum'] = this.meetingTypeEnum;
      data['officeLocationId'] = this.officeLocationId;
      data['agentId'] = this.agentId;
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      data['emailAddress'] = this.emailAddress;
      data['referralSourceTypeId'] = this.referralSourceTypeId;
      data['referralDetails'] = this.referralDetails;
      data['isEmailPhoneEnabled'] = this.isEmailPhoneEnabled;
      data['isPreferedLanguageEnglish'] = this.isPreferedLanguageEnglish;
      data['url'] = this.url;
      return data;
    }
  }

  export interface IBookInitialAppointmenInputPublicDto {
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
    agentId?: string;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    mainPhoneTypeId?: string;
    mainPhoneNumber?: string | undefined;
    emailAddress?: string | undefined;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
    isEmailPhoneEnabled?: boolean;
    isPreferedLanguageEnglish?: boolean;
    url?: string | undefined;
  }

  export class ReserveAppointmentDto implements IReserveAppointmentDto {
    dateTime?: moment.Moment;
    officeLocationId?: string;
    isPreferedLanguageEnglish?: boolean;
    meetingTypeEnum?: MeetingTypeEnum;
    agentIds?: string[] | undefined;

    constructor(data?: IReserveAppointmentDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.dateTime = _data['dateTime'] ? moment(_data['dateTime'].toString()) : <any>undefined;
        this.officeLocationId = _data['officeLocationId'];
        this.isPreferedLanguageEnglish = _data['isPreferedLanguageEnglish'];
        this.meetingTypeEnum = _data['meetingTypeEnum'];
        if (Array.isArray(_data['agentIds'])) {
          this.agentIds = [] as any;
          for (let item of _data['agentIds']) this.agentIds!.push(item);
        }
      }
    }

    static fromJS(data: any): ReserveAppointmentDto {
      data = typeof data === 'object' ? data : {};
      let result = new ReserveAppointmentDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['dateTime'] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
      data['officeLocationId'] = this.officeLocationId;
      data['isPreferedLanguageEnglish'] = this.isPreferedLanguageEnglish;
      data['meetingTypeEnum'] = this.meetingTypeEnum;
      if (Array.isArray(this.agentIds)) {
        data['agentIds'] = [];
        for (let item of this.agentIds) data['agentIds'].push(item);
      }
      return data;
    }
  }

  export interface IReserveAppointmentDto {
    dateTime?: moment.Moment;
    officeLocationId?: string;
    isPreferedLanguageEnglish?: boolean;
    meetingTypeEnum?: MeetingTypeEnum;
    agentIds?: string[] | undefined;
  }

  export class UpdateAppointmentPublicDto implements IUpdateAppointmentPublicDto {
    appointmentId?: string;
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;

    constructor(data?: IUpdateAppointmentPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.appointmentId = _data['appointmentId'];
        this.dateTime = _data['dateTime'] ? moment(_data['dateTime'].toString()) : <any>undefined;
        this.meetingTypeEnum = _data['meetingTypeEnum'];
        this.officeLocationId = _data['officeLocationId'];
      }
    }

    static fromJS(data: any): UpdateAppointmentPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new UpdateAppointmentPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['appointmentId'] = this.appointmentId;
      data['dateTime'] = this.dateTime ? this.dateTime.toISOString() : <any>undefined;
      data['meetingTypeEnum'] = this.meetingTypeEnum;
      data['officeLocationId'] = this.officeLocationId;
      return data;
    }
  }

  export interface IUpdateAppointmentPublicDto {
    appointmentId?: string;
    dateTime?: moment.Moment;
    meetingTypeEnum?: MeetingTypeEnum;
    officeLocationId?: string;
  }

  export class BalanceInfoDto implements IBalanceInfoDto {
    startingBalance?: number;
    paidBalance?: number;

    constructor(data?: IBalanceInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.startingBalance = _data['startingBalance'];
        this.paidBalance = _data['paidBalance'];
      }
    }

    static fromJS(data: any): BalanceInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new BalanceInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['startingBalance'] = this.startingBalance;
      data['paidBalance'] = this.paidBalance;
      return data;
    }
  }

  export interface IBalanceInfoDto {
    startingBalance?: number;
    paidBalance?: number;
  }

  export class PADInfoChangeRequestCreatePublicDto implements IPADInfoChangeRequestCreatePublicDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    documentIds?: string[] | undefined;

    constructor(data?: IPADInfoChangeRequestCreatePublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.accountName = _data['accountName'];
        this.bankName = _data['bankName'];
        this.bankAddress = _data['bankAddress'];
        this.accountNumber = _data['accountNumber'];
        this.transitNumber = _data['transitNumber'];
        this.branchNumber = _data['branchNumber'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
      }
    }

    static fromJS(data: any): PADInfoChangeRequestCreatePublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new PADInfoChangeRequestCreatePublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['accountName'] = this.accountName;
      data['bankName'] = this.bankName;
      data['bankAddress'] = this.bankAddress;
      data['accountNumber'] = this.accountNumber;
      data['transitNumber'] = this.transitNumber;
      data['branchNumber'] = this.branchNumber;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      return data;
    }
  }

  export interface IPADInfoChangeRequestCreatePublicDto {
    accountName?: string | undefined;
    bankName?: string | undefined;
    bankAddress?: string | undefined;
    accountNumber?: string | undefined;
    transitNumber?: string | undefined;
    branchNumber?: string | undefined;
    documentIds?: string[] | undefined;
  }

  export class PADScheduleDto implements IPADScheduleDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    externalPadScheduleId?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    deposited?: number;
    isDeposited?: boolean;
    isPending?: boolean;
    paymentStatus?: PADSchedulePaymentStatusEnum;
    agrNo?: number;
    hasReceipts?: boolean;

    constructor(data?: IPADScheduleDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.state = _data['state'];
        this.holdUntil = _data['holdUntil'] ? moment(_data['holdUntil'].toString()) : <any>undefined;
        this.holdReason = _data['holdReason'];
        this.externalPadScheduleId = _data['externalPadScheduleId'];
        this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
        this.type = _data['type'];
        this.no = _data['no'];
        this.amount = _data['amount'];
        this.deposited = _data['deposited'];
        this.isDeposited = _data['isDeposited'];
        this.isPending = _data['isPending'];
        this.paymentStatus = _data['paymentStatus'];
        this.agrNo = _data['agrNo'];
        this.hasReceipts = _data['hasReceipts'];
      }
    }

    static fromJS(data: any): PADScheduleDto {
      data = typeof data === 'object' ? data : {};
      let result = new PADScheduleDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['state'] = this.state;
      data['holdUntil'] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
      data['holdReason'] = this.holdReason;
      data['externalPadScheduleId'] = this.externalPadScheduleId;
      data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
      data['type'] = this.type;
      data['no'] = this.no;
      data['amount'] = this.amount;
      data['deposited'] = this.deposited;
      data['isDeposited'] = this.isDeposited;
      data['isPending'] = this.isPending;
      data['paymentStatus'] = this.paymentStatus;
      data['agrNo'] = this.agrNo;
      data['hasReceipts'] = this.hasReceipts;
      return data;
    }
  }

  export interface IPADScheduleDto {
    id?: string;
    state?: PADScheduleStateEnum;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    externalPadScheduleId?: string | undefined;
    dueDate?: moment.Moment | undefined;
    type?: string | undefined;
    no?: string | undefined;
    amount?: number;
    deposited?: number;
    isDeposited?: boolean;
    isPending?: boolean;
    paymentStatus?: PADSchedulePaymentStatusEnum;
    agrNo?: number;
    hasReceipts?: boolean;
  }

  export class PADScheduleUpdatePublicDto implements IPADScheduleUpdatePublicDto {
    id?: string;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    state?: PADScheduleStateEnum;

    constructor(data?: IPADScheduleUpdatePublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.holdUntil = _data['holdUntil'] ? moment(_data['holdUntil'].toString()) : <any>undefined;
        this.holdReason = _data['holdReason'];
        this.state = _data['state'];
      }
    }

    static fromJS(data: any): PADScheduleUpdatePublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new PADScheduleUpdatePublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['holdUntil'] = this.holdUntil ? this.holdUntil.toISOString() : <any>undefined;
      data['holdReason'] = this.holdReason;
      data['state'] = this.state;
      return data;
    }
  }

  export interface IPADScheduleUpdatePublicDto {
    id?: string;
    holdUntil?: moment.Moment | undefined;
    holdReason?: string | undefined;
    state?: PADScheduleStateEnum;
  }

  export class PublicPADInfoDto implements IPublicPADInfoDto {
    accountOwner?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    userCanSendChangeRequest?: boolean;

    constructor(data?: IPublicPADInfoDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.accountOwner = _data['accountOwner'];
        this.bankAccountNumber = _data['bankAccountNumber'];
        this.bankTransitNumber = _data['bankTransitNumber'];
        this.bankBranchNumber = _data['bankBranchNumber'];
        this.userCanSendChangeRequest = _data['userCanSendChangeRequest'];
      }
    }

    static fromJS(data: any): PublicPADInfoDto {
      data = typeof data === 'object' ? data : {};
      let result = new PublicPADInfoDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['accountOwner'] = this.accountOwner;
      data['bankAccountNumber'] = this.bankAccountNumber;
      data['bankTransitNumber'] = this.bankTransitNumber;
      data['bankBranchNumber'] = this.bankBranchNumber;
      data['userCanSendChangeRequest'] = this.userCanSendChangeRequest;
      return data;
    }
  }

  export interface IPublicPADInfoDto {
    accountOwner?: string | undefined;
    bankAccountNumber?: string | undefined;
    bankTransitNumber?: string | undefined;
    bankBranchNumber?: string | undefined;
    userCanSendChangeRequest?: boolean;
  }

  export class ClientPhoneDto implements IClientPhoneDto {
    id?: string;
    phoneTypeId?: string;
    phoneNumber?: string | undefined;
    doNotContact?: boolean;
    doNotSMS?: boolean;
    isDeleted?: boolean;

    constructor(data?: IClientPhoneDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.phoneTypeId = _data['phoneTypeId'];
        this.phoneNumber = _data['phoneNumber'];
        this.doNotContact = _data['doNotContact'];
        this.doNotSMS = _data['doNotSMS'];
        this.isDeleted = _data['isDeleted'];
      }
    }

    static fromJS(data: any): ClientPhoneDto {
      data = typeof data === 'object' ? data : {};
      let result = new ClientPhoneDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['phoneTypeId'] = this.phoneTypeId;
      data['phoneNumber'] = this.phoneNumber;
      data['doNotContact'] = this.doNotContact;
      data['doNotSMS'] = this.doNotSMS;
      data['isDeleted'] = this.isDeleted;
      return data;
    }
  }

  export interface IClientPhoneDto {
    id?: string;
    phoneTypeId?: string;
    phoneNumber?: string | undefined;
    doNotContact?: boolean;
    doNotSMS?: boolean;
    isDeleted?: boolean;
  }

  export class DebtorPasswordUpdatePublicDto implements IDebtorPasswordUpdatePublicDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;

    constructor(data?: IDebtorPasswordUpdatePublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.oldPassword = _data['oldPassword'];
        this.newPassword = _data['newPassword'];
        this.confirmNewPassword = _data['confirmNewPassword'];
      }
    }

    static fromJS(data: any): DebtorPasswordUpdatePublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorPasswordUpdatePublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['oldPassword'] = this.oldPassword;
      data['newPassword'] = this.newPassword;
      data['confirmNewPassword'] = this.confirmNewPassword;
      return data;
    }
  }

  export interface IDebtorPasswordUpdatePublicDto {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    confirmNewPassword?: string | undefined;
  }

  export class DebtorProfileDto implements IDebtorProfileDto {
    fileId?: string;
    clientId?: string;
    isFileStagePostSignup?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    canResetPassword?: boolean;
    enableClientLogin?: boolean;
    enablePortalNotifications?: boolean;
    address?: string | undefined;
    unit?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    mainPhoneDoNotContact?: boolean;
    mainPhoneDoNotSMS?: boolean;
    emailAddress?: string | undefined;
    doNotEmail?: boolean;
    alternatePhoneNumbers?: ClientPhoneDto[] | undefined;
    intakeSourceId?: string | undefined;
    referralSource?: ReferralSourceDto;
    referralSourceTypeId?: string | undefined;
    referralDetails?: string | undefined;
    notes?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    canCreateNewApplication?: boolean;
    preferredLanguageId?: string | undefined;
    descendantFileId?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    copiedFromFileId?: string | undefined;
    receiveEmailConsent?: boolean | undefined;

    constructor(data?: IDebtorProfileDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.clientId = _data['clientId'];
        this.isFileStagePostSignup = _data['isFileStagePostSignup'];
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.userName = _data['userName'];
        this.dateOfBirth = _data['dateOfBirth'] ? moment(_data['dateOfBirth'].toString()) : <any>undefined;
        this.canResetPassword = _data['canResetPassword'];
        this.enableClientLogin = _data['enableClientLogin'];
        this.enablePortalNotifications = _data['enablePortalNotifications'];
        this.address = _data['address'];
        this.unit = _data['unit'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.city = _data['city'];
        this.cityTypeId = _data['cityTypeId'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.latitude = _data['latitude'];
        this.longitude = _data['longitude'];
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
        this.mainPhoneDoNotContact = _data['mainPhoneDoNotContact'];
        this.mainPhoneDoNotSMS = _data['mainPhoneDoNotSMS'];
        this.emailAddress = _data['emailAddress'];
        this.doNotEmail = _data['doNotEmail'];
        if (Array.isArray(_data['alternatePhoneNumbers'])) {
          this.alternatePhoneNumbers = [] as any;
          for (let item of _data['alternatePhoneNumbers'])
            this.alternatePhoneNumbers!.push(ClientPhoneDto.fromJS(item));
        }
        this.intakeSourceId = _data['intakeSourceId'];
        this.referralSource = _data['referralSource']
          ? ReferralSourceDto.fromJS(_data['referralSource'])
          : <any>undefined;
        this.referralSourceTypeId = _data['referralSourceTypeId'];
        this.referralDetails = _data['referralDetails'];
        this.notes = _data['notes'];
        this.followUpDate = _data['followUpDate'] ? moment(_data['followUpDate'].toString()) : <any>undefined;
        this.canCreateNewApplication = _data['canCreateNewApplication'];
        this.preferredLanguageId = _data['preferredLanguageId'];
        this.descendantFileId = _data['descendantFileId'];
        this.isLocked = _data['isLocked'];
        this.isAppFormLocked = _data['isAppFormLocked'];
        this.isMigrated = _data['isMigrated'];
        this.isDuplicate = _data['isDuplicate'];
        this.isRegisteredToClientPortal = _data['isRegisteredToClientPortal'];
        this.copiedFromFileId = _data['copiedFromFileId'];
        this.receiveEmailConsent = _data['receiveEmailConsent'];
      }
    }

    static fromJS(data: any): DebtorProfileDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorProfileDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['clientId'] = this.clientId;
      data['isFileStagePostSignup'] = this.isFileStagePostSignup;
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['userName'] = this.userName;
      data['dateOfBirth'] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
      data['canResetPassword'] = this.canResetPassword;
      data['enableClientLogin'] = this.enableClientLogin;
      data['enablePortalNotifications'] = this.enablePortalNotifications;
      data['address'] = this.address;
      data['unit'] = this.unit;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['city'] = this.city;
      data['cityTypeId'] = this.cityTypeId;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['latitude'] = this.latitude;
      data['longitude'] = this.longitude;
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      data['mainPhoneDoNotContact'] = this.mainPhoneDoNotContact;
      data['mainPhoneDoNotSMS'] = this.mainPhoneDoNotSMS;
      data['emailAddress'] = this.emailAddress;
      data['doNotEmail'] = this.doNotEmail;
      if (Array.isArray(this.alternatePhoneNumbers)) {
        data['alternatePhoneNumbers'] = [];
        for (let item of this.alternatePhoneNumbers) data['alternatePhoneNumbers'].push(item.toJSON());
      }
      data['intakeSourceId'] = this.intakeSourceId;
      data['referralSource'] = this.referralSource ? this.referralSource.toJSON() : <any>undefined;
      data['referralSourceTypeId'] = this.referralSourceTypeId;
      data['referralDetails'] = this.referralDetails;
      data['notes'] = this.notes;
      data['followUpDate'] = this.followUpDate ? this.followUpDate.toISOString() : <any>undefined;
      data['canCreateNewApplication'] = this.canCreateNewApplication;
      data['preferredLanguageId'] = this.preferredLanguageId;
      data['descendantFileId'] = this.descendantFileId;
      data['isLocked'] = this.isLocked;
      data['isAppFormLocked'] = this.isAppFormLocked;
      data['isMigrated'] = this.isMigrated;
      data['isDuplicate'] = this.isDuplicate;
      data['isRegisteredToClientPortal'] = this.isRegisteredToClientPortal;
      data['copiedFromFileId'] = this.copiedFromFileId;
      data['receiveEmailConsent'] = this.receiveEmailConsent;
      return data;
    }
  }

  export interface IDebtorProfileDto {
    fileId?: string;
    clientId?: string;
    isFileStagePostSignup?: boolean | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    canResetPassword?: boolean;
    enableClientLogin?: boolean;
    enablePortalNotifications?: boolean;
    address?: string | undefined;
    unit?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    city?: string | undefined;
    cityTypeId?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
    mainPhoneDoNotContact?: boolean;
    mainPhoneDoNotSMS?: boolean;
    emailAddress?: string | undefined;
    doNotEmail?: boolean;
    alternatePhoneNumbers?: ClientPhoneDto[] | undefined;
    intakeSourceId?: string | undefined;
    referralSource?: ReferralSourceDto;
    referralSourceTypeId?: string | undefined;
    referralDetails?: string | undefined;
    notes?: string | undefined;
    followUpDate?: moment.Moment | undefined;
    canCreateNewApplication?: boolean;
    preferredLanguageId?: string | undefined;
    descendantFileId?: string | undefined;
    isLocked?: boolean | undefined;
    isAppFormLocked?: boolean | undefined;
    isMigrated?: boolean | undefined;
    isDuplicate?: boolean | undefined;
    isRegisteredToClientPortal?: boolean;
    copiedFromFileId?: string | undefined;
    receiveEmailConsent?: boolean | undefined;
  }

  export class DebtorProfileHeaderDto implements IDebtorProfileHeaderDto {
    createdDate?: moment.Moment;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: LookupReadOnlyDto;

    constructor(data?: IDebtorProfileHeaderDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.createdDate = _data['createdDate'] ? moment(_data['createdDate'].toString()) : <any>undefined;
        this.agent = _data['agent'];
        this.estateAdministrator = _data['estateAdministrator'];
        this.trustee = _data['trustee'];
        this.stage = _data['stage'] ? LookupReadOnlyDto.fromJS(_data['stage']) : <any>undefined;
      }
    }

    static fromJS(data: any): DebtorProfileHeaderDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorProfileHeaderDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['createdDate'] = this.createdDate ? this.createdDate.toISOString() : <any>undefined;
      data['agent'] = this.agent;
      data['estateAdministrator'] = this.estateAdministrator;
      data['trustee'] = this.trustee;
      data['stage'] = this.stage ? this.stage.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IDebtorProfileHeaderDto {
    createdDate?: moment.Moment;
    agent?: string | undefined;
    estateAdministrator?: string | undefined;
    trustee?: string | undefined;
    stage?: LookupReadOnlyDto;
  }

  export class DebtorProfilePageDto implements IDebtorProfilePageDto {
    header?: DebtorProfileHeaderDto;
    profile?: DebtorProfileDto;

    constructor(data?: IDebtorProfilePageDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.header = _data['header'] ? DebtorProfileHeaderDto.fromJS(_data['header']) : <any>undefined;
        this.profile = _data['profile'] ? DebtorProfileDto.fromJS(_data['profile']) : <any>undefined;
      }
    }

    static fromJS(data: any): DebtorProfilePageDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorProfilePageDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['header'] = this.header ? this.header.toJSON() : <any>undefined;
      data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IDebtorProfilePageDto {
    header?: DebtorProfileHeaderDto;
    profile?: DebtorProfileDto;
  }

  export class DebtorProfileUpdatePublicDto implements IDebtorProfileUpdatePublicDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;

    constructor(data?: IDebtorProfileUpdatePublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.firstName = _data['firstName'];
        this.middleName = _data['middleName'];
        this.lastName = _data['lastName'];
        this.dateOfBirth = _data['dateOfBirth'] ? moment(_data['dateOfBirth'].toString()) : <any>undefined;
        this.address = _data['address'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.latitude = _data['latitude'];
        this.longitude = _data['longitude'];
        this.mainPhoneTypeId = _data['mainPhoneTypeId'];
        this.mainPhoneNumber = _data['mainPhoneNumber'];
      }
    }

    static fromJS(data: any): DebtorProfileUpdatePublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorProfileUpdatePublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['firstName'] = this.firstName;
      data['middleName'] = this.middleName;
      data['lastName'] = this.lastName;
      data['dateOfBirth'] = this.dateOfBirth ? this.dateOfBirth.toISOString() : <any>undefined;
      data['address'] = this.address;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['latitude'] = this.latitude;
      data['longitude'] = this.longitude;
      data['mainPhoneTypeId'] = this.mainPhoneTypeId;
      data['mainPhoneNumber'] = this.mainPhoneNumber;
      return data;
    }
  }

  export interface IDebtorProfileUpdatePublicDto {
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    address?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    mainPhoneTypeId?: string | undefined;
    mainPhoneNumber?: string | undefined;
  }

  export class DebtorSettingsPublicUpdateDto implements IDebtorSettingsPublicUpdateDto {
    isAllowedEmailNotifications?: boolean;
    isAllowedSMSNotifications?: boolean;

    constructor(data?: IDebtorSettingsPublicUpdateDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.isAllowedEmailNotifications = _data['isAllowedEmailNotifications'];
        this.isAllowedSMSNotifications = _data['isAllowedSMSNotifications'];
      }
    }

    static fromJS(data: any): DebtorSettingsPublicUpdateDto {
      data = typeof data === 'object' ? data : {};
      let result = new DebtorSettingsPublicUpdateDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['isAllowedEmailNotifications'] = this.isAllowedEmailNotifications;
      data['isAllowedSMSNotifications'] = this.isAllowedSMSNotifications;
      return data;
    }
  }

  export interface IDebtorSettingsPublicUpdateDto {
    isAllowedEmailNotifications?: boolean;
    isAllowedSMSNotifications?: boolean;
  }

  export class ReferralSourceDto implements IReferralSourceDto {
    id?: string;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;

    constructor(data?: IReferralSourceDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.referralSourceTypeId = _data['referralSourceTypeId'];
        this.referralDetails = _data['referralDetails'];
      }
    }

    static fromJS(data: any): ReferralSourceDto {
      data = typeof data === 'object' ? data : {};
      let result = new ReferralSourceDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['referralSourceTypeId'] = this.referralSourceTypeId;
      data['referralDetails'] = this.referralDetails;
      return data;
    }
  }

  export interface IReferralSourceDto {
    id?: string;
    referralSourceTypeId?: string;
    referralDetails?: string | undefined;
  }

  export class GoogleApiKeyDto implements IGoogleApiKeyDto {
    apiKey?: string | undefined;

    constructor(data?: IGoogleApiKeyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.apiKey = _data['apiKey'];
      }
    }

    static fromJS(data: any): GoogleApiKeyDto {
      data = typeof data === 'object' ? data : {};
      let result = new GoogleApiKeyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['apiKey'] = this.apiKey;
      return data;
    }
  }

  export interface IGoogleApiKeyDto {
    apiKey?: string | undefined;
  }

  export class VerifyReCaptchaTokenDto implements IVerifyReCaptchaTokenDto {
    token?: string | undefined;

    constructor(data?: IVerifyReCaptchaTokenDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.token = _data['token'];
      }
    }

    static fromJS(data: any): VerifyReCaptchaTokenDto {
      data = typeof data === 'object' ? data : {};
      let result = new VerifyReCaptchaTokenDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['token'] = this.token;
      return data;
    }
  }

  export interface IVerifyReCaptchaTokenDto {
    token?: string | undefined;
  }

  export class ContactStaffDto implements IContactStaffDto {
    teamId?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;

    constructor(data?: IContactStaffDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.teamId = _data['teamId'];
        this.subject = _data['subject'];
        this.message = _data['message'];
      }
    }

    static fromJS(data: any): ContactStaffDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContactStaffDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['teamId'] = this.teamId;
      data['subject'] = this.subject;
      data['message'] = this.message;
      return data;
    }
  }

  export interface IContactStaffDto {
    teamId?: string | undefined;
    subject?: string | undefined;
    message?: string | undefined;
  }

  export class ContactSupportFormDto implements IContactSupportFormDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    inquiryType?: string | undefined;
    comments?: string | undefined;
    token?: string | undefined;

    constructor(data?: IContactSupportFormDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.name = _data['name'];
        this.email = _data['email'];
        this.phoneNumber = _data['phoneNumber'];
        this.inquiryType = _data['inquiryType'];
        this.comments = _data['comments'];
        this.token = _data['token'];
      }
    }

    static fromJS(data: any): ContactSupportFormDto {
      data = typeof data === 'object' ? data : {};
      let result = new ContactSupportFormDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['name'] = this.name;
      data['email'] = this.email;
      data['phoneNumber'] = this.phoneNumber;
      data['inquiryType'] = this.inquiryType;
      data['comments'] = this.comments;
      data['token'] = this.token;
      return data;
    }
  }

  export interface IContactSupportFormDto {
    name?: string | undefined;
    email?: string | undefined;
    phoneNumber?: string | undefined;
    inquiryType?: string | undefined;
    comments?: string | undefined;
    token?: string | undefined;
  }

  export class DocumentDto implements IDocumentDto {
    id?: string;
    name?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentPrefixId?: string | undefined;
    documentPrefixName?: string | undefined;
    additionalInformation?: string | undefined;
    documentVerificationId?: string | undefined;
    verificationStatus?: DocumentVerificationStatusEnum;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;
    isVisible?: boolean;
    isSupportingDocumentReviewed?: boolean | undefined;

    constructor(data?: IDocumentDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.documentFolderId = _data['documentFolderId'];
        this.documentFolderName = _data['documentFolderName'];
        this.uploadDate = _data['uploadDate'] ? moment(_data['uploadDate'].toString()) : <any>undefined;
        this.modifiedDate = _data['modifiedDate'] ? moment(_data['modifiedDate'].toString()) : <any>undefined;
        this.fileSizeInBytes = _data['fileSizeInBytes'];
        this.documentTypeId = _data['documentTypeId'];
        this.documentTypeName = _data['documentTypeName'];
        this.documentPrefixId = _data['documentPrefixId'];
        this.documentPrefixName = _data['documentPrefixName'];
        this.additionalInformation = _data['additionalInformation'];
        this.documentVerificationId = _data['documentVerificationId'];
        this.verificationStatus = _data['verificationStatus'];
        this.isForSpouse = _data['isForSpouse'];
        this.businessName = _data['businessName'];
        this.isVisible = _data['isVisible'];
        this.isSupportingDocumentReviewed = _data['isSupportingDocumentReviewed'];
      }
    }

    static fromJS(data: any): DocumentDto {
      data = typeof data === 'object' ? data : {};
      let result = new DocumentDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['documentFolderId'] = this.documentFolderId;
      data['documentFolderName'] = this.documentFolderName;
      data['uploadDate'] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
      data['modifiedDate'] = this.modifiedDate ? this.modifiedDate.toISOString() : <any>undefined;
      data['fileSizeInBytes'] = this.fileSizeInBytes;
      data['documentTypeId'] = this.documentTypeId;
      data['documentTypeName'] = this.documentTypeName;
      data['documentPrefixId'] = this.documentPrefixId;
      data['documentPrefixName'] = this.documentPrefixName;
      data['additionalInformation'] = this.additionalInformation;
      data['documentVerificationId'] = this.documentVerificationId;
      data['verificationStatus'] = this.verificationStatus;
      data['isForSpouse'] = this.isForSpouse;
      data['businessName'] = this.businessName;
      data['isVisible'] = this.isVisible;
      data['isSupportingDocumentReviewed'] = this.isSupportingDocumentReviewed;
      return data;
    }
  }

  export interface IDocumentDto {
    id?: string;
    name?: string | undefined;
    frenchName?: string | undefined;
    documentFolderId?: string;
    documentFolderName?: string | undefined;
    uploadDate?: moment.Moment;
    modifiedDate?: moment.Moment | undefined;
    fileSizeInBytes?: number;
    documentTypeId?: string;
    documentTypeName?: string | undefined;
    documentPrefixId?: string | undefined;
    documentPrefixName?: string | undefined;
    additionalInformation?: string | undefined;
    documentVerificationId?: string | undefined;
    verificationStatus?: DocumentVerificationStatusEnum;
    isForSpouse?: boolean | undefined;
    businessName?: string | undefined;
    isVisible?: boolean;
    isSupportingDocumentReviewed?: boolean | undefined;
  }

  export class ExpenseSubmissionItemCreateDto implements IExpenseSubmissionItemCreateDto {
    expenseTypeId?: string;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;

    constructor(data?: IExpenseSubmissionItemCreateDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.expenseTypeId = _data['expenseTypeId'];
        this.expenseDescriptionId = _data['expenseDescriptionId'];
        this.amountApplicant = _data['amountApplicant'];
        this.amountSpouse = _data['amountSpouse'];
        this.amountOther = _data['amountOther'];
        this.otherDescription = _data['otherDescription'];
      }
    }

    static fromJS(data: any): ExpenseSubmissionItemCreateDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExpenseSubmissionItemCreateDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['expenseTypeId'] = this.expenseTypeId;
      data['expenseDescriptionId'] = this.expenseDescriptionId;
      data['amountApplicant'] = this.amountApplicant;
      data['amountSpouse'] = this.amountSpouse;
      data['amountOther'] = this.amountOther;
      data['otherDescription'] = this.otherDescription;
      return data;
    }
  }

  export interface IExpenseSubmissionItemCreateDto {
    expenseTypeId?: string;
    expenseDescriptionId?: string;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
  }

  export class ExpenseSubmissionItemPublicDto implements IExpenseSubmissionItemPublicDto {
    id?: string | undefined;
    expenseType?: LookupDto;
    expenseDescription?: LookupDto;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IExpenseSubmissionItemPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.expenseType = _data['expenseType'] ? LookupDto.fromJS(_data['expenseType']) : <any>undefined;
        this.expenseDescription = _data['expenseDescription']
          ? LookupDto.fromJS(_data['expenseDescription'])
          : <any>undefined;
        this.amountApplicant = _data['amountApplicant'];
        this.amountSpouse = _data['amountSpouse'];
        this.amountOther = _data['amountOther'];
        this.otherDescription = _data['otherDescription'];
        this.isMissingDocuments = _data['isMissingDocuments'];
      }
    }

    static fromJS(data: any): ExpenseSubmissionItemPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new ExpenseSubmissionItemPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['expenseType'] = this.expenseType ? this.expenseType.toJSON() : <any>undefined;
      data['expenseDescription'] = this.expenseDescription ? this.expenseDescription.toJSON() : <any>undefined;
      data['amountApplicant'] = this.amountApplicant;
      data['amountSpouse'] = this.amountSpouse;
      data['amountOther'] = this.amountOther;
      data['otherDescription'] = this.otherDescription;
      data['isMissingDocuments'] = this.isMissingDocuments;
      return data;
    }
  }

  export interface IExpenseSubmissionItemPublicDto {
    id?: string | undefined;
    expenseType?: LookupDto;
    expenseDescription?: LookupDto;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    otherDescription?: string | undefined;
    isMissingDocuments?: boolean;
  }

  export class IncomeExpenseSubmissionCreatePublicDto implements IIncomeExpenseSubmissionCreatePublicDto {
    numberOfHousehold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    incomeItems?: IncomeSubmissionItemCreateDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemCreateDto[] | undefined;

    constructor(data?: IIncomeExpenseSubmissionCreatePublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.numberOfHousehold = _data['numberOfHousehold'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.externalIeSubmissionPeriodId = _data['externalIeSubmissionPeriodId'];
        if (Array.isArray(_data['incomeItems'])) {
          this.incomeItems = [] as any;
          for (let item of _data['incomeItems']) this.incomeItems!.push(IncomeSubmissionItemCreateDto.fromJS(item));
        }
        if (Array.isArray(_data['expenseItems'])) {
          this.expenseItems = [] as any;
          for (let item of _data['expenseItems']) this.expenseItems!.push(ExpenseSubmissionItemCreateDto.fromJS(item));
        }
      }
    }

    static fromJS(data: any): IncomeExpenseSubmissionCreatePublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeExpenseSubmissionCreatePublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['numberOfHousehold'] = this.numberOfHousehold;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['externalIeSubmissionPeriodId'] = this.externalIeSubmissionPeriodId;
      if (Array.isArray(this.incomeItems)) {
        data['incomeItems'] = [];
        for (let item of this.incomeItems) data['incomeItems'].push(item.toJSON());
      }
      if (Array.isArray(this.expenseItems)) {
        data['expenseItems'] = [];
        for (let item of this.expenseItems) data['expenseItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IIncomeExpenseSubmissionCreatePublicDto {
    numberOfHousehold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    incomeItems?: IncomeSubmissionItemCreateDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemCreateDto[] | undefined;
  }

  export class IncomeExpenseSubmissionPeriodDto implements IIncomeExpenseSubmissionPeriodDto {
    externalIeSubmissionPeriodId?: string | undefined;
    scheduleNumber?: number;
    period?: number;
    dueDate?: moment.Moment | undefined;
    estimatedSurplus?: number;
    comments?: string | undefined;
    status?: IncomeExpensePeriodStatusEnum;

    constructor(data?: IIncomeExpenseSubmissionPeriodDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.externalIeSubmissionPeriodId = _data['externalIeSubmissionPeriodId'];
        this.scheduleNumber = _data['scheduleNumber'];
        this.period = _data['period'];
        this.dueDate = _data['dueDate'] ? moment(_data['dueDate'].toString()) : <any>undefined;
        this.estimatedSurplus = _data['estimatedSurplus'];
        this.comments = _data['comments'];
        this.status = _data['status'];
      }
    }

    static fromJS(data: any): IncomeExpenseSubmissionPeriodDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeExpenseSubmissionPeriodDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['externalIeSubmissionPeriodId'] = this.externalIeSubmissionPeriodId;
      data['scheduleNumber'] = this.scheduleNumber;
      data['period'] = this.period;
      data['dueDate'] = this.dueDate ? this.dueDate.toISOString() : <any>undefined;
      data['estimatedSurplus'] = this.estimatedSurplus;
      data['comments'] = this.comments;
      data['status'] = this.status;
      return data;
    }
  }

  export interface IIncomeExpenseSubmissionPeriodDto {
    externalIeSubmissionPeriodId?: string | undefined;
    scheduleNumber?: number;
    period?: number;
    dueDate?: moment.Moment | undefined;
    estimatedSurplus?: number;
    comments?: string | undefined;
    status?: IncomeExpensePeriodStatusEnum;
  }

  export class IncomeExpenseSubmissionPublicDto implements IIncomeExpenseSubmissionPublicDto {
    id?: string | undefined;
    numberOfHouseHold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    isChangeRequired?: boolean;
    commentsFromStaffPortal?: string | undefined;
    incomeItems?: IncomeSubmissionItemPublicDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemPublicDto[] | undefined;
    isNilIncomeBankStatementMissing?: boolean;

    constructor(data?: IIncomeExpenseSubmissionPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.numberOfHouseHold = _data['numberOfHouseHold'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
        this.externalIeSubmissionPeriodId = _data['externalIeSubmissionPeriodId'];
        this.isChangeRequired = _data['isChangeRequired'];
        this.commentsFromStaffPortal = _data['commentsFromStaffPortal'];
        if (Array.isArray(_data['incomeItems'])) {
          this.incomeItems = [] as any;
          for (let item of _data['incomeItems']) this.incomeItems!.push(IncomeSubmissionItemPublicDto.fromJS(item));
        }
        if (Array.isArray(_data['expenseItems'])) {
          this.expenseItems = [] as any;
          for (let item of _data['expenseItems']) this.expenseItems!.push(ExpenseSubmissionItemPublicDto.fromJS(item));
        }
        this.isNilIncomeBankStatementMissing = _data['isNilIncomeBankStatementMissing'];
      }
    }

    static fromJS(data: any): IncomeExpenseSubmissionPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeExpenseSubmissionPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['numberOfHouseHold'] = this.numberOfHouseHold;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      data['externalIeSubmissionPeriodId'] = this.externalIeSubmissionPeriodId;
      data['isChangeRequired'] = this.isChangeRequired;
      data['commentsFromStaffPortal'] = this.commentsFromStaffPortal;
      if (Array.isArray(this.incomeItems)) {
        data['incomeItems'] = [];
        for (let item of this.incomeItems) data['incomeItems'].push(item.toJSON());
      }
      if (Array.isArray(this.expenseItems)) {
        data['expenseItems'] = [];
        for (let item of this.expenseItems) data['expenseItems'].push(item.toJSON());
      }
      data['isNilIncomeBankStatementMissing'] = this.isNilIncomeBankStatementMissing;
      return data;
    }
  }

  export interface IIncomeExpenseSubmissionPublicDto {
    id?: string | undefined;
    numberOfHouseHold?: number;
    documentIds?: string[] | undefined;
    externalIeSubmissionPeriodId?: string | undefined;
    isChangeRequired?: boolean;
    commentsFromStaffPortal?: string | undefined;
    incomeItems?: IncomeSubmissionItemPublicDto[] | undefined;
    expenseItems?: ExpenseSubmissionItemPublicDto[] | undefined;
    isNilIncomeBankStatementMissing?: boolean;
  }

  export class IncomeSubmissionItemCreateDto implements IIncomeSubmissionItemCreateDto {
    incomeTypeId?: string;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;

    constructor(data?: IIncomeSubmissionItemCreateDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.incomeTypeId = _data['incomeTypeId'];
        this.description = _data['description'];
        this.amountApplicant = _data['amountApplicant'];
        this.amountSpouse = _data['amountSpouse'];
        this.amountOther = _data['amountOther'];
      }
    }

    static fromJS(data: any): IncomeSubmissionItemCreateDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeSubmissionItemCreateDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['incomeTypeId'] = this.incomeTypeId;
      data['description'] = this.description;
      data['amountApplicant'] = this.amountApplicant;
      data['amountSpouse'] = this.amountSpouse;
      data['amountOther'] = this.amountOther;
      return data;
    }
  }

  export interface IIncomeSubmissionItemCreateDto {
    incomeTypeId?: string;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
  }

  export class IncomeSubmissionItemPublicDto implements IIncomeSubmissionItemPublicDto {
    id?: string | undefined;
    incomeType?: LookupDto;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    isMissingDocuments?: boolean;

    constructor(data?: IIncomeSubmissionItemPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.incomeType = _data['incomeType'] ? LookupDto.fromJS(_data['incomeType']) : <any>undefined;
        this.description = _data['description'];
        this.amountApplicant = _data['amountApplicant'];
        this.amountSpouse = _data['amountSpouse'];
        this.amountOther = _data['amountOther'];
        this.isMissingDocuments = _data['isMissingDocuments'];
      }
    }

    static fromJS(data: any): IncomeSubmissionItemPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new IncomeSubmissionItemPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['incomeType'] = this.incomeType ? this.incomeType.toJSON() : <any>undefined;
      data['description'] = this.description;
      data['amountApplicant'] = this.amountApplicant;
      data['amountSpouse'] = this.amountSpouse;
      data['amountOther'] = this.amountOther;
      data['isMissingDocuments'] = this.isMissingDocuments;
      return data;
    }
  }

  export interface IIncomeSubmissionItemPublicDto {
    id?: string | undefined;
    incomeType?: LookupDto;
    description?: string | undefined;
    amountApplicant?: number | undefined;
    amountSpouse?: number | undefined;
    amountOther?: number | undefined;
    isMissingDocuments?: boolean;
  }

  export class NotificationDto implements INotificationDto {
    id?: string;
    isUnread?: boolean;
    url?: string | undefined;
    messageKey?: string | undefined;
    creationTime?: moment.Moment;
    contentParameters?: { [key: string]: string } | undefined;
    urlParameters?: { [key: string]: string } | undefined;

    constructor(data?: INotificationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.isUnread = _data['isUnread'];
        this.url = _data['url'];
        this.messageKey = _data['messageKey'];
        this.creationTime = _data['creationTime'] ? moment(_data['creationTime'].toString()) : <any>undefined;
        if (_data['contentParameters']) {
          this.contentParameters = {} as any;
          for (let key in _data['contentParameters']) {
            if (_data['contentParameters'].hasOwnProperty(key))
              (<any>this.contentParameters)![key] = _data['contentParameters'][key];
          }
        }
        if (_data['urlParameters']) {
          this.urlParameters = {} as any;
          for (let key in _data['urlParameters']) {
            if (_data['urlParameters'].hasOwnProperty(key))
              (<any>this.urlParameters)![key] = _data['urlParameters'][key];
          }
        }
      }
    }

    static fromJS(data: any): NotificationDto {
      data = typeof data === 'object' ? data : {};
      let result = new NotificationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['isUnread'] = this.isUnread;
      data['url'] = this.url;
      data['messageKey'] = this.messageKey;
      data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
      if (this.contentParameters) {
        data['contentParameters'] = {};
        for (let key in this.contentParameters) {
          if (this.contentParameters.hasOwnProperty(key))
            (<any>data['contentParameters'])[key] = (<any>this.contentParameters)[key];
        }
      }
      if (this.urlParameters) {
        data['urlParameters'] = {};
        for (let key in this.urlParameters) {
          if (this.urlParameters.hasOwnProperty(key))
            (<any>data['urlParameters'])[key] = (<any>this.urlParameters)[key];
        }
      }
      return data;
    }
  }

  export interface INotificationDto {
    id?: string;
    isUnread?: boolean;
    url?: string | undefined;
    messageKey?: string | undefined;
    creationTime?: moment.Moment;
    contentParameters?: { [key: string]: string } | undefined;
    urlParameters?: { [key: string]: string } | undefined;
  }

  export class OfficeLocationDto implements IOfficeLocationDto {
    id?: string;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    officeRegion?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean;
    hours?: string | undefined;
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    timeZoneCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    timeZoneId?: string | undefined;
    officeRegionId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;

    constructor(data?: IOfficeLocationDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.name = _data['name'];
        this.streetNumber = _data['streetNumber'];
        this.streetName = _data['streetName'];
        this.unit = _data['unit'];
        this.city = _data['city'];
        this.postalCode = _data['postalCode'];
        this.province = _data['province'];
        this.country = _data['country'];
        this.officeRegion = _data['officeRegion'];
        this.latitude = _data['latitude'];
        this.longitude = _data['longitude'];
        this.isActive = _data['isActive'];
        this.hours = _data['hours'];
        this.locationCode = _data['locationCode'];
        this.locationPrefix = _data['locationPrefix'];
        this.timeZoneCode = _data['timeZoneCode'];
        this.provinceId = _data['provinceId'];
        this.countryId = _data['countryId'];
        this.timeZoneId = _data['timeZoneId'];
        this.officeRegionId = _data['officeRegionId'];
        this.isServiceLocation = _data['isServiceLocation'];
        this.isTrusteeOffice = _data['isTrusteeOffice'];
      }
    }

    static fromJS(data: any): OfficeLocationDto {
      data = typeof data === 'object' ? data : {};
      let result = new OfficeLocationDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['name'] = this.name;
      data['streetNumber'] = this.streetNumber;
      data['streetName'] = this.streetName;
      data['unit'] = this.unit;
      data['city'] = this.city;
      data['postalCode'] = this.postalCode;
      data['province'] = this.province;
      data['country'] = this.country;
      data['officeRegion'] = this.officeRegion;
      data['latitude'] = this.latitude;
      data['longitude'] = this.longitude;
      data['isActive'] = this.isActive;
      data['hours'] = this.hours;
      data['locationCode'] = this.locationCode;
      data['locationPrefix'] = this.locationPrefix;
      data['timeZoneCode'] = this.timeZoneCode;
      data['provinceId'] = this.provinceId;
      data['countryId'] = this.countryId;
      data['timeZoneId'] = this.timeZoneId;
      data['officeRegionId'] = this.officeRegionId;
      data['isServiceLocation'] = this.isServiceLocation;
      data['isTrusteeOffice'] = this.isTrusteeOffice;
      return data;
    }
  }

  export interface IOfficeLocationDto {
    id?: string;
    name?: string | undefined;
    streetNumber?: string | undefined;
    streetName?: string | undefined;
    unit?: string | undefined;
    city?: string | undefined;
    postalCode?: string | undefined;
    province?: string | undefined;
    country?: string | undefined;
    officeRegion?: string | undefined;
    latitude?: number | undefined;
    longitude?: number | undefined;
    isActive?: boolean;
    hours?: string | undefined;
    locationCode?: string | undefined;
    locationPrefix?: string | undefined;
    timeZoneCode?: string | undefined;
    provinceId?: string | undefined;
    countryId?: string | undefined;
    timeZoneId?: string | undefined;
    officeRegionId?: string | undefined;
    isServiceLocation?: boolean;
    isTrusteeOffice?: boolean;
  }

  export class ReceiptPublicDto implements IReceiptPublicDto {
    id?: string;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    paymentAmount?: number | undefined;

    constructor(data?: IReceiptPublicDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.receiptNumber = _data['receiptNumber'];
        this.paymentDate = _data['paymentDate'] ? moment(_data['paymentDate'].toString()) : <any>undefined;
        this.paymentAmount = _data['paymentAmount'];
      }
    }

    static fromJS(data: any): ReceiptPublicDto {
      data = typeof data === 'object' ? data : {};
      let result = new ReceiptPublicDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['receiptNumber'] = this.receiptNumber;
      data['paymentDate'] = this.paymentDate ? this.paymentDate.toISOString() : <any>undefined;
      data['paymentAmount'] = this.paymentAmount;
      return data;
    }
  }

  export interface IReceiptPublicDto {
    id?: string;
    receiptNumber?: string | undefined;
    paymentDate?: moment.Moment;
    paymentAmount?: number | undefined;
  }

  export class RequestDocumentDownloadCodeResultDto implements IRequestDocumentDownloadCodeResultDto {
    sent?: boolean;
    rateLimited?: boolean;
    cooldownSecondsRemaining?: number;
    expiresAt?: moment.Moment | undefined;

    constructor(data?: IRequestDocumentDownloadCodeResultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.sent = _data['sent'];
        this.rateLimited = _data['rateLimited'];
        this.cooldownSecondsRemaining = _data['cooldownSecondsRemaining'];
        this.expiresAt = _data['expiresAt'] ? moment(_data['expiresAt'].toString()) : <any>undefined;
      }
    }

    static fromJS(data: any): RequestDocumentDownloadCodeResultDto {
      data = typeof data === 'object' ? data : {};
      let result = new RequestDocumentDownloadCodeResultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['sent'] = this.sent;
      data['rateLimited'] = this.rateLimited;
      data['cooldownSecondsRemaining'] = this.cooldownSecondsRemaining;
      data['expiresAt'] = this.expiresAt ? this.expiresAt.toISOString() : <any>undefined;
      return data;
    }
  }

  export interface IRequestDocumentDownloadCodeResultDto {
    sent?: boolean;
    rateLimited?: boolean;
    cooldownSecondsRemaining?: number;
    expiresAt?: moment.Moment | undefined;
  }

  export class VerifyDocumentDownloadCodeInputDto implements IVerifyDocumentDownloadCodeInputDto {
    code!: string;

    constructor(data?: IVerifyDocumentDownloadCodeInputDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'];
      }
    }

    static fromJS(data: any): VerifyDocumentDownloadCodeInputDto {
      data = typeof data === 'object' ? data : {};
      let result = new VerifyDocumentDownloadCodeInputDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code;
      return data;
    }
  }

  export interface IVerifyDocumentDownloadCodeInputDto {
    code: string;
  }

  export class VerifyDocumentDownloadCodeResultDto implements IVerifyDocumentDownloadCodeResultDto {
    success?: boolean;
    token?: string | undefined;
    errorCode?: string | undefined;
    attemptsRemaining?: number;

    constructor(data?: IVerifyDocumentDownloadCodeResultDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.success = _data['success'];
        this.token = _data['token'];
        this.errorCode = _data['errorCode'];
        this.attemptsRemaining = _data['attemptsRemaining'];
      }
    }

    static fromJS(data: any): VerifyDocumentDownloadCodeResultDto {
      data = typeof data === 'object' ? data : {};
      let result = new VerifyDocumentDownloadCodeResultDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['success'] = this.success;
      data['token'] = this.token;
      data['errorCode'] = this.errorCode;
      data['attemptsRemaining'] = this.attemptsRemaining;
      return data;
    }
  }

  export interface IVerifyDocumentDownloadCodeResultDto {
    success?: boolean;
    token?: string | undefined;
    errorCode?: string | undefined;
    attemptsRemaining?: number;
  }

  export class SupportingDocumentApplicabilityOverrideDto implements ISupportingDocumentApplicabilityOverrideDto {
    fileId?: string;
    documentFolderId?: string;
    supportingDocumentApplicabilityOverrideItems?: SupportingDocumentApplicabilityOverrideItemDto[] | undefined;

    constructor(data?: ISupportingDocumentApplicabilityOverrideDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fileId = _data['fileId'];
        this.documentFolderId = _data['documentFolderId'];
        if (Array.isArray(_data['supportingDocumentApplicabilityOverrideItems'])) {
          this.supportingDocumentApplicabilityOverrideItems = [] as any;
          for (let item of _data['supportingDocumentApplicabilityOverrideItems'])
            this.supportingDocumentApplicabilityOverrideItems!.push(
              SupportingDocumentApplicabilityOverrideItemDto.fromJS(item)
            );
        }
      }
    }

    static fromJS(data: any): SupportingDocumentApplicabilityOverrideDto {
      data = typeof data === 'object' ? data : {};
      let result = new SupportingDocumentApplicabilityOverrideDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fileId'] = this.fileId;
      data['documentFolderId'] = this.documentFolderId;
      if (Array.isArray(this.supportingDocumentApplicabilityOverrideItems)) {
        data['supportingDocumentApplicabilityOverrideItems'] = [];
        for (let item of this.supportingDocumentApplicabilityOverrideItems)
          data['supportingDocumentApplicabilityOverrideItems'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface ISupportingDocumentApplicabilityOverrideDto {
    fileId?: string;
    documentFolderId?: string;
    supportingDocumentApplicabilityOverrideItems?: SupportingDocumentApplicabilityOverrideItemDto[] | undefined;
  }

  export class SupportingDocumentApplicabilityOverrideItemDto
    implements ISupportingDocumentApplicabilityOverrideItemDto
  {
    documentPrefixId?: string;
    overrideReason?: string | undefined;
    isDisabled?: boolean | undefined;

    constructor(data?: ISupportingDocumentApplicabilityOverrideItemDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.documentPrefixId = _data['documentPrefixId'];
        this.overrideReason = _data['overrideReason'];
        this.isDisabled = _data['isDisabled'];
      }
    }

    static fromJS(data: any): SupportingDocumentApplicabilityOverrideItemDto {
      data = typeof data === 'object' ? data : {};
      let result = new SupportingDocumentApplicabilityOverrideItemDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['documentPrefixId'] = this.documentPrefixId;
      data['overrideReason'] = this.overrideReason;
      data['isDisabled'] = this.isDisabled;
      return data;
    }
  }

  export interface ISupportingDocumentApplicabilityOverrideItemDto {
    documentPrefixId?: string;
    overrideReason?: string | undefined;
    isDisabled?: boolean | undefined;
  }

  export class SupportingDocumentDocumentUpdateDto implements ISupportingDocumentDocumentUpdateDto {
    supportingDocumentId?: string;
    documentIds?: string[] | undefined;

    constructor(data?: ISupportingDocumentDocumentUpdateDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.supportingDocumentId = _data['supportingDocumentId'];
        if (Array.isArray(_data['documentIds'])) {
          this.documentIds = [] as any;
          for (let item of _data['documentIds']) this.documentIds!.push(item);
        }
      }
    }

    static fromJS(data: any): SupportingDocumentDocumentUpdateDto {
      data = typeof data === 'object' ? data : {};
      let result = new SupportingDocumentDocumentUpdateDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['supportingDocumentId'] = this.supportingDocumentId;
      if (Array.isArray(this.documentIds)) {
        data['documentIds'] = [];
        for (let item of this.documentIds) data['documentIds'].push(item);
      }
      return data;
    }
  }

  export interface ISupportingDocumentDocumentUpdateDto {
    supportingDocumentId?: string;
    documentIds?: string[] | undefined;
  }

  export class SupportingDocumentDto implements ISupportingDocumentDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentSize?: number | undefined;
    documentFormat?: string | undefined;
    documentId?: string;
    uploadDate?: moment.Moment | undefined;
    id?: string;
    supportingDocumentType?: SupportingDocumentType;
    documentPrefixes?: DocumentPrefixDto[] | undefined;
    supportingDocumentStatus?: SupportingDocumentStatusEnum;

    constructor(data?: ISupportingDocumentDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.detail = _data['detail'];
        this.documentName = _data['documentName'];
        this.frenchName = _data['frenchName'];
        this.documentSize = _data['documentSize'];
        this.documentFormat = _data['documentFormat'];
        this.documentId = _data['documentId'];
        this.uploadDate = _data['uploadDate'] ? moment(_data['uploadDate'].toString()) : <any>undefined;
        this.id = _data['id'];
        this.supportingDocumentType = _data['supportingDocumentType']
          ? SupportingDocumentType.fromJS(_data['supportingDocumentType'])
          : <any>undefined;
        if (Array.isArray(_data['documentPrefixes'])) {
          this.documentPrefixes = [] as any;
          for (let item of _data['documentPrefixes']) this.documentPrefixes!.push(DocumentPrefixDto.fromJS(item));
        }
        this.supportingDocumentStatus = _data['supportingDocumentStatus'];
      }
    }

    static fromJS(data: any): SupportingDocumentDto {
      data = typeof data === 'object' ? data : {};
      let result = new SupportingDocumentDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['detail'] = this.detail;
      data['documentName'] = this.documentName;
      data['frenchName'] = this.frenchName;
      data['documentSize'] = this.documentSize;
      data['documentFormat'] = this.documentFormat;
      data['documentId'] = this.documentId;
      data['uploadDate'] = this.uploadDate ? this.uploadDate.toISOString() : <any>undefined;
      data['id'] = this.id;
      data['supportingDocumentType'] = this.supportingDocumentType
        ? this.supportingDocumentType.toJSON()
        : <any>undefined;
      if (Array.isArray(this.documentPrefixes)) {
        data['documentPrefixes'] = [];
        for (let item of this.documentPrefixes) data['documentPrefixes'].push(item.toJSON());
      }
      data['supportingDocumentStatus'] = this.supportingDocumentStatus;
      return data;
    }
  }

  export interface ISupportingDocumentDto {
    detail?: string | undefined;
    documentName?: string | undefined;
    frenchName?: string | undefined;
    documentSize?: number | undefined;
    documentFormat?: string | undefined;
    documentId?: string;
    uploadDate?: moment.Moment | undefined;
    id?: string;
    supportingDocumentType?: SupportingDocumentType;
    documentPrefixes?: DocumentPrefixDto[] | undefined;
    supportingDocumentStatus?: SupportingDocumentStatusEnum;
  }

  export class SupportingDocumentType implements ISupportingDocumentType {
    readonly id?: string;
    orderNumber?: number;
    enumValue?: SupportingDocumentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;

    constructor(data?: ISupportingDocumentType) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        (<any>this).id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.enumValue = _data['enumValue'];
        this.code = _data['code'];
        this.name = _data['name'];
      }
    }

    static fromJS(data: any): SupportingDocumentType {
      data = typeof data === 'object' ? data : {};
      let result = new SupportingDocumentType();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['enumValue'] = this.enumValue;
      data['code'] = this.code;
      data['name'] = this.name;
      return data;
    }
  }

  export interface ISupportingDocumentType {
    id?: string;
    orderNumber?: number;
    enumValue?: SupportingDocumentTypeEnum;
    code?: string | undefined;
    name?: string | undefined;
  }

  export enum FieldIdentifier {
    None = 0,
    FirstName = 1,
    MiddleName = 2,
    LastName = 3,
    DateOfBirth = 4,
    PreferredLanguage = 5,
    EmailAddress = 6,
    PhoneType = 7,
    PhoneNumber = 8,
    AlternatePhoneType = 9,
    AlternatePhoneNumber = 10,
    StreetNumber = 11,
    StreetName = 12,
    Unit = 13,
    City = 14,
    PostalCode = 15,
    Province = 16,
    Country = 17,
    IntakeSource = 18,
    ReferralSource = 19,
    SMSTemplateId = 20,
    SMSDetail = 21,
    SMSTemplateName = 22,
    SMSTemplateBody = 23,
    ConfirmDeleteFromAscend = 24,
    SessionCompletionInfo = 25,
    PaymentAmount = 26,
    ConfirmTransitionSignupInProgress = 27,
  }

  export class LookupDto implements ILookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: number;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AppointmentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfAppointmentStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AppointmentStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDebtOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfAssetDebtOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDebtOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfAssetDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfAssetTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: AssetTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BankruptcyDischargeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(
      data?: ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfBankruptcyDischargeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BankruptcyDischargeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfBusinessOwnershipTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessOwnershipTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfBusinessTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: BusinessTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CityTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfCityTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CityTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CreditorTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfCreditorTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: CreditorTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DebtDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfDebtDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DebtDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DocumentFolderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfDocumentFolderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: DocumentFolderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: EducationLevelEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfEducationLevelEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: EducationLevelEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfExpenseDescriptionEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseDescriptionEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfExpenseTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ExpenseTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: GenderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfGenderEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: GenderEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IncomeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfIncomeTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IncomeTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IndustryEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfIndustryEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: IndustryEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: InsolvencyTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfInsolvencyTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: InsolvencyTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: LTPCodeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfLTPCodeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: LTPCodeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MaritalStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfMaritalStatusEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MaritalStatusEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MeetingTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfMeetingTypeEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: MeetingTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: RESPRRSPEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfRESPRRSPEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: RESPRRSPEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ReasonForPreferredEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfReasonForPreferredEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ReasonForPreferredEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAppliesToEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfResidenceAppliesToEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAppliesToEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAvailableEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(
      data: any
    ): LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfResidenceAvailableEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: ResidenceAvailableEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: TaxTypesEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;

    constructor(data?: ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
      }
    }

    static fromJS(data: any): LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new LookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      return data;
    }
  }

  export interface ILookupDto_1OfOfTaxTypesEnumAndCoreAnd_0AndCulture_neutralAndPublicKeyToken_null {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: TaxTypesEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
  }

  export class LookupReadOnlyDto implements ILookupReadOnlyDto {
    orderNumber?: number;
    enumValue?: number;
    code?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    localizationString?: string | undefined;

    constructor(data?: ILookupReadOnlyDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.orderNumber = _data['orderNumber'];
        this.enumValue = _data['enumValue'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.groupName = _data['groupName'];
        this.localizationString = _data['localizationString'];
      }
    }

    static fromJS(data: any): LookupReadOnlyDto {
      data = typeof data === 'object' ? data : {};
      let result = new LookupReadOnlyDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['orderNumber'] = this.orderNumber;
      data['enumValue'] = this.enumValue;
      data['code'] = this.code;
      data['name'] = this.name;
      data['groupName'] = this.groupName;
      data['localizationString'] = this.localizationString;
      return data;
    }
  }

  export interface ILookupReadOnlyDto {
    orderNumber?: number;
    enumValue?: number;
    code?: string | undefined;
    name?: string | undefined;
    groupName?: string | undefined;
    localizationString?: string | undefined;
  }

  export class PhoneTypeLookupDto implements IPhoneTypeLookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: PhoneTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
    canSMS?: boolean;

    constructor(data?: IPhoneTypeLookupDto) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.id = _data['id'];
        this.orderNumber = _data['orderNumber'];
        this.code = _data['code'];
        this.name = _data['name'];
        this.frenchName = _data['frenchName'];
        this.enumValue = _data['enumValue'];
        this.displayName = _data['displayName'];
        this.description = _data['description'];
        this.localizationString = _data['localizationString'];
        this.descriptionLocalizationString = _data['descriptionLocalizationString'];
        this.canSMS = _data['canSMS'];
      }
    }

    static fromJS(data: any): PhoneTypeLookupDto {
      data = typeof data === 'object' ? data : {};
      let result = new PhoneTypeLookupDto();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['id'] = this.id;
      data['orderNumber'] = this.orderNumber;
      data['code'] = this.code;
      data['name'] = this.name;
      data['frenchName'] = this.frenchName;
      data['enumValue'] = this.enumValue;
      data['displayName'] = this.displayName;
      data['description'] = this.description;
      data['localizationString'] = this.localizationString;
      data['descriptionLocalizationString'] = this.descriptionLocalizationString;
      data['canSMS'] = this.canSMS;
      return data;
    }
  }

  export interface IPhoneTypeLookupDto {
    id?: string;
    orderNumber?: number;
    code?: string | undefined;
    name?: string | undefined;
    frenchName?: string | undefined;
    enumValue?: PhoneTypeEnum;
    displayName?: string | undefined;
    description?: string | undefined;
    localizationString?: string | undefined;
    descriptionLocalizationString?: string | undefined;
    canSMS?: boolean;
  }

  export class Message implements IMessage {
    fieldIdentifier?: FieldIdentifier;
    relatedEntityId?: string | undefined;
    fieldValue?: string | undefined;
    exceptionMessage?: string | undefined;
    body?: string | undefined;
    messageType?: ResultMessageType;

    constructor(data?: IMessage) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.fieldIdentifier = _data['fieldIdentifier'];
        this.relatedEntityId = _data['relatedEntityId'];
        this.fieldValue = _data['fieldValue'];
        this.exceptionMessage = _data['exceptionMessage'];
        this.body = _data['body'];
        this.messageType = _data['messageType'];
      }
    }

    static fromJS(data: any): Message {
      data = typeof data === 'object' ? data : {};
      let result = new Message();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['fieldIdentifier'] = this.fieldIdentifier;
      data['relatedEntityId'] = this.relatedEntityId;
      data['fieldValue'] = this.fieldValue;
      data['exceptionMessage'] = this.exceptionMessage;
      data['body'] = this.body;
      data['messageType'] = this.messageType;
      return data;
    }
  }

  export interface IMessage {
    fieldIdentifier?: FieldIdentifier;
    relatedEntityId?: string | undefined;
    fieldValue?: string | undefined;
    exceptionMessage?: string | undefined;
    body?: string | undefined;
    messageType?: ResultMessageType;
  }

  export enum Result {
    Successful = 0,
    Failed = 3,
  }

  export enum ResultMessageType {
    Success = 0,
    Warning = 1,
    Confirm = 2,
    Error = 3,
    Info = 4,
  }

  export class SaveResult implements ISaveResult {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    readonly hasConfirm?: boolean;
    readonly hasWarnings?: boolean;
    readonly hasErrors?: boolean;
    result?: Result;

    constructor(data?: ISaveResult) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.returnId = _data['returnId'];
        if (Array.isArray(_data['returnIds'])) {
          this.returnIds = [] as any;
          for (let item of _data['returnIds']) this.returnIds!.push(item);
        }
        if (Array.isArray(_data['messages'])) {
          this.messages = [] as any;
          for (let item of _data['messages']) this.messages!.push(Message.fromJS(item));
        }
        (<any>this).hasConfirm = _data['hasConfirm'];
        (<any>this).hasWarnings = _data['hasWarnings'];
        (<any>this).hasErrors = _data['hasErrors'];
        this.result = _data['result'];
      }
    }

    static fromJS(data: any): SaveResult {
      data = typeof data === 'object' ? data : {};
      let result = new SaveResult();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['returnId'] = this.returnId;
      if (Array.isArray(this.returnIds)) {
        data['returnIds'] = [];
        for (let item of this.returnIds) data['returnIds'].push(item);
      }
      if (Array.isArray(this.messages)) {
        data['messages'] = [];
        for (let item of this.messages) data['messages'].push(item.toJSON());
      }
      data['hasConfirm'] = this.hasConfirm;
      data['hasWarnings'] = this.hasWarnings;
      data['hasErrors'] = this.hasErrors;
      data['result'] = this.result;
      return data;
    }
  }

  export interface ISaveResult {
    returnId?: string;
    returnIds?: string[] | undefined;
    messages?: Message[] | undefined;
    hasConfirm?: boolean;
    hasWarnings?: boolean;
    hasErrors?: boolean;
    result?: Result;
  }

  export enum AnswerEnum {
    Yes = 0,
    No = 1,
    PreferNotToAnswer = 2,
  }

  export enum AppFileDescendantType {
    Duplicate = 1,
    New = 2,
  }

  export enum AppFormStatusEnum {
    NotStarted = 0,
    Incomplete = 1,
    Incomplete_Review = 2,
    ReadyForReview = 3,
    Reviewed = 4,
    Complete = 5,
  }

  export enum AppTaskActionNameEnum {
    CallMade_Attempt_1 = 0,
    CallMade_Attempt_2 = 1,
    CallMade_Attempt_3 = 2,
    CallMade_Attempt_4 = 3,
    EmailSent_Attempt_1 = 4,
    EmailSent_Attempt_2 = 5,
    EmailSent_Attempt_3 = 6,
    EmailSent_Attempt_4 = 7,
    DidNotAttend = 8,
    Attended = 9,
    ClaimReceived = 10,
    CallReceived = 11,
    EmailReceived = 12,
    WebformRequest = 13,
    AppointmentScheduled = 14,
    AppointmentRescheduled = 15,
    NoShow = 16,
    Trustee_EngagementAcceptanceAndRiskAssessment = 17,
    Trustee_RiskManagement = 18,
    ReviewSent = 19,
    ReviewAccepted = 20,
    ReviewRejected = 21,
    ApprovalSent = 22,
    ApprovalAccepted = 23,
    ApprovalRejected = 24,
    SignSent = 25,
    SignAccepted = 26,
    SignRejected = 27,
    PendingReview = 28,
    PendingApproval = 29,
    PendingSign = 30,
    SecuredClaim = 31,
    ClaimAlertPendingReview = 32,
    NewIandESubmission = 35,
    IandEMissedSubmission = 36,
    TaxReturnsAddedFromAscend = 37,
    TaxReturnsNOANextProcess = 38,
    NewTaxReturnSubmission = 39,
    PADInfoUpdateRequest = 41,
    ChequePadHoldRequest = 42,
    ChequePADHoldNotification = 43,
    HoldRequestedReminder = 44,
    OnHoldReminder = 45,
    Process170Pending = 46,
    OppositionResponseReceived = 47,
    WithdrawOpposition = 48,
    CourtAppearanceAccepted = 49,
    CourtAppearanceRejected = 50,
    CourtDischargePending = 51,
    PostMediationMonitor = 52,
    MediationFailed = 53,
    ComplianceReview = 54,
    CourtFeesChequeRequest = 55,
    CourtAppearanceRequested = 56,
    TaxReturnAlert = 57,
    InterimDividendScheduled = 58,
    TrusteeDischargePending = 59,
    ProposalAccepted = 60,
    CourtRevivalRequested = 61,
    PaymentArrearWarning = 62,
    MeetingWithCreditorsCompleted = 63,
    IncomeExpenseAlert = 64,
    NewIandEUpload = 65,
    NewTaxReturnUpload = 66,
    MeetingWithCreditorsAccepted = 67,
    ProcessDividendPayment = 68,
    CertificateofFullPerformance = 69,
    DividendChecklistApproved = 71,
    DividendChecklistRejected = 72,
    DividendChecklistSigned = 73,
    DividendChecklistPendngReview = 74,
    SrdChecklistApproved_Proposal = 75,
    SrdChecklistRejected_Proposal = 76,
    SrdChecklistSigned_Proposal = 77,
    SrdChecklistPendingReview_Proposal = 78,
    SrdChecklistApproved_Bankruptcy = 79,
    SrdChecklistRejected_Bankruptcy = 80,
    SrdChecklistSigned_Bankruptcy = 81,
    SrdChecklistPendingReview_Bankruptcy = 82,
    PadInfoUpdateNotification = 83,
    ProposalRevivalRequested = 84,
    ProposalNonRevivalFinalSRD = 85,
    ProposalNonRevivalNotification = 86,
    CourtRevivalCompleted = 87,
    AssetReviewRequired = 88,
    GSTHSTRefundPending = 89,
    DischargeCertificatePending = 90,
    MediationPending = 91,
    OppositionFollowUp = 92,
    OppositionCourtDischargePending = 93,
    RecommendationPending = 94,
    ConditionalSixtyDayWarning = 95,
    ReadyforClosure = 96,
    SurplusPaymentCheck = 97,
    TaxReturnNOAReminder = 98,
    TaxReturnListAdded = 99,
    ApprovalStatusMeetingRequested = 100,
    ProposalPending = 101,
    ReviewRevival = 102,
    PaymentArrearDeemedAnnulled = 103,
    TwentyFiveDayCheckDeemedAnnulled = 104,
    PendingCertificateofFullPerformance = 105,
    ClaimAlert = 106,
    MeetingWithCreditors = 107,
    ApprovalStatusApproved = 108,
    FollowUp = 109,
    PADInfoUpdateNotification = 110,
    CourtDateReview = 111,
    CreditorNoticeNotSent = 112,
    AmendmentRequired = 113,
    UnsecuredClaim = 114,
    AppointmentRequested = 115,
    ClientPortalMessage = 116,
    ClientPortalUpload = 117,
    TaxT1Adjustment = 118,
    TaxInBank = 119,
    TaxNOANORAReview = 120,
    TaxInquiry = 121,
    ChequeRequisition = 122,
    DividendInquiry = 123,
    RequestToRecoverFunds = 124,
    RequestForCourtFee = 125,
    PADSetupInitial = 126,
    PADSetupUpdate = 127,
    BankReconciliationReport = 128,
    InterimDividend = 129,
    UrgentRequest = 130,
    FinalOrdinaryDivisionI = 131,
    FinalSummary = 132,
    FinalProposal = 133,
    FinalSupplemental = 134,
    CourtUndischargedBankruptInquiry = 135,
    CourtDischargeReview = 136,
    CourtLetterRequested = 137,
    CourtDiv1CourtApprovalRequired = 138,
    CourtRevivalRequired = 139,
    CourtTaxationRequired = 140,
    CourtTrusteeDischargeRequired = 141,
    CourtFileStatusUpdate = 142,
    CourtCourtOrder = 143,
    CourtNoOrderDispositionSheet = 144,
    CourtForm81 = 145,
    DischargeReview = 146,
    FollowUpAssetReview = 147,
    Other = -1,
  }

  export enum AppTaskActionStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    Other = -1,
  }

  export enum AppTaskNameEnum {
    NewProspect = 0,
    FollowUpProspect = 1,
    Appointment = 2,
    SignUp = 3,
    FollowUp = 4,
    POC = 5,
    IaEReceived = 6,
    TaxReturnReceived = 7,
    DocumentReview = 8,
    DocumentApproval = 9,
    DocumentSign = 10,
    DocumentVerification = 11,
    SecuredClaim = 12,
    ClaimAlert = 13,
    IandESubmission = 16,
    IandEMissedSubmission = 17,
    TaxReturns = 18,
    TaxReturnSubmission = 19,
    PADInfoUpdateRequest = 21,
    ChequePadHoldRequest = 22,
    ChequePADHoldNotification = 23,
    HoldRequestedReminder = 24,
    OnHoldReminder = 25,
    Process170Pending = 26,
    CourtDischargePending = 27,
    CourtFeesChequeRequest = 28,
    CourtAppearanceRequested = 29,
    TaxReturnAlert = 30,
    InterimDividendScheduled = 31,
    TrusteeDischargePending = 32,
    ProposalUpdate = 33,
    CourtRevivalRequested = 34,
    CreditorNoticeNotSent = 35,
    PaymentArrearWarning = 36,
    IncomeExpenseAlert = 37,
    IandEUpload = 38,
    TaxReturnUpload = 39,
    AppointmentInitialConsultation = 40,
    AppointmentFollowUpConsultation = 41,
    AppointmentCounselling_1st = 42,
    AppointmentCounselling_2nd = 43,
    AppointmentCounselling_3rd = 44,
    AppointmentMeetingWithCreditors = 45,
    ProposalRevivalRequested = 46,
    ProposalNonRevivalFinalSRD = 47,
    ProposalNonRevivalNotification = 48,
    WebformRequest = 49,
    AssetReviewRequired = 50,
    FollowUpClaim = 51,
    FollowUpDischarge = 52,
    FollowUpBanking = 53,
    FollowUpIandE = 54,
    FollowUpTaxReturn = 55,
    FollowUpProposal = 56,
    FollowUpReceiptsDisbursements = 57,
    FollowUpCounselling = 58,
    FollowUpSigned = 59,
    PADInfoUpdateNotification = 60,
    GSTHSTRefundPending = 61,
    ReadyforClosure = 62,
    SurplusPaymentCheck = 63,
    ReviewRevival = 64,
    PaymentArrearDeemedAnnulled = 65,
    TwentyFiveDayCheckDeemedAnnulled = 66,
    ProcessDividendPayment = 67,
    PendingCertificateofFullPerformance = 68,
    MeetingWithCreditors = 70,
    AppointmentFollowUp = 71,
    ClientPortalMessage = 72,
    ClientPortalUpload = 73,
    TaxT1Adjustment = 74,
    TaxInBank = 75,
    TaxNOANORAReview = 76,
    TaxInquiry = 77,
    ChequeRequisition = 78,
    DividendInquiry = 79,
    RequestToRecoverFunds = 80,
    RequestForCourtFee = 81,
    PADSetupInitial = 82,
    PADSetupUpdate = 83,
    BankReconciliationReport = 84,
    InterimDividend = 85,
    UrgentRequest = 86,
    FinalOrdinaryDivisionI = 87,
    FinalSummary = 88,
    FinalProposal = 89,
    FinalSupplemental = 90,
    CourtUndischargedBankruptInquiry = 91,
    CourtDischargeReview = 92,
    CourtLetterRequested = 93,
    CourtDiv1CourtApprovalRequired = 94,
    CourtRevivalRequired = 95,
    CourtTaxationRequired = 96,
    CourtTrusteeDischargeRequired = 97,
    CourtFileStatusUpdate = 98,
    CourtCourtOrder = 99,
    CourtNoOrderDispositionSheet = 100,
    CourtForm81 = 101,
    DischargeReview = 102,
    FollowUpAssetReview = 103,
    Other = -1,
  }

  export enum AppTaskStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    Other = -1,
  }

  export enum AppointmentStatusEnum {
    Pending = 0,
    Completed = 1,
    Cancelled = 2,
    NoShow = 3,
    Unknown = -1,
  }

  export enum AppointmentTypeEnum {
    InitialConsultation = 0,
    FollowUpConsultation = 1,
    Counselling_1st = 2,
    Counselling_2nd = 3,
    Counselling_3rd = 4,
    MeetingWithCreditors = 5,
    Unknown = -1,
  }

  export enum AssetDebtOwnershipTypeEnum {
    Applicant = 0,
    Spouse = 1,
    Joint = 2,
  }

  export enum AssetDescriptionEnum {
    Cash = 0,
    GIC = 1,
    Savings = 2,
    TFSA = 3,
    Other_CashOrSavings = 4,
    HouseholdFurnitureAndEffects = 5,
    Other_Furniture = 6,
    Jewelry = 7,
    PersonalEffects = 8,
    Other_PersonalEffects = 9,
    LifeInsurance = 10,
    RRSP = 11,
    RRIF = 12,
    LIRA = 13,
    RESP = 14,
    Shares = 15,
    Bonds = 16,
    Investments = 17,
    CoopShares = 18,
    CreditUnionShares = 19,
    RDSP = 20,
    Pension = 21,
    Other_InvestmentsOrPolicies = 22,
    House = 23,
    Condo = 24,
    Land = 25,
    Cottage = 26,
    Other_RealEstate = 27,
    Automobile = 28,
    Boat = 31,
    Trailer = 32,
    Camper = 33,
    ATV = 34,
    Other_RecreationalEquipment = 35,
    TaxRefund = 36,
    ToolsOfTrade = 37,
    HuntingTools = 38,
    FishingTools = 39,
    FarmingTools = 40,
    Motorcycle_MotorVehicles = 41,
    Snowmobile_MotorVehicles = 42,
    Other_MotorVehicles = 43,
  }

  export enum AssetTypeEnum {
    CashOrSavings = 0,
    Furniture = 1,
    PersonalEffects = 2,
    InvestmentsOrPolicies = 3,
    RealEstate = 4,
    MotorVehicles = 5,
    RecreationalEquipment = 6,
    TaxRefund = 7,
    Other = 8,
  }

  export enum BankruptcyDischargeTypeEnum {
    AbsoluteAfterConditional = 0,
    AbsoluteAfterSuspended = 1,
    AbsoluteDischarge = 2,
    AdjournedSineDie = 3,
    Annulled = 4,
    Automatic = 5,
    Automatic1stNoSI = 6,
    Automatic1stWithSI = 7,
    Automatic2ndNoSI = 8,
    Automatic2ndWithSI = 9,
    Cancelled = 10,
    Conditional = 11,
    ConditionalAgreedUpon = 12,
    ConditionalCourtOrdered = 13,
    Deceased = 14,
    DischargeSuspended = 15,
    Failed = 16,
    HearingSet = 17,
    MediationConditionsMet = 18,
    MediationRequested = 19,
    NoOrder = 20,
    Opposition = 21,
    Refused = 22,
    TrusteeConditionsMet = 23,
  }

  export enum BusinessOwnershipTypeEnum {
    Cooperative = 0,
    Corporation = 1,
    LimitedLiabilityCompany = 2,
    Partnership = 3,
    SoleProprietorship = 4,
  }

  export enum BusinessTypeEnum {
    AccommodationAndFoodServices = 0,
    AdministrativeAndSupportWasteManagementAndRemediationServices = 1,
    AgricultureForestryFishingAndHunting = 2,
    ArtsEntertainmentAndRecreation = 3,
    Construction = 4,
    EducationalServices = 5,
    FinanceAndInsurance = 6,
    HealthCareAndSocialAssistance = 7,
    InformationAndCulturalIndustries = 8,
    ManagementOfCompaniesAndEnterprises = 9,
    Manufacturing = 10,
    MiningQuarryingAndOilAndGasExtraction = 11,
    OtherServices = 12,
    ProfessionalScientificAndTechnicalServices = 13,
    PublicAdministration = 14,
    RealEstateAndRentalAndLeasing = 15,
    RetailTrade = 16,
    TransportationAndWarehousing = 17,
    Utilities = 18,
    Wholesale = 19,
  }

  export enum CityTypeEnum {
    City = 0,
    Community = 1,
    County = 2,
    District = 3,
    Hamlet = 4,
    Municipalite = 5,
    Municipality = 6,
    RegonalMunicipality = 7,
    Reserve = 8,
    ResortMunicipality = 9,
    State = 10,
    Town = 11,
    Township = 12,
    UnincorporatedArea = 13,
    Village = 14,
    Ville = 15,
  }

  export enum CreditorTypeEnum {
    Secured = 0,
    Unsecured = 1,
    DeemedTrust = 2,
    Deferred = 3,
    Contingent = 4,
    Preferred = 5,
    Property = 6,
  }

  export enum DebtDescriptionEnum {
    AutoLoan = 0,
    CreditCard = 1,
    LineOfCredit = 2,
    Mortgage = 3,
    Overdraft = 4,
    PaydayLoan = 5,
    PersonalLoan = 6,
    StudentLoan = 7,
    Taxes = 8,
    CreditReportCollection = 9,
    CreditReportTrade = 10,
    CreditReportRegisteredItem = 11,
    Other = 12,
  }

  export enum DocumentFolderEnum {
    Assets = 1,
    Claims = 2,
    Correspondence = 3,
    Discharge = 4,
    Lead = 5,
    SurplusIE = 6,
    Banking = 7,
    Taxes = 8,
    ClientUpload = 9,
  }

  export enum DocumentPrefixContextEnum {
    Form56Upload = 1,
    Form93Upload = 2,
    Form95Upload = 4,
    Form96Upload = 8,
    ProposalChecklist = 16,
    ProposalCourtRevival = 32,
  }

  export enum DocumentTypeEnum {
    PDF = 1,
    DOCX = 2,
    DOC = 3,
    XLSX = 4,
    XLS = 5,
    CSV = 6,
    PPT = 7,
    PPTX = 8,
    MSG = 9,
    JPG = 10,
    JPEG = 11,
    BMP = 12,
    PNG = 13,
    GIF = 14,
    HEIC = 15,
    AVIF = 16,
    TIFF = 17,
    WEBP = 18,
    Unknown = -1,
  }

  export enum DocumentVerificationStatusEnum {
    Pending = 0,
    PartiallyCompleted = 1,
    Completed = 2,
    Rejected = 3,
  }

  export enum EducationLevelEnum {
    ZeroToEightYears = 0,
    SomeHighSchool = 1,
    HighSchoolDiploma = 2,
    SomePostSecondary = 3,
    PostSecondaryCertificateOrDiploma = 4,
    UniversityDegree = 5,
    Unknown = 6,
    IPreferNotToAnswer = 7,
  }

  export enum ExpenseDescriptionEnum {
    ChildSupportPayments = 0,
    SpousalSupportPayments = 1,
    ChildCare = 2,
    MedicalOrDentalOrPrescription = 3,
    FinesOrPenaltiesImposedByCourt = 4,
    AsAConditionOfEmployment = 5,
    DebtsWhereStayHasBeenLifted = 6,
    Other_NonDiscretionary = 7,
    RentOrMortgageOrHypothec = 8,
    PropertyTaxesOrCondoFees = 9,
    HeatOrGasOrOil = 10,
    TelephoneOrCellPhone = 11,
    CableOrStreamingServices = 12,
    Electricity = 13,
    Water = 14,
    Furniture = 15,
    Other_Housing = 16,
    FoodOrGrocery = 17,
    LaundryOrDryCleaning = 18,
    GroomingOrToiletries = 19,
    Clothing = 20,
    Other_Living = 21,
    CarLeaseOrFinancePayments = 22,
    RepairOrMaintenanceOrGas = 23,
    PublicTransportation = 24,
    Other_Transportation = 25,
    TobaccoOrVapingOrCannabis = 26,
    Alcohol = 27,
    MealsOrRestaurants = 28,
    EntertainmentOrSports = 29,
    GiftsOrCharitableDonations = 30,
    Allowances = 31,
    Other_Personal = 32,
    Vehicle = 33,
    Home = 34,
    FurnitureOrContents = 35,
    LifeInsurance = 36,
    Other_Insurance = 37,
    ProposalPayments = 38,
    BankruptcyPayments = 39,
    ToSecuredCreditors = 40,
    Other_Payments = 41,
    Prescriptions = 42,
    Dental = 43,
    Other_Medical = 44,
    ToProviderOfFinancialAdvice = 45,
    ToTheEstate = 46,
    Internet = 47,
    VehicleInsurnceOrRegistration = 48,
  }

  export enum ExpenseTypeEnum {
    NonDiscretionary = 0,
    Housing = 1,
    Living = 2,
    Transportation = 3,
    Personal = 4,
    Insurance = 5,
    Payments = 6,
    Medical = 7,
  }

  export enum FileProcessEnum {
    Prospect = 0,
    SignUp = 1,
    Counselling = 2,
    Claims = 3,
    Asset = 4,
    Preferences = 5,
    IandE = 6,
    TaxReturn = 7,
    Banking = 8,
    DebtorDischarge = 9,
    TrusteeDischarge = 10,
    Day45Review = 11,
    MeetingWithCreditors = 12,
    DocumentVerification = 13,
    WebformRequest = 14,
    Closed = 15,
    Court = 16,
    Unknown = -1,
  }

  export enum FileProcessStatusEnum {
    Complete = 1,
    Incomplete = 2,
    InProgress = 3,
    Pending = 4,
    Exception = 5,
  }

  export enum FileStageEnum {
    NewProspect = 0,
    PreSignup = 1,
    Signed = 2,
    FileInProcess = 3,
    Closed = 4,
    Annulled = 5,
    Transferred = 6,
    StatusChanged = 7,
  }

  export enum FilingTypeEnum {
    Ordinary = 0,
    Summary = 1,
    DivisionI = 2,
    DivisionII = 3,
  }

  export enum GenderEnum {
    Male = 0,
    Female = 1,
    Other = 2,
    PreferNotToAnswer = 3,
  }

  export enum IncomeExpensePeriodStatusEnum {
    Pending = 0,
    Received = 1,
    Completed = 2,
    MissingInformation = 3,
    DiscrepancyNotice = 4,
    AmendmentRequired = 5,
  }

  export enum IncomeTypeEnum {
    EmploymentIncome = 0,
    PensionOrAnnuities = 1,
    ChildSupport = 2,
    SpousalSupport = 3,
    EmploymentInsuranceBenefits = 4,
    SocialAssistance = 5,
    SelfEmploymentIncome = 6,
    ChildTaxBenefit = 7,
    Other = 8,
    RentalIncome = 9,
    GovernmentBenefits = 10,
    OtherBenefits = 11,
  }

  export enum IndustryEnum {
    Healthcare = 0,
    Education = 1,
    InformationTechnology = 2,
    Engineering = 3,
    Finance = 4,
    SalesAndMarketing = 5,
    Legal = 6,
    ArtsAndMedia = 7,
    Hospitality = 8,
    ConstructionAndTrades = 9,
    Transportation = 10,
    Manufacturing = 11,
    Retail = 12,
    Government = 13,
    ScienceAndResearch = 14,
    SocialServices = 15,
    Agriculture = 16,
    RealEstate = 17,
    HumanResources = 18,
    CustomerService = 19,
    Security = 20,
    SportsAndRecreation = 21,
    SelfEmployed = 22,
    Student = 23,
    Other = 24,
  }

  export enum InsolvencyTypeEnum {
    Bankruptcy = 0,
    Proposal = 1,
  }

  export enum LTPCodeEnum {
    Other = 0,
    BankLoansExceptRealPropertyMortgage = 1,
    CreditCardsBankOrTrustCompany = 2,
    CreditCardsOther = 3,
    FinanceCompanyLoans = 4,
    LoansFromIndividuals = 5,
    RealPropertyMortgage = 6,
    StudenLoans = 7,
    GovernmentTaxes = 8,
    CreditCardsStores = 9,
    TaxesFederal = 10,
    PaydayLoans = 11,
    Utilities = 12,
    FuturePaymentsOtherFinancialAdvisors = 13,
  }

  export enum LanguageEnum {
    English = 1,
    French = 2,
    BiLingual = 3,
  }

  export enum MaritalStatusEnum {
    Married = 0,
    Single = 1,
    Divorced = 2,
    CommonLaw = 3,
    Widowed = 4,
    Separated = 5,
  }

  export enum MeetingTypeEnum {
    InPerson = 0,
    Phone = 1,
    Unknown = -1,
  }

  export enum PADSchedulePaymentStatusEnum {
    NotDeposited = 0,
    Deposited = 1,
    Pending = 2,
  }

  export enum PADScheduleStateEnum {
    Active = 0,
    HoldRequested = 1,
    OnHold = 2,
    RequestRejected = 3,
    Canceled = 4,
  }

  export enum PhoneTypeEnum {
    Mobile = 0,
    Home = 1,
    Work = 2,
    Fax = 3,
  }

  export enum PreSignupProgressEnum {
    NotStarted = 0,
    InitialConsultation = 1,
    GatherDocuments = 2,
    SignUp = 3,
    FileInProgress = 4,
  }

  export enum RESPRRSPEnum {
    Exempt = 0,
  }

  export enum ReasonForPreferredEnum {
    A = 0,
    B = 1,
    C = 2,
    D = 3,
    D1 = 4,
    E = 5,
    F = 6,
    G = 7,
    H = 8,
    I = 9,
    J = 10,
  }

  export enum ResidenceAppliesToEnum {
    Household = 0,
    Individual = 1,
  }

  export enum ResidenceAvailableEnum {
    Always = 0,
    Limited = 1,
  }

  export enum SupportingDocumentStatusEnum {
    Pending = 0,
    Uploaded = 1,
    Reviewed = 2,
  }

  export enum SupportingDocumentTypeEnum {
    ID = 0,
    ID_Spouse = 1,
    Asset = 2,
    Income = 3,
    Expense = 4,
    IncomeTax = 5,
    IncomeTax_Spouse = 6,
    BankingInfo = 7,
    Business = 8,
    NilIncomeBankStatement = 9,
  }

  export enum TaxTypesEnum {
    GST = 0,
    HST = 1,
    GSTQST = 2,
  }

  export enum TeamTypeEnum {
    POC_CPC = 0,
    Asset_CPC = 1,
    IandE_CPC = 2,
    Tax_CPC = 3,
    Banking_CPC = 4,
    Court_CPC = 5,
    Report_170_CPC = 6,
    Proposal_CPC = 7,
    SRD_CPC = 8,
    Trustee = 9,
    FLA = 10,
    Agent = 11,
    Counselling_POD = 12,
  }

  export class PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    items?: AppointmentInfoDto[] | undefined;
    totalCount?: number;

    constructor(
      data?: IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items']) this.items!.push(AppointmentInfoDto.fromJS(item));
        }
        this.totalCount = _data['totalCount'];
      }
    }

    static fromJS(
      data: any
    ): PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result =
        new PagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalCount'] = this.totalCount;
      return data;
    }
  }

  export interface IPagedResultDto_1OfOfAppointmentInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: AppointmentInfoDto[] | undefined;
    totalCount?: number;
  }

  export class PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    items?: DocumentDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items']) this.items!.push(DocumentDto.fromJS(item));
        }
        this.totalCount = _data['totalCount'];
      }
    }

    static fromJS(data: any): PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new PagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalCount'] = this.totalCount;
      return data;
    }
  }

  export interface IPagedResultDto_1OfOfDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: DocumentDto[] | undefined;
    totalCount?: number;
  }

  export class PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    items?: NotificationDto[] | undefined;
    totalCount?: number;

    constructor(data?: IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items']) this.items!.push(NotificationDto.fromJS(item));
        }
        this.totalCount = _data['totalCount'];
      }
    }

    static fromJS(
      data: any
    ): PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new PagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalCount'] = this.totalCount;
      return data;
    }
  }

  export interface IPagedResultDto_1OfOfNotificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: NotificationDto[] | undefined;
    totalCount?: number;
  }

  export class PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    items?: OfficeLocationDto[] | undefined;
    totalCount?: number;

    constructor(
      data?: IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items']) this.items!.push(OfficeLocationDto.fromJS(item));
        }
        this.totalCount = _data['totalCount'];
      }
    }

    static fromJS(
      data: any
    ): PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result = new PagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalCount'] = this.totalCount;
      return data;
    }
  }

  export interface IPagedResultDto_1OfOfOfficeLocationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: OfficeLocationDto[] | undefined;
    totalCount?: number;
  }

  export class PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    implements IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  {
    items?: SupportingDocumentDto[] | undefined;
    totalCount?: number;

    constructor(
      data?: IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
    ) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        if (Array.isArray(_data['items'])) {
          this.items = [] as any;
          for (let item of _data['items']) this.items!.push(SupportingDocumentDto.fromJS(item));
        }
        this.totalCount = _data['totalCount'];
      }
    }

    static fromJS(
      data: any
    ): PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
      data = typeof data === 'object' ? data : {};
      let result =
        new PagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      if (Array.isArray(this.items)) {
        data['items'] = [];
        for (let item of this.items) data['items'].push(item.toJSON());
      }
      data['totalCount'] = this.totalCount;
      return data;
    }
  }

  export interface IPagedResultDto_1OfOfSupportingDocumentDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    items?: SupportingDocumentDto[] | undefined;
    totalCount?: number;
  }

  export class RemoteServiceErrorInfo implements IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;

    constructor(data?: IRemoteServiceErrorInfo) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.code = _data['code'];
        this.message = _data['message'];
        this.details = _data['details'];
        if (_data['data']) {
          this.data = {} as any;
          for (let key in _data['data']) {
            if (_data['data'].hasOwnProperty(key)) (<any>this.data)![key] = _data['data'][key];
          }
        }
        if (Array.isArray(_data['validationErrors'])) {
          this.validationErrors = [] as any;
          for (let item of _data['validationErrors'])
            this.validationErrors!.push(RemoteServiceValidationErrorInfo.fromJS(item));
        }
      }
    }

    static fromJS(data: any): RemoteServiceErrorInfo {
      data = typeof data === 'object' ? data : {};
      let result = new RemoteServiceErrorInfo();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['code'] = this.code;
      data['message'] = this.message;
      data['details'] = this.details;
      if (this.data) {
        data['data'] = {};
        for (let key in this.data) {
          if (this.data.hasOwnProperty(key)) (<any>data['data'])[key] = (<any>this.data)[key];
        }
      }
      if (Array.isArray(this.validationErrors)) {
        data['validationErrors'] = [];
        for (let item of this.validationErrors) data['validationErrors'].push(item.toJSON());
      }
      return data;
    }
  }

  export interface IRemoteServiceErrorInfo {
    code?: string | undefined;
    message?: string | undefined;
    details?: string | undefined;
    data?: { [key: string]: any } | undefined;
    validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;
  }

  export class RemoteServiceErrorResponse implements IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;

    constructor(data?: IRemoteServiceErrorResponse) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.error = _data['error'] ? RemoteServiceErrorInfo.fromJS(_data['error']) : <any>undefined;
      }
    }

    static fromJS(data: any): RemoteServiceErrorResponse {
      data = typeof data === 'object' ? data : {};
      let result = new RemoteServiceErrorResponse();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['error'] = this.error ? this.error.toJSON() : <any>undefined;
      return data;
    }
  }

  export interface IRemoteServiceErrorResponse {
    error?: RemoteServiceErrorInfo;
  }

  export class RemoteServiceValidationErrorInfo implements IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: string[] | undefined;

    constructor(data?: IRemoteServiceValidationErrorInfo) {
      if (data) {
        for (var property in data) {
          if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
        }
      }
    }

    init(_data?: any) {
      if (_data) {
        this.message = _data['message'];
        if (Array.isArray(_data['members'])) {
          this.members = [] as any;
          for (let item of _data['members']) this.members!.push(item);
        }
      }
    }

    static fromJS(data: any): RemoteServiceValidationErrorInfo {
      data = typeof data === 'object' ? data : {};
      let result = new RemoteServiceValidationErrorInfo();
      result.init(data);
      return result;
    }

    toJSON(data?: any) {
      data = typeof data === 'object' ? data : {};
      data['message'] = this.message;
      if (Array.isArray(this.members)) {
        data['members'] = [];
        for (let item of this.members) data['members'].push(item);
      }
      return data;
    }
  }

  export interface IRemoteServiceValidationErrorInfo {
    message?: string | undefined;
    members?: string[] | undefined;
  }

  export interface FileParameter {
    data: any;
    fileName: string;
  }

  export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
  }

  export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
      super();

      this.message = message;
      this.status = status;
      this.response = response;
      this.headers = headers;
      this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
      return obj.isApiException === true;
    }
  }

  function throwException(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result?: any
  ): any {
    if (result !== null && result !== undefined) throw result;
    else throw new ApiException(message, status, response, headers, null);
  }

  /**
   * Base api service, works for inject local value (works for multiple languages support)
   * and oauth single sign on access token into the http request header.
   * Note: This is not auto generated code.
   */
}
